import { default as aapanelMFsO877KIYMeta } from "/builds/racent/frontend/website_nicsrs/pages/aapanel.vue?macro=true";
import { default as about_45usYYpDOqhwwJMeta } from "/builds/racent/frontend/website_nicsrs/pages/about-us.vue?macro=true";
import { default as affiliate_45program0facdMezZGMeta } from "/builds/racent/frontend/website_nicsrs/pages/affiliate-program.vue?macro=true";
import { default as _91url_alias_93h3Ll5SROPWMeta } from "/builds/racent/frontend/website_nicsrs/pages/blog/[url_alias].vue?macro=true";
import { default as _91category_932JuRr6kCdjMeta } from "/builds/racent/frontend/website_nicsrs/pages/blog/category/[category].vue?macro=true";
import { default as index5rXufKkEHvMeta } from "/builds/racent/frontend/website_nicsrs/pages/blog/index.vue?macro=true";
import { default as _91tag_93DoW6eQFVfJMeta } from "/builds/racent/frontend/website_nicsrs/pages/blog/tag/[tag].vue?macro=true";
import { default as _91viewType_93oz2fuYjcgiMeta } from "/builds/racent/frontend/website_nicsrs/pages/brand/[viewType].vue?macro=true";
import { default as configskqSb53A6DMeta } from "/builds/racent/frontend/website_nicsrs/pages/brand/config.ts?macro=true";
import { default as caas0bC3gX1cWxMeta } from "/builds/racent/frontend/website_nicsrs/pages/caas.vue?macro=true";
import { default as ccTLDstlStVuDVTBMeta } from "/builds/racent/frontend/website_nicsrs/pages/ccTLDs.vue?macro=true";
import { default as cert_45file5Gnj0Hcv2IMeta } from "/builds/racent/frontend/website_nicsrs/pages/cert-file.vue?macro=true";
import { default as check_45ct_45logJZne3aLxGhMeta } from "/builds/racent/frontend/website_nicsrs/pages/check-ct-log.vue?macro=true";
import { default as domaingEdVW4SaQIMeta } from "/builds/racent/frontend/website_nicsrs/pages/check/domain.vue?macro=true";
import { default as clm_45sslpDWFpMZDgVMeta } from "/builds/racent/frontend/website_nicsrs/pages/clm-ssl.vue?macro=true";
import { default as clmQYxAWciJjWMeta } from "/builds/racent/frontend/website_nicsrs/pages/clm.vue?macro=true";
import { default as cloud_45code_45signingXnBZAsXZoOMeta } from "/builds/racent/frontend/website_nicsrs/pages/cloud-code-signing.vue?macro=true";
import { default as cloud_45mpkiYe6EurE5MgMeta } from "/builds/racent/frontend/website_nicsrs/pages/cloud-mpki.vue?macro=true";
import { default as code_45signing_45certificateE0rqJiDF66Meta } from "/builds/racent/frontend/website_nicsrs/pages/code-signing-certificate.vue?macro=true";
import { default as contactE9OT4OE3cGMeta } from "/builds/racent/frontend/website_nicsrs/pages/contact.vue?macro=true";
import { default as cpanel17mmSRhj04Meta } from "/builds/racent/frontend/website_nicsrs/pages/cpanel.vue?macro=true";
import { default as csr_45decoderuQU5laFg5hMeta } from "/builds/racent/frontend/website_nicsrs/pages/csr-decoder.vue?macro=true";
import { default as dns_45lookup0hGVZAd7y3Meta } from "/builds/racent/frontend/website_nicsrs/pages/dns-lookup.vue?macro=true";
import { default as dnsQbL7cNA0y0Meta } from "/builds/racent/frontend/website_nicsrs/pages/dns.vue?macro=true";
import { default as document_45signing_45certificatejWOBxwO5fSMeta } from "/builds/racent/frontend/website_nicsrs/pages/document-signing-certificate.vue?macro=true";
import { default as domain_45transfer1czu6y2FH3Meta } from "/builds/racent/frontend/website_nicsrs/pages/domain-transfer.vue?macro=true";
import { default as DomainCardiXdiIEvHUgMeta } from "/builds/racent/frontend/website_nicsrs/pages/domain/DomainCard.vue?macro=true";
import { default as _91code_93yRrkFFxFnXMeta } from "/builds/racent/frontend/website_nicsrs/pages/domain/[code].vue?macro=true";
import { default as indexs1JptdUy19Meta } from "/builds/racent/frontend/website_nicsrs/pages/domain/index.vue?macro=true";
import { default as download_45cert_45chainMdvgkCrsopMeta } from "/builds/racent/frontend/website_nicsrs/pages/download-cert-chain.vue?macro=true";
import { default as ecosystemLxfszMIKkQMeta } from "/builds/racent/frontend/website_nicsrs/pages/ecosystem.vue?macro=true";
import { default as email_45signing_45certificateYUTTR0tFr5Meta } from "/builds/racent/frontend/website_nicsrs/pages/email-signing-certificate.vue?macro=true";
import { default as emailNm3dg7jxqiMeta } from "/builds/racent/frontend/website_nicsrs/pages/email.vue?macro=true";
import { default as generate_45csrozaAjAzDhzMeta } from "/builds/racent/frontend/website_nicsrs/pages/generate-csr.vue?macro=true";
import { default as help_45centerDJyrZOPD8mMeta } from "/builds/racent/frontend/website_nicsrs/pages/help-center.vue?macro=true";
import { default as _91id_93wt7dSLxfvBMeta } from "/builds/racent/frontend/website_nicsrs/pages/help-detail/[id].vue?macro=true";
import { default as _91pname_938Kjdn9n9J0Meta } from "/builds/racent/frontend/website_nicsrs/pages/help-list/[pname].vue?macro=true";
import { default as _91key_938HAeI1aJXtMeta } from "/builds/racent/frontend/website_nicsrs/pages/help-search/[key].vue?macro=true";
import { default as _91name_93YrLVpQEu5mMeta } from "/builds/racent/frontend/website_nicsrs/pages/hosting/cms/[name].vue?macro=true";
import { default as _91name_93MqhNGWM3TcMeta } from "/builds/racent/frontend/website_nicsrs/pages/hosting/location/[name].vue?macro=true";
import { default as _91name_93PWzjNwXTHlMeta } from "/builds/racent/frontend/website_nicsrs/pages/hosting/type/[name].vue?macro=true";
import { default as resellerIvf8frJ4aKMeta } from "/builds/racent/frontend/website_nicsrs/pages/hosting/type/reseller.vue?macro=true";
import { default as indexZJfwXI1CuzMeta } from "/builds/racent/frontend/website_nicsrs/pages/index.vue?macro=true";
import { default as ispmanagerp3OKnXNQzfMeta } from "/builds/racent/frontend/website_nicsrs/pages/ispmanager.vue?macro=true";
import { default as log_45detailsY6qzWGxIv5Meta } from "/builds/racent/frontend/website_nicsrs/pages/log-details.vue?macro=true";
import { default as pleskfQTWJseJlVMeta } from "/builds/racent/frontend/website_nicsrs/pages/plesk.vue?macro=true";
import { default as policy_45agreement8p79u5bhNnMeta } from "/builds/racent/frontend/website_nicsrs/pages/policy-agreement.vue?macro=true";
import { default as privacyj8BSIcQ3aBMeta } from "/builds/racent/frontend/website_nicsrs/pages/privacy.vue?macro=true";
import { default as _91code_93POYWEFxG8rMeta } from "/builds/racent/frontend/website_nicsrs/pages/product/[code].vue?macro=true";
import { default as resellersRIYZhtSRqMeta } from "/builds/racent/frontend/website_nicsrs/pages/reseller.vue?macro=true";
import { default as sitelockUseNRdjOj7Meta } from "/builds/racent/frontend/website_nicsrs/pages/sitelock.vue?macro=true";
import { default as compliance0iSTfh82KuMeta } from "/builds/racent/frontend/website_nicsrs/pages/solution/compliance.vue?macro=true";
import { default as foreign_45trade_45ecommercejHzX2244VLMeta } from "/builds/racent/frontend/website_nicsrs/pages/solution/foreign-trade-ecommerce.vue?macro=true";
import { default as hostingy0JfMpgGHrMeta } from "/builds/racent/frontend/website_nicsrs/pages/solution/hosting.vue?macro=true";
import { default as pkiWRnAT3uirUMeta } from "/builds/racent/frontend/website_nicsrs/pages/solution/pki.vue?macro=true";
import { default as secured_45emailHrfqhwG6PFMeta } from "/builds/racent/frontend/website_nicsrs/pages/solution/secured-email.vue?macro=true";
import { default as ucmjqNOF4PpkGMeta } from "/builds/racent/frontend/website_nicsrs/pages/solution/ucm.vue?macro=true";
import { default as ssl_45checkerxkOEuBYTL5Meta } from "/builds/racent/frontend/website_nicsrs/pages/ssl-checker.vue?macro=true";
import { default as ssl_45converterupq6O3q4dRMeta } from "/builds/racent/frontend/website_nicsrs/pages/ssl-converter.vue?macro=true";
import { default as ssl_45monitoringeyYR4VHxENMeta } from "/builds/racent/frontend/website_nicsrs/pages/ssl-monitoring.vue?macro=true";
import { default as _91viewType_93kQjKfmSOWfMeta } from "/builds/racent/frontend/website_nicsrs/pages/ssl/[viewType].vue?macro=true";
import { default as indexYBv5K0UvrUMeta } from "/builds/racent/frontend/website_nicsrs/pages/ssl/index.vue?macro=true";
import { default as indexD04gcbwWxZMeta } from "/builds/racent/frontend/website_nicsrs/pages/tools/index.vue?macro=true";
import { default as verified_45mark_45certificate5vxDYAamR1Meta } from "/builds/racent/frontend/website_nicsrs/pages/verified-mark-certificate.vue?macro=true";
import { default as whmcsf8FmDsZ0CKMeta } from "/builds/racent/frontend/website_nicsrs/pages/whmcs.vue?macro=true";
import { default as whois_45lookupZ4YcDKnLqnMeta } from "/builds/racent/frontend/website_nicsrs/pages/whois-lookup.vue?macro=true";
import { default as whql9qhG2AF5FsMeta } from "/builds/racent/frontend/website_nicsrs/pages/whql.vue?macro=true";
import { default as why_45nicsrsu5r75lVeIbMeta } from "/builds/racent/frontend/website_nicsrs/pages/why-nicsrs.vue?macro=true";
export default [
  {
    name: aapanelMFsO877KIYMeta?.name ?? "aapanel___en",
    path: aapanelMFsO877KIYMeta?.path ?? "/aapanel",
    meta: aapanelMFsO877KIYMeta || {},
    alias: aapanelMFsO877KIYMeta?.alias || [],
    redirect: aapanelMFsO877KIYMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/aapanel.vue").then(m => m.default || m)
  },
  {
    name: aapanelMFsO877KIYMeta?.name ?? "aapanel___zh-cn",
    path: aapanelMFsO877KIYMeta?.path ?? "/zh-cn/aapanel",
    meta: aapanelMFsO877KIYMeta || {},
    alias: aapanelMFsO877KIYMeta?.alias || [],
    redirect: aapanelMFsO877KIYMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/aapanel.vue").then(m => m.default || m)
  },
  {
    name: aapanelMFsO877KIYMeta?.name ?? "aapanel___zh-tw",
    path: aapanelMFsO877KIYMeta?.path ?? "/zh-tw/aapanel",
    meta: aapanelMFsO877KIYMeta || {},
    alias: aapanelMFsO877KIYMeta?.alias || [],
    redirect: aapanelMFsO877KIYMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/aapanel.vue").then(m => m.default || m)
  },
  {
    name: aapanelMFsO877KIYMeta?.name ?? "aapanel___jp",
    path: aapanelMFsO877KIYMeta?.path ?? "/jp/aapanel",
    meta: aapanelMFsO877KIYMeta || {},
    alias: aapanelMFsO877KIYMeta?.alias || [],
    redirect: aapanelMFsO877KIYMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/aapanel.vue").then(m => m.default || m)
  },
  {
    name: aapanelMFsO877KIYMeta?.name ?? "aapanel___es",
    path: aapanelMFsO877KIYMeta?.path ?? "/es/aapanel",
    meta: aapanelMFsO877KIYMeta || {},
    alias: aapanelMFsO877KIYMeta?.alias || [],
    redirect: aapanelMFsO877KIYMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/aapanel.vue").then(m => m.default || m)
  },
  {
    name: aapanelMFsO877KIYMeta?.name ?? "aapanel___fr",
    path: aapanelMFsO877KIYMeta?.path ?? "/fr/aapanel",
    meta: aapanelMFsO877KIYMeta || {},
    alias: aapanelMFsO877KIYMeta?.alias || [],
    redirect: aapanelMFsO877KIYMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/aapanel.vue").then(m => m.default || m)
  },
  {
    name: aapanelMFsO877KIYMeta?.name ?? "aapanel___de",
    path: aapanelMFsO877KIYMeta?.path ?? "/de/aapanel",
    meta: aapanelMFsO877KIYMeta || {},
    alias: aapanelMFsO877KIYMeta?.alias || [],
    redirect: aapanelMFsO877KIYMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/aapanel.vue").then(m => m.default || m)
  },
  {
    name: aapanelMFsO877KIYMeta?.name ?? "aapanel___kr",
    path: aapanelMFsO877KIYMeta?.path ?? "/kr/aapanel",
    meta: aapanelMFsO877KIYMeta || {},
    alias: aapanelMFsO877KIYMeta?.alias || [],
    redirect: aapanelMFsO877KIYMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/aapanel.vue").then(m => m.default || m)
  },
  {
    name: aapanelMFsO877KIYMeta?.name ?? "aapanel___vn",
    path: aapanelMFsO877KIYMeta?.path ?? "/vn/aapanel",
    meta: aapanelMFsO877KIYMeta || {},
    alias: aapanelMFsO877KIYMeta?.alias || [],
    redirect: aapanelMFsO877KIYMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/aapanel.vue").then(m => m.default || m)
  },
  {
    name: aapanelMFsO877KIYMeta?.name ?? "aapanel___th",
    path: aapanelMFsO877KIYMeta?.path ?? "/th/aapanel",
    meta: aapanelMFsO877KIYMeta || {},
    alias: aapanelMFsO877KIYMeta?.alias || [],
    redirect: aapanelMFsO877KIYMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/aapanel.vue").then(m => m.default || m)
  },
  {
    name: aapanelMFsO877KIYMeta?.name ?? "aapanel___ru",
    path: aapanelMFsO877KIYMeta?.path ?? "/ru/aapanel",
    meta: aapanelMFsO877KIYMeta || {},
    alias: aapanelMFsO877KIYMeta?.alias || [],
    redirect: aapanelMFsO877KIYMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/aapanel.vue").then(m => m.default || m)
  },
  {
    name: aapanelMFsO877KIYMeta?.name ?? "aapanel___tr",
    path: aapanelMFsO877KIYMeta?.path ?? "/tr/aapanel",
    meta: aapanelMFsO877KIYMeta || {},
    alias: aapanelMFsO877KIYMeta?.alias || [],
    redirect: aapanelMFsO877KIYMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/aapanel.vue").then(m => m.default || m)
  },
  {
    name: about_45usYYpDOqhwwJMeta?.name ?? "about-us___en",
    path: about_45usYYpDOqhwwJMeta?.path ?? "/about-us",
    meta: about_45usYYpDOqhwwJMeta || {},
    alias: about_45usYYpDOqhwwJMeta?.alias || [],
    redirect: about_45usYYpDOqhwwJMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/about-us.vue").then(m => m.default || m)
  },
  {
    name: about_45usYYpDOqhwwJMeta?.name ?? "about-us___zh-cn",
    path: about_45usYYpDOqhwwJMeta?.path ?? "/zh-cn/about-us",
    meta: about_45usYYpDOqhwwJMeta || {},
    alias: about_45usYYpDOqhwwJMeta?.alias || [],
    redirect: about_45usYYpDOqhwwJMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/about-us.vue").then(m => m.default || m)
  },
  {
    name: about_45usYYpDOqhwwJMeta?.name ?? "about-us___zh-tw",
    path: about_45usYYpDOqhwwJMeta?.path ?? "/zh-tw/about-us",
    meta: about_45usYYpDOqhwwJMeta || {},
    alias: about_45usYYpDOqhwwJMeta?.alias || [],
    redirect: about_45usYYpDOqhwwJMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/about-us.vue").then(m => m.default || m)
  },
  {
    name: about_45usYYpDOqhwwJMeta?.name ?? "about-us___jp",
    path: about_45usYYpDOqhwwJMeta?.path ?? "/jp/about-us",
    meta: about_45usYYpDOqhwwJMeta || {},
    alias: about_45usYYpDOqhwwJMeta?.alias || [],
    redirect: about_45usYYpDOqhwwJMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/about-us.vue").then(m => m.default || m)
  },
  {
    name: about_45usYYpDOqhwwJMeta?.name ?? "about-us___es",
    path: about_45usYYpDOqhwwJMeta?.path ?? "/es/about-us",
    meta: about_45usYYpDOqhwwJMeta || {},
    alias: about_45usYYpDOqhwwJMeta?.alias || [],
    redirect: about_45usYYpDOqhwwJMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/about-us.vue").then(m => m.default || m)
  },
  {
    name: about_45usYYpDOqhwwJMeta?.name ?? "about-us___fr",
    path: about_45usYYpDOqhwwJMeta?.path ?? "/fr/about-us",
    meta: about_45usYYpDOqhwwJMeta || {},
    alias: about_45usYYpDOqhwwJMeta?.alias || [],
    redirect: about_45usYYpDOqhwwJMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/about-us.vue").then(m => m.default || m)
  },
  {
    name: about_45usYYpDOqhwwJMeta?.name ?? "about-us___de",
    path: about_45usYYpDOqhwwJMeta?.path ?? "/de/about-us",
    meta: about_45usYYpDOqhwwJMeta || {},
    alias: about_45usYYpDOqhwwJMeta?.alias || [],
    redirect: about_45usYYpDOqhwwJMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/about-us.vue").then(m => m.default || m)
  },
  {
    name: about_45usYYpDOqhwwJMeta?.name ?? "about-us___kr",
    path: about_45usYYpDOqhwwJMeta?.path ?? "/kr/about-us",
    meta: about_45usYYpDOqhwwJMeta || {},
    alias: about_45usYYpDOqhwwJMeta?.alias || [],
    redirect: about_45usYYpDOqhwwJMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/about-us.vue").then(m => m.default || m)
  },
  {
    name: about_45usYYpDOqhwwJMeta?.name ?? "about-us___vn",
    path: about_45usYYpDOqhwwJMeta?.path ?? "/vn/about-us",
    meta: about_45usYYpDOqhwwJMeta || {},
    alias: about_45usYYpDOqhwwJMeta?.alias || [],
    redirect: about_45usYYpDOqhwwJMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/about-us.vue").then(m => m.default || m)
  },
  {
    name: about_45usYYpDOqhwwJMeta?.name ?? "about-us___th",
    path: about_45usYYpDOqhwwJMeta?.path ?? "/th/about-us",
    meta: about_45usYYpDOqhwwJMeta || {},
    alias: about_45usYYpDOqhwwJMeta?.alias || [],
    redirect: about_45usYYpDOqhwwJMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/about-us.vue").then(m => m.default || m)
  },
  {
    name: about_45usYYpDOqhwwJMeta?.name ?? "about-us___ru",
    path: about_45usYYpDOqhwwJMeta?.path ?? "/ru/about-us",
    meta: about_45usYYpDOqhwwJMeta || {},
    alias: about_45usYYpDOqhwwJMeta?.alias || [],
    redirect: about_45usYYpDOqhwwJMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/about-us.vue").then(m => m.default || m)
  },
  {
    name: about_45usYYpDOqhwwJMeta?.name ?? "about-us___tr",
    path: about_45usYYpDOqhwwJMeta?.path ?? "/tr/about-us",
    meta: about_45usYYpDOqhwwJMeta || {},
    alias: about_45usYYpDOqhwwJMeta?.alias || [],
    redirect: about_45usYYpDOqhwwJMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/about-us.vue").then(m => m.default || m)
  },
  {
    name: affiliate_45program0facdMezZGMeta?.name ?? "affiliate-program___en",
    path: affiliate_45program0facdMezZGMeta?.path ?? "/affiliate-program",
    meta: affiliate_45program0facdMezZGMeta || {},
    alias: affiliate_45program0facdMezZGMeta?.alias || [],
    redirect: affiliate_45program0facdMezZGMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/affiliate-program.vue").then(m => m.default || m)
  },
  {
    name: affiliate_45program0facdMezZGMeta?.name ?? "affiliate-program___zh-cn",
    path: affiliate_45program0facdMezZGMeta?.path ?? "/zh-cn/affiliate-program",
    meta: affiliate_45program0facdMezZGMeta || {},
    alias: affiliate_45program0facdMezZGMeta?.alias || [],
    redirect: affiliate_45program0facdMezZGMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/affiliate-program.vue").then(m => m.default || m)
  },
  {
    name: affiliate_45program0facdMezZGMeta?.name ?? "affiliate-program___zh-tw",
    path: affiliate_45program0facdMezZGMeta?.path ?? "/zh-tw/affiliate-program",
    meta: affiliate_45program0facdMezZGMeta || {},
    alias: affiliate_45program0facdMezZGMeta?.alias || [],
    redirect: affiliate_45program0facdMezZGMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/affiliate-program.vue").then(m => m.default || m)
  },
  {
    name: affiliate_45program0facdMezZGMeta?.name ?? "affiliate-program___jp",
    path: affiliate_45program0facdMezZGMeta?.path ?? "/jp/affiliate-program",
    meta: affiliate_45program0facdMezZGMeta || {},
    alias: affiliate_45program0facdMezZGMeta?.alias || [],
    redirect: affiliate_45program0facdMezZGMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/affiliate-program.vue").then(m => m.default || m)
  },
  {
    name: affiliate_45program0facdMezZGMeta?.name ?? "affiliate-program___es",
    path: affiliate_45program0facdMezZGMeta?.path ?? "/es/affiliate-program",
    meta: affiliate_45program0facdMezZGMeta || {},
    alias: affiliate_45program0facdMezZGMeta?.alias || [],
    redirect: affiliate_45program0facdMezZGMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/affiliate-program.vue").then(m => m.default || m)
  },
  {
    name: affiliate_45program0facdMezZGMeta?.name ?? "affiliate-program___fr",
    path: affiliate_45program0facdMezZGMeta?.path ?? "/fr/affiliate-program",
    meta: affiliate_45program0facdMezZGMeta || {},
    alias: affiliate_45program0facdMezZGMeta?.alias || [],
    redirect: affiliate_45program0facdMezZGMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/affiliate-program.vue").then(m => m.default || m)
  },
  {
    name: affiliate_45program0facdMezZGMeta?.name ?? "affiliate-program___de",
    path: affiliate_45program0facdMezZGMeta?.path ?? "/de/affiliate-program",
    meta: affiliate_45program0facdMezZGMeta || {},
    alias: affiliate_45program0facdMezZGMeta?.alias || [],
    redirect: affiliate_45program0facdMezZGMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/affiliate-program.vue").then(m => m.default || m)
  },
  {
    name: affiliate_45program0facdMezZGMeta?.name ?? "affiliate-program___kr",
    path: affiliate_45program0facdMezZGMeta?.path ?? "/kr/affiliate-program",
    meta: affiliate_45program0facdMezZGMeta || {},
    alias: affiliate_45program0facdMezZGMeta?.alias || [],
    redirect: affiliate_45program0facdMezZGMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/affiliate-program.vue").then(m => m.default || m)
  },
  {
    name: affiliate_45program0facdMezZGMeta?.name ?? "affiliate-program___vn",
    path: affiliate_45program0facdMezZGMeta?.path ?? "/vn/affiliate-program",
    meta: affiliate_45program0facdMezZGMeta || {},
    alias: affiliate_45program0facdMezZGMeta?.alias || [],
    redirect: affiliate_45program0facdMezZGMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/affiliate-program.vue").then(m => m.default || m)
  },
  {
    name: affiliate_45program0facdMezZGMeta?.name ?? "affiliate-program___th",
    path: affiliate_45program0facdMezZGMeta?.path ?? "/th/affiliate-program",
    meta: affiliate_45program0facdMezZGMeta || {},
    alias: affiliate_45program0facdMezZGMeta?.alias || [],
    redirect: affiliate_45program0facdMezZGMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/affiliate-program.vue").then(m => m.default || m)
  },
  {
    name: affiliate_45program0facdMezZGMeta?.name ?? "affiliate-program___ru",
    path: affiliate_45program0facdMezZGMeta?.path ?? "/ru/affiliate-program",
    meta: affiliate_45program0facdMezZGMeta || {},
    alias: affiliate_45program0facdMezZGMeta?.alias || [],
    redirect: affiliate_45program0facdMezZGMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/affiliate-program.vue").then(m => m.default || m)
  },
  {
    name: affiliate_45program0facdMezZGMeta?.name ?? "affiliate-program___tr",
    path: affiliate_45program0facdMezZGMeta?.path ?? "/tr/affiliate-program",
    meta: affiliate_45program0facdMezZGMeta || {},
    alias: affiliate_45program0facdMezZGMeta?.alias || [],
    redirect: affiliate_45program0facdMezZGMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/affiliate-program.vue").then(m => m.default || m)
  },
  {
    name: _91url_alias_93h3Ll5SROPWMeta?.name ?? "blog-url_alias___en",
    path: _91url_alias_93h3Ll5SROPWMeta?.path ?? "/blog/:url_alias()",
    meta: _91url_alias_93h3Ll5SROPWMeta || {},
    alias: _91url_alias_93h3Ll5SROPWMeta?.alias || [],
    redirect: _91url_alias_93h3Ll5SROPWMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/blog/[url_alias].vue").then(m => m.default || m)
  },
  {
    name: _91url_alias_93h3Ll5SROPWMeta?.name ?? "blog-url_alias___zh-cn",
    path: _91url_alias_93h3Ll5SROPWMeta?.path ?? "/zh-cn/blog/:url_alias()",
    meta: _91url_alias_93h3Ll5SROPWMeta || {},
    alias: _91url_alias_93h3Ll5SROPWMeta?.alias || [],
    redirect: _91url_alias_93h3Ll5SROPWMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/blog/[url_alias].vue").then(m => m.default || m)
  },
  {
    name: _91url_alias_93h3Ll5SROPWMeta?.name ?? "blog-url_alias___zh-tw",
    path: _91url_alias_93h3Ll5SROPWMeta?.path ?? "/zh-tw/blog/:url_alias()",
    meta: _91url_alias_93h3Ll5SROPWMeta || {},
    alias: _91url_alias_93h3Ll5SROPWMeta?.alias || [],
    redirect: _91url_alias_93h3Ll5SROPWMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/blog/[url_alias].vue").then(m => m.default || m)
  },
  {
    name: _91url_alias_93h3Ll5SROPWMeta?.name ?? "blog-url_alias___jp",
    path: _91url_alias_93h3Ll5SROPWMeta?.path ?? "/jp/blog/:url_alias()",
    meta: _91url_alias_93h3Ll5SROPWMeta || {},
    alias: _91url_alias_93h3Ll5SROPWMeta?.alias || [],
    redirect: _91url_alias_93h3Ll5SROPWMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/blog/[url_alias].vue").then(m => m.default || m)
  },
  {
    name: _91url_alias_93h3Ll5SROPWMeta?.name ?? "blog-url_alias___es",
    path: _91url_alias_93h3Ll5SROPWMeta?.path ?? "/es/blog/:url_alias()",
    meta: _91url_alias_93h3Ll5SROPWMeta || {},
    alias: _91url_alias_93h3Ll5SROPWMeta?.alias || [],
    redirect: _91url_alias_93h3Ll5SROPWMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/blog/[url_alias].vue").then(m => m.default || m)
  },
  {
    name: _91url_alias_93h3Ll5SROPWMeta?.name ?? "blog-url_alias___fr",
    path: _91url_alias_93h3Ll5SROPWMeta?.path ?? "/fr/blog/:url_alias()",
    meta: _91url_alias_93h3Ll5SROPWMeta || {},
    alias: _91url_alias_93h3Ll5SROPWMeta?.alias || [],
    redirect: _91url_alias_93h3Ll5SROPWMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/blog/[url_alias].vue").then(m => m.default || m)
  },
  {
    name: _91url_alias_93h3Ll5SROPWMeta?.name ?? "blog-url_alias___de",
    path: _91url_alias_93h3Ll5SROPWMeta?.path ?? "/de/blog/:url_alias()",
    meta: _91url_alias_93h3Ll5SROPWMeta || {},
    alias: _91url_alias_93h3Ll5SROPWMeta?.alias || [],
    redirect: _91url_alias_93h3Ll5SROPWMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/blog/[url_alias].vue").then(m => m.default || m)
  },
  {
    name: _91url_alias_93h3Ll5SROPWMeta?.name ?? "blog-url_alias___kr",
    path: _91url_alias_93h3Ll5SROPWMeta?.path ?? "/kr/blog/:url_alias()",
    meta: _91url_alias_93h3Ll5SROPWMeta || {},
    alias: _91url_alias_93h3Ll5SROPWMeta?.alias || [],
    redirect: _91url_alias_93h3Ll5SROPWMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/blog/[url_alias].vue").then(m => m.default || m)
  },
  {
    name: _91url_alias_93h3Ll5SROPWMeta?.name ?? "blog-url_alias___vn",
    path: _91url_alias_93h3Ll5SROPWMeta?.path ?? "/vn/blog/:url_alias()",
    meta: _91url_alias_93h3Ll5SROPWMeta || {},
    alias: _91url_alias_93h3Ll5SROPWMeta?.alias || [],
    redirect: _91url_alias_93h3Ll5SROPWMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/blog/[url_alias].vue").then(m => m.default || m)
  },
  {
    name: _91url_alias_93h3Ll5SROPWMeta?.name ?? "blog-url_alias___th",
    path: _91url_alias_93h3Ll5SROPWMeta?.path ?? "/th/blog/:url_alias()",
    meta: _91url_alias_93h3Ll5SROPWMeta || {},
    alias: _91url_alias_93h3Ll5SROPWMeta?.alias || [],
    redirect: _91url_alias_93h3Ll5SROPWMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/blog/[url_alias].vue").then(m => m.default || m)
  },
  {
    name: _91url_alias_93h3Ll5SROPWMeta?.name ?? "blog-url_alias___ru",
    path: _91url_alias_93h3Ll5SROPWMeta?.path ?? "/ru/blog/:url_alias()",
    meta: _91url_alias_93h3Ll5SROPWMeta || {},
    alias: _91url_alias_93h3Ll5SROPWMeta?.alias || [],
    redirect: _91url_alias_93h3Ll5SROPWMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/blog/[url_alias].vue").then(m => m.default || m)
  },
  {
    name: _91url_alias_93h3Ll5SROPWMeta?.name ?? "blog-url_alias___tr",
    path: _91url_alias_93h3Ll5SROPWMeta?.path ?? "/tr/blog/:url_alias()",
    meta: _91url_alias_93h3Ll5SROPWMeta || {},
    alias: _91url_alias_93h3Ll5SROPWMeta?.alias || [],
    redirect: _91url_alias_93h3Ll5SROPWMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/blog/[url_alias].vue").then(m => m.default || m)
  },
  {
    name: _91category_932JuRr6kCdjMeta?.name ?? "blog-category-category___en",
    path: _91category_932JuRr6kCdjMeta?.path ?? "/blog/category/:category()",
    meta: _91category_932JuRr6kCdjMeta || {},
    alias: _91category_932JuRr6kCdjMeta?.alias || [],
    redirect: _91category_932JuRr6kCdjMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/blog/category/[category].vue").then(m => m.default || m)
  },
  {
    name: _91category_932JuRr6kCdjMeta?.name ?? "blog-category-category___zh-cn",
    path: _91category_932JuRr6kCdjMeta?.path ?? "/zh-cn/blog/category/:category()",
    meta: _91category_932JuRr6kCdjMeta || {},
    alias: _91category_932JuRr6kCdjMeta?.alias || [],
    redirect: _91category_932JuRr6kCdjMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/blog/category/[category].vue").then(m => m.default || m)
  },
  {
    name: _91category_932JuRr6kCdjMeta?.name ?? "blog-category-category___zh-tw",
    path: _91category_932JuRr6kCdjMeta?.path ?? "/zh-tw/blog/category/:category()",
    meta: _91category_932JuRr6kCdjMeta || {},
    alias: _91category_932JuRr6kCdjMeta?.alias || [],
    redirect: _91category_932JuRr6kCdjMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/blog/category/[category].vue").then(m => m.default || m)
  },
  {
    name: _91category_932JuRr6kCdjMeta?.name ?? "blog-category-category___jp",
    path: _91category_932JuRr6kCdjMeta?.path ?? "/jp/blog/category/:category()",
    meta: _91category_932JuRr6kCdjMeta || {},
    alias: _91category_932JuRr6kCdjMeta?.alias || [],
    redirect: _91category_932JuRr6kCdjMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/blog/category/[category].vue").then(m => m.default || m)
  },
  {
    name: _91category_932JuRr6kCdjMeta?.name ?? "blog-category-category___es",
    path: _91category_932JuRr6kCdjMeta?.path ?? "/es/blog/category/:category()",
    meta: _91category_932JuRr6kCdjMeta || {},
    alias: _91category_932JuRr6kCdjMeta?.alias || [],
    redirect: _91category_932JuRr6kCdjMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/blog/category/[category].vue").then(m => m.default || m)
  },
  {
    name: _91category_932JuRr6kCdjMeta?.name ?? "blog-category-category___fr",
    path: _91category_932JuRr6kCdjMeta?.path ?? "/fr/blog/category/:category()",
    meta: _91category_932JuRr6kCdjMeta || {},
    alias: _91category_932JuRr6kCdjMeta?.alias || [],
    redirect: _91category_932JuRr6kCdjMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/blog/category/[category].vue").then(m => m.default || m)
  },
  {
    name: _91category_932JuRr6kCdjMeta?.name ?? "blog-category-category___de",
    path: _91category_932JuRr6kCdjMeta?.path ?? "/de/blog/category/:category()",
    meta: _91category_932JuRr6kCdjMeta || {},
    alias: _91category_932JuRr6kCdjMeta?.alias || [],
    redirect: _91category_932JuRr6kCdjMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/blog/category/[category].vue").then(m => m.default || m)
  },
  {
    name: _91category_932JuRr6kCdjMeta?.name ?? "blog-category-category___kr",
    path: _91category_932JuRr6kCdjMeta?.path ?? "/kr/blog/category/:category()",
    meta: _91category_932JuRr6kCdjMeta || {},
    alias: _91category_932JuRr6kCdjMeta?.alias || [],
    redirect: _91category_932JuRr6kCdjMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/blog/category/[category].vue").then(m => m.default || m)
  },
  {
    name: _91category_932JuRr6kCdjMeta?.name ?? "blog-category-category___vn",
    path: _91category_932JuRr6kCdjMeta?.path ?? "/vn/blog/category/:category()",
    meta: _91category_932JuRr6kCdjMeta || {},
    alias: _91category_932JuRr6kCdjMeta?.alias || [],
    redirect: _91category_932JuRr6kCdjMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/blog/category/[category].vue").then(m => m.default || m)
  },
  {
    name: _91category_932JuRr6kCdjMeta?.name ?? "blog-category-category___th",
    path: _91category_932JuRr6kCdjMeta?.path ?? "/th/blog/category/:category()",
    meta: _91category_932JuRr6kCdjMeta || {},
    alias: _91category_932JuRr6kCdjMeta?.alias || [],
    redirect: _91category_932JuRr6kCdjMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/blog/category/[category].vue").then(m => m.default || m)
  },
  {
    name: _91category_932JuRr6kCdjMeta?.name ?? "blog-category-category___ru",
    path: _91category_932JuRr6kCdjMeta?.path ?? "/ru/blog/category/:category()",
    meta: _91category_932JuRr6kCdjMeta || {},
    alias: _91category_932JuRr6kCdjMeta?.alias || [],
    redirect: _91category_932JuRr6kCdjMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/blog/category/[category].vue").then(m => m.default || m)
  },
  {
    name: _91category_932JuRr6kCdjMeta?.name ?? "blog-category-category___tr",
    path: _91category_932JuRr6kCdjMeta?.path ?? "/tr/blog/category/:category()",
    meta: _91category_932JuRr6kCdjMeta || {},
    alias: _91category_932JuRr6kCdjMeta?.alias || [],
    redirect: _91category_932JuRr6kCdjMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/blog/category/[category].vue").then(m => m.default || m)
  },
  {
    name: index5rXufKkEHvMeta?.name ?? "blog___en",
    path: index5rXufKkEHvMeta?.path ?? "/blog",
    meta: index5rXufKkEHvMeta || {},
    alias: index5rXufKkEHvMeta?.alias || [],
    redirect: index5rXufKkEHvMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: index5rXufKkEHvMeta?.name ?? "blog___zh-cn",
    path: index5rXufKkEHvMeta?.path ?? "/zh-cn/blog",
    meta: index5rXufKkEHvMeta || {},
    alias: index5rXufKkEHvMeta?.alias || [],
    redirect: index5rXufKkEHvMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: index5rXufKkEHvMeta?.name ?? "blog___zh-tw",
    path: index5rXufKkEHvMeta?.path ?? "/zh-tw/blog",
    meta: index5rXufKkEHvMeta || {},
    alias: index5rXufKkEHvMeta?.alias || [],
    redirect: index5rXufKkEHvMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: index5rXufKkEHvMeta?.name ?? "blog___jp",
    path: index5rXufKkEHvMeta?.path ?? "/jp/blog",
    meta: index5rXufKkEHvMeta || {},
    alias: index5rXufKkEHvMeta?.alias || [],
    redirect: index5rXufKkEHvMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: index5rXufKkEHvMeta?.name ?? "blog___es",
    path: index5rXufKkEHvMeta?.path ?? "/es/blog",
    meta: index5rXufKkEHvMeta || {},
    alias: index5rXufKkEHvMeta?.alias || [],
    redirect: index5rXufKkEHvMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: index5rXufKkEHvMeta?.name ?? "blog___fr",
    path: index5rXufKkEHvMeta?.path ?? "/fr/blog",
    meta: index5rXufKkEHvMeta || {},
    alias: index5rXufKkEHvMeta?.alias || [],
    redirect: index5rXufKkEHvMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: index5rXufKkEHvMeta?.name ?? "blog___de",
    path: index5rXufKkEHvMeta?.path ?? "/de/blog",
    meta: index5rXufKkEHvMeta || {},
    alias: index5rXufKkEHvMeta?.alias || [],
    redirect: index5rXufKkEHvMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: index5rXufKkEHvMeta?.name ?? "blog___kr",
    path: index5rXufKkEHvMeta?.path ?? "/kr/blog",
    meta: index5rXufKkEHvMeta || {},
    alias: index5rXufKkEHvMeta?.alias || [],
    redirect: index5rXufKkEHvMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: index5rXufKkEHvMeta?.name ?? "blog___vn",
    path: index5rXufKkEHvMeta?.path ?? "/vn/blog",
    meta: index5rXufKkEHvMeta || {},
    alias: index5rXufKkEHvMeta?.alias || [],
    redirect: index5rXufKkEHvMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: index5rXufKkEHvMeta?.name ?? "blog___th",
    path: index5rXufKkEHvMeta?.path ?? "/th/blog",
    meta: index5rXufKkEHvMeta || {},
    alias: index5rXufKkEHvMeta?.alias || [],
    redirect: index5rXufKkEHvMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: index5rXufKkEHvMeta?.name ?? "blog___ru",
    path: index5rXufKkEHvMeta?.path ?? "/ru/blog",
    meta: index5rXufKkEHvMeta || {},
    alias: index5rXufKkEHvMeta?.alias || [],
    redirect: index5rXufKkEHvMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: index5rXufKkEHvMeta?.name ?? "blog___tr",
    path: index5rXufKkEHvMeta?.path ?? "/tr/blog",
    meta: index5rXufKkEHvMeta || {},
    alias: index5rXufKkEHvMeta?.alias || [],
    redirect: index5rXufKkEHvMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: _91tag_93DoW6eQFVfJMeta?.name ?? "blog-tag-tag___en",
    path: _91tag_93DoW6eQFVfJMeta?.path ?? "/blog/tag/:tag()",
    meta: _91tag_93DoW6eQFVfJMeta || {},
    alias: _91tag_93DoW6eQFVfJMeta?.alias || [],
    redirect: _91tag_93DoW6eQFVfJMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/blog/tag/[tag].vue").then(m => m.default || m)
  },
  {
    name: _91tag_93DoW6eQFVfJMeta?.name ?? "blog-tag-tag___zh-cn",
    path: _91tag_93DoW6eQFVfJMeta?.path ?? "/zh-cn/blog/tag/:tag()",
    meta: _91tag_93DoW6eQFVfJMeta || {},
    alias: _91tag_93DoW6eQFVfJMeta?.alias || [],
    redirect: _91tag_93DoW6eQFVfJMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/blog/tag/[tag].vue").then(m => m.default || m)
  },
  {
    name: _91tag_93DoW6eQFVfJMeta?.name ?? "blog-tag-tag___zh-tw",
    path: _91tag_93DoW6eQFVfJMeta?.path ?? "/zh-tw/blog/tag/:tag()",
    meta: _91tag_93DoW6eQFVfJMeta || {},
    alias: _91tag_93DoW6eQFVfJMeta?.alias || [],
    redirect: _91tag_93DoW6eQFVfJMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/blog/tag/[tag].vue").then(m => m.default || m)
  },
  {
    name: _91tag_93DoW6eQFVfJMeta?.name ?? "blog-tag-tag___jp",
    path: _91tag_93DoW6eQFVfJMeta?.path ?? "/jp/blog/tag/:tag()",
    meta: _91tag_93DoW6eQFVfJMeta || {},
    alias: _91tag_93DoW6eQFVfJMeta?.alias || [],
    redirect: _91tag_93DoW6eQFVfJMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/blog/tag/[tag].vue").then(m => m.default || m)
  },
  {
    name: _91tag_93DoW6eQFVfJMeta?.name ?? "blog-tag-tag___es",
    path: _91tag_93DoW6eQFVfJMeta?.path ?? "/es/blog/tag/:tag()",
    meta: _91tag_93DoW6eQFVfJMeta || {},
    alias: _91tag_93DoW6eQFVfJMeta?.alias || [],
    redirect: _91tag_93DoW6eQFVfJMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/blog/tag/[tag].vue").then(m => m.default || m)
  },
  {
    name: _91tag_93DoW6eQFVfJMeta?.name ?? "blog-tag-tag___fr",
    path: _91tag_93DoW6eQFVfJMeta?.path ?? "/fr/blog/tag/:tag()",
    meta: _91tag_93DoW6eQFVfJMeta || {},
    alias: _91tag_93DoW6eQFVfJMeta?.alias || [],
    redirect: _91tag_93DoW6eQFVfJMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/blog/tag/[tag].vue").then(m => m.default || m)
  },
  {
    name: _91tag_93DoW6eQFVfJMeta?.name ?? "blog-tag-tag___de",
    path: _91tag_93DoW6eQFVfJMeta?.path ?? "/de/blog/tag/:tag()",
    meta: _91tag_93DoW6eQFVfJMeta || {},
    alias: _91tag_93DoW6eQFVfJMeta?.alias || [],
    redirect: _91tag_93DoW6eQFVfJMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/blog/tag/[tag].vue").then(m => m.default || m)
  },
  {
    name: _91tag_93DoW6eQFVfJMeta?.name ?? "blog-tag-tag___kr",
    path: _91tag_93DoW6eQFVfJMeta?.path ?? "/kr/blog/tag/:tag()",
    meta: _91tag_93DoW6eQFVfJMeta || {},
    alias: _91tag_93DoW6eQFVfJMeta?.alias || [],
    redirect: _91tag_93DoW6eQFVfJMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/blog/tag/[tag].vue").then(m => m.default || m)
  },
  {
    name: _91tag_93DoW6eQFVfJMeta?.name ?? "blog-tag-tag___vn",
    path: _91tag_93DoW6eQFVfJMeta?.path ?? "/vn/blog/tag/:tag()",
    meta: _91tag_93DoW6eQFVfJMeta || {},
    alias: _91tag_93DoW6eQFVfJMeta?.alias || [],
    redirect: _91tag_93DoW6eQFVfJMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/blog/tag/[tag].vue").then(m => m.default || m)
  },
  {
    name: _91tag_93DoW6eQFVfJMeta?.name ?? "blog-tag-tag___th",
    path: _91tag_93DoW6eQFVfJMeta?.path ?? "/th/blog/tag/:tag()",
    meta: _91tag_93DoW6eQFVfJMeta || {},
    alias: _91tag_93DoW6eQFVfJMeta?.alias || [],
    redirect: _91tag_93DoW6eQFVfJMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/blog/tag/[tag].vue").then(m => m.default || m)
  },
  {
    name: _91tag_93DoW6eQFVfJMeta?.name ?? "blog-tag-tag___ru",
    path: _91tag_93DoW6eQFVfJMeta?.path ?? "/ru/blog/tag/:tag()",
    meta: _91tag_93DoW6eQFVfJMeta || {},
    alias: _91tag_93DoW6eQFVfJMeta?.alias || [],
    redirect: _91tag_93DoW6eQFVfJMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/blog/tag/[tag].vue").then(m => m.default || m)
  },
  {
    name: _91tag_93DoW6eQFVfJMeta?.name ?? "blog-tag-tag___tr",
    path: _91tag_93DoW6eQFVfJMeta?.path ?? "/tr/blog/tag/:tag()",
    meta: _91tag_93DoW6eQFVfJMeta || {},
    alias: _91tag_93DoW6eQFVfJMeta?.alias || [],
    redirect: _91tag_93DoW6eQFVfJMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/blog/tag/[tag].vue").then(m => m.default || m)
  },
  {
    name: _91viewType_93oz2fuYjcgiMeta?.name ?? "brand-viewType___en",
    path: _91viewType_93oz2fuYjcgiMeta?.path ?? "/brand/:viewType()",
    meta: _91viewType_93oz2fuYjcgiMeta || {},
    alias: _91viewType_93oz2fuYjcgiMeta?.alias || [],
    redirect: _91viewType_93oz2fuYjcgiMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/brand/[viewType].vue").then(m => m.default || m)
  },
  {
    name: _91viewType_93oz2fuYjcgiMeta?.name ?? "brand-viewType___zh-cn",
    path: _91viewType_93oz2fuYjcgiMeta?.path ?? "/zh-cn/brand/:viewType()",
    meta: _91viewType_93oz2fuYjcgiMeta || {},
    alias: _91viewType_93oz2fuYjcgiMeta?.alias || [],
    redirect: _91viewType_93oz2fuYjcgiMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/brand/[viewType].vue").then(m => m.default || m)
  },
  {
    name: _91viewType_93oz2fuYjcgiMeta?.name ?? "brand-viewType___zh-tw",
    path: _91viewType_93oz2fuYjcgiMeta?.path ?? "/zh-tw/brand/:viewType()",
    meta: _91viewType_93oz2fuYjcgiMeta || {},
    alias: _91viewType_93oz2fuYjcgiMeta?.alias || [],
    redirect: _91viewType_93oz2fuYjcgiMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/brand/[viewType].vue").then(m => m.default || m)
  },
  {
    name: _91viewType_93oz2fuYjcgiMeta?.name ?? "brand-viewType___jp",
    path: _91viewType_93oz2fuYjcgiMeta?.path ?? "/jp/brand/:viewType()",
    meta: _91viewType_93oz2fuYjcgiMeta || {},
    alias: _91viewType_93oz2fuYjcgiMeta?.alias || [],
    redirect: _91viewType_93oz2fuYjcgiMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/brand/[viewType].vue").then(m => m.default || m)
  },
  {
    name: _91viewType_93oz2fuYjcgiMeta?.name ?? "brand-viewType___es",
    path: _91viewType_93oz2fuYjcgiMeta?.path ?? "/es/brand/:viewType()",
    meta: _91viewType_93oz2fuYjcgiMeta || {},
    alias: _91viewType_93oz2fuYjcgiMeta?.alias || [],
    redirect: _91viewType_93oz2fuYjcgiMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/brand/[viewType].vue").then(m => m.default || m)
  },
  {
    name: _91viewType_93oz2fuYjcgiMeta?.name ?? "brand-viewType___fr",
    path: _91viewType_93oz2fuYjcgiMeta?.path ?? "/fr/brand/:viewType()",
    meta: _91viewType_93oz2fuYjcgiMeta || {},
    alias: _91viewType_93oz2fuYjcgiMeta?.alias || [],
    redirect: _91viewType_93oz2fuYjcgiMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/brand/[viewType].vue").then(m => m.default || m)
  },
  {
    name: _91viewType_93oz2fuYjcgiMeta?.name ?? "brand-viewType___de",
    path: _91viewType_93oz2fuYjcgiMeta?.path ?? "/de/brand/:viewType()",
    meta: _91viewType_93oz2fuYjcgiMeta || {},
    alias: _91viewType_93oz2fuYjcgiMeta?.alias || [],
    redirect: _91viewType_93oz2fuYjcgiMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/brand/[viewType].vue").then(m => m.default || m)
  },
  {
    name: _91viewType_93oz2fuYjcgiMeta?.name ?? "brand-viewType___kr",
    path: _91viewType_93oz2fuYjcgiMeta?.path ?? "/kr/brand/:viewType()",
    meta: _91viewType_93oz2fuYjcgiMeta || {},
    alias: _91viewType_93oz2fuYjcgiMeta?.alias || [],
    redirect: _91viewType_93oz2fuYjcgiMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/brand/[viewType].vue").then(m => m.default || m)
  },
  {
    name: _91viewType_93oz2fuYjcgiMeta?.name ?? "brand-viewType___vn",
    path: _91viewType_93oz2fuYjcgiMeta?.path ?? "/vn/brand/:viewType()",
    meta: _91viewType_93oz2fuYjcgiMeta || {},
    alias: _91viewType_93oz2fuYjcgiMeta?.alias || [],
    redirect: _91viewType_93oz2fuYjcgiMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/brand/[viewType].vue").then(m => m.default || m)
  },
  {
    name: _91viewType_93oz2fuYjcgiMeta?.name ?? "brand-viewType___th",
    path: _91viewType_93oz2fuYjcgiMeta?.path ?? "/th/brand/:viewType()",
    meta: _91viewType_93oz2fuYjcgiMeta || {},
    alias: _91viewType_93oz2fuYjcgiMeta?.alias || [],
    redirect: _91viewType_93oz2fuYjcgiMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/brand/[viewType].vue").then(m => m.default || m)
  },
  {
    name: _91viewType_93oz2fuYjcgiMeta?.name ?? "brand-viewType___ru",
    path: _91viewType_93oz2fuYjcgiMeta?.path ?? "/ru/brand/:viewType()",
    meta: _91viewType_93oz2fuYjcgiMeta || {},
    alias: _91viewType_93oz2fuYjcgiMeta?.alias || [],
    redirect: _91viewType_93oz2fuYjcgiMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/brand/[viewType].vue").then(m => m.default || m)
  },
  {
    name: _91viewType_93oz2fuYjcgiMeta?.name ?? "brand-viewType___tr",
    path: _91viewType_93oz2fuYjcgiMeta?.path ?? "/tr/brand/:viewType()",
    meta: _91viewType_93oz2fuYjcgiMeta || {},
    alias: _91viewType_93oz2fuYjcgiMeta?.alias || [],
    redirect: _91viewType_93oz2fuYjcgiMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/brand/[viewType].vue").then(m => m.default || m)
  },
  {
    name: configskqSb53A6DMeta?.name ?? "brand-config___en",
    path: configskqSb53A6DMeta?.path ?? "/brand/config",
    meta: configskqSb53A6DMeta || {},
    alias: configskqSb53A6DMeta?.alias || [],
    redirect: configskqSb53A6DMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/brand/config.ts").then(m => m.default || m)
  },
  {
    name: configskqSb53A6DMeta?.name ?? "brand-config___zh-cn",
    path: configskqSb53A6DMeta?.path ?? "/zh-cn/brand/config",
    meta: configskqSb53A6DMeta || {},
    alias: configskqSb53A6DMeta?.alias || [],
    redirect: configskqSb53A6DMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/brand/config.ts").then(m => m.default || m)
  },
  {
    name: configskqSb53A6DMeta?.name ?? "brand-config___zh-tw",
    path: configskqSb53A6DMeta?.path ?? "/zh-tw/brand/config",
    meta: configskqSb53A6DMeta || {},
    alias: configskqSb53A6DMeta?.alias || [],
    redirect: configskqSb53A6DMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/brand/config.ts").then(m => m.default || m)
  },
  {
    name: configskqSb53A6DMeta?.name ?? "brand-config___jp",
    path: configskqSb53A6DMeta?.path ?? "/jp/brand/config",
    meta: configskqSb53A6DMeta || {},
    alias: configskqSb53A6DMeta?.alias || [],
    redirect: configskqSb53A6DMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/brand/config.ts").then(m => m.default || m)
  },
  {
    name: configskqSb53A6DMeta?.name ?? "brand-config___es",
    path: configskqSb53A6DMeta?.path ?? "/es/brand/config",
    meta: configskqSb53A6DMeta || {},
    alias: configskqSb53A6DMeta?.alias || [],
    redirect: configskqSb53A6DMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/brand/config.ts").then(m => m.default || m)
  },
  {
    name: configskqSb53A6DMeta?.name ?? "brand-config___fr",
    path: configskqSb53A6DMeta?.path ?? "/fr/brand/config",
    meta: configskqSb53A6DMeta || {},
    alias: configskqSb53A6DMeta?.alias || [],
    redirect: configskqSb53A6DMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/brand/config.ts").then(m => m.default || m)
  },
  {
    name: configskqSb53A6DMeta?.name ?? "brand-config___de",
    path: configskqSb53A6DMeta?.path ?? "/de/brand/config",
    meta: configskqSb53A6DMeta || {},
    alias: configskqSb53A6DMeta?.alias || [],
    redirect: configskqSb53A6DMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/brand/config.ts").then(m => m.default || m)
  },
  {
    name: configskqSb53A6DMeta?.name ?? "brand-config___kr",
    path: configskqSb53A6DMeta?.path ?? "/kr/brand/config",
    meta: configskqSb53A6DMeta || {},
    alias: configskqSb53A6DMeta?.alias || [],
    redirect: configskqSb53A6DMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/brand/config.ts").then(m => m.default || m)
  },
  {
    name: configskqSb53A6DMeta?.name ?? "brand-config___vn",
    path: configskqSb53A6DMeta?.path ?? "/vn/brand/config",
    meta: configskqSb53A6DMeta || {},
    alias: configskqSb53A6DMeta?.alias || [],
    redirect: configskqSb53A6DMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/brand/config.ts").then(m => m.default || m)
  },
  {
    name: configskqSb53A6DMeta?.name ?? "brand-config___th",
    path: configskqSb53A6DMeta?.path ?? "/th/brand/config",
    meta: configskqSb53A6DMeta || {},
    alias: configskqSb53A6DMeta?.alias || [],
    redirect: configskqSb53A6DMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/brand/config.ts").then(m => m.default || m)
  },
  {
    name: configskqSb53A6DMeta?.name ?? "brand-config___ru",
    path: configskqSb53A6DMeta?.path ?? "/ru/brand/config",
    meta: configskqSb53A6DMeta || {},
    alias: configskqSb53A6DMeta?.alias || [],
    redirect: configskqSb53A6DMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/brand/config.ts").then(m => m.default || m)
  },
  {
    name: configskqSb53A6DMeta?.name ?? "brand-config___tr",
    path: configskqSb53A6DMeta?.path ?? "/tr/brand/config",
    meta: configskqSb53A6DMeta || {},
    alias: configskqSb53A6DMeta?.alias || [],
    redirect: configskqSb53A6DMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/brand/config.ts").then(m => m.default || m)
  },
  {
    name: caas0bC3gX1cWxMeta?.name ?? "caas___en",
    path: caas0bC3gX1cWxMeta?.path ?? "/caas",
    meta: caas0bC3gX1cWxMeta || {},
    alias: caas0bC3gX1cWxMeta?.alias || [],
    redirect: caas0bC3gX1cWxMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/caas.vue").then(m => m.default || m)
  },
  {
    name: caas0bC3gX1cWxMeta?.name ?? "caas___zh-cn",
    path: caas0bC3gX1cWxMeta?.path ?? "/zh-cn/caas",
    meta: caas0bC3gX1cWxMeta || {},
    alias: caas0bC3gX1cWxMeta?.alias || [],
    redirect: caas0bC3gX1cWxMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/caas.vue").then(m => m.default || m)
  },
  {
    name: caas0bC3gX1cWxMeta?.name ?? "caas___zh-tw",
    path: caas0bC3gX1cWxMeta?.path ?? "/zh-tw/caas",
    meta: caas0bC3gX1cWxMeta || {},
    alias: caas0bC3gX1cWxMeta?.alias || [],
    redirect: caas0bC3gX1cWxMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/caas.vue").then(m => m.default || m)
  },
  {
    name: caas0bC3gX1cWxMeta?.name ?? "caas___jp",
    path: caas0bC3gX1cWxMeta?.path ?? "/jp/caas",
    meta: caas0bC3gX1cWxMeta || {},
    alias: caas0bC3gX1cWxMeta?.alias || [],
    redirect: caas0bC3gX1cWxMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/caas.vue").then(m => m.default || m)
  },
  {
    name: caas0bC3gX1cWxMeta?.name ?? "caas___es",
    path: caas0bC3gX1cWxMeta?.path ?? "/es/caas",
    meta: caas0bC3gX1cWxMeta || {},
    alias: caas0bC3gX1cWxMeta?.alias || [],
    redirect: caas0bC3gX1cWxMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/caas.vue").then(m => m.default || m)
  },
  {
    name: caas0bC3gX1cWxMeta?.name ?? "caas___fr",
    path: caas0bC3gX1cWxMeta?.path ?? "/fr/caas",
    meta: caas0bC3gX1cWxMeta || {},
    alias: caas0bC3gX1cWxMeta?.alias || [],
    redirect: caas0bC3gX1cWxMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/caas.vue").then(m => m.default || m)
  },
  {
    name: caas0bC3gX1cWxMeta?.name ?? "caas___de",
    path: caas0bC3gX1cWxMeta?.path ?? "/de/caas",
    meta: caas0bC3gX1cWxMeta || {},
    alias: caas0bC3gX1cWxMeta?.alias || [],
    redirect: caas0bC3gX1cWxMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/caas.vue").then(m => m.default || m)
  },
  {
    name: caas0bC3gX1cWxMeta?.name ?? "caas___kr",
    path: caas0bC3gX1cWxMeta?.path ?? "/kr/caas",
    meta: caas0bC3gX1cWxMeta || {},
    alias: caas0bC3gX1cWxMeta?.alias || [],
    redirect: caas0bC3gX1cWxMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/caas.vue").then(m => m.default || m)
  },
  {
    name: caas0bC3gX1cWxMeta?.name ?? "caas___vn",
    path: caas0bC3gX1cWxMeta?.path ?? "/vn/caas",
    meta: caas0bC3gX1cWxMeta || {},
    alias: caas0bC3gX1cWxMeta?.alias || [],
    redirect: caas0bC3gX1cWxMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/caas.vue").then(m => m.default || m)
  },
  {
    name: caas0bC3gX1cWxMeta?.name ?? "caas___th",
    path: caas0bC3gX1cWxMeta?.path ?? "/th/caas",
    meta: caas0bC3gX1cWxMeta || {},
    alias: caas0bC3gX1cWxMeta?.alias || [],
    redirect: caas0bC3gX1cWxMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/caas.vue").then(m => m.default || m)
  },
  {
    name: caas0bC3gX1cWxMeta?.name ?? "caas___ru",
    path: caas0bC3gX1cWxMeta?.path ?? "/ru/caas",
    meta: caas0bC3gX1cWxMeta || {},
    alias: caas0bC3gX1cWxMeta?.alias || [],
    redirect: caas0bC3gX1cWxMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/caas.vue").then(m => m.default || m)
  },
  {
    name: caas0bC3gX1cWxMeta?.name ?? "caas___tr",
    path: caas0bC3gX1cWxMeta?.path ?? "/tr/caas",
    meta: caas0bC3gX1cWxMeta || {},
    alias: caas0bC3gX1cWxMeta?.alias || [],
    redirect: caas0bC3gX1cWxMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/caas.vue").then(m => m.default || m)
  },
  {
    name: ccTLDstlStVuDVTBMeta?.name ?? "ccTLDs___en",
    path: ccTLDstlStVuDVTBMeta?.path ?? "/ccTLDs",
    meta: ccTLDstlStVuDVTBMeta || {},
    alias: ccTLDstlStVuDVTBMeta?.alias || [],
    redirect: ccTLDstlStVuDVTBMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ccTLDs.vue").then(m => m.default || m)
  },
  {
    name: ccTLDstlStVuDVTBMeta?.name ?? "ccTLDs___zh-cn",
    path: ccTLDstlStVuDVTBMeta?.path ?? "/zh-cn/ccTLDs",
    meta: ccTLDstlStVuDVTBMeta || {},
    alias: ccTLDstlStVuDVTBMeta?.alias || [],
    redirect: ccTLDstlStVuDVTBMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ccTLDs.vue").then(m => m.default || m)
  },
  {
    name: ccTLDstlStVuDVTBMeta?.name ?? "ccTLDs___zh-tw",
    path: ccTLDstlStVuDVTBMeta?.path ?? "/zh-tw/ccTLDs",
    meta: ccTLDstlStVuDVTBMeta || {},
    alias: ccTLDstlStVuDVTBMeta?.alias || [],
    redirect: ccTLDstlStVuDVTBMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ccTLDs.vue").then(m => m.default || m)
  },
  {
    name: ccTLDstlStVuDVTBMeta?.name ?? "ccTLDs___jp",
    path: ccTLDstlStVuDVTBMeta?.path ?? "/jp/ccTLDs",
    meta: ccTLDstlStVuDVTBMeta || {},
    alias: ccTLDstlStVuDVTBMeta?.alias || [],
    redirect: ccTLDstlStVuDVTBMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ccTLDs.vue").then(m => m.default || m)
  },
  {
    name: ccTLDstlStVuDVTBMeta?.name ?? "ccTLDs___es",
    path: ccTLDstlStVuDVTBMeta?.path ?? "/es/ccTLDs",
    meta: ccTLDstlStVuDVTBMeta || {},
    alias: ccTLDstlStVuDVTBMeta?.alias || [],
    redirect: ccTLDstlStVuDVTBMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ccTLDs.vue").then(m => m.default || m)
  },
  {
    name: ccTLDstlStVuDVTBMeta?.name ?? "ccTLDs___fr",
    path: ccTLDstlStVuDVTBMeta?.path ?? "/fr/ccTLDs",
    meta: ccTLDstlStVuDVTBMeta || {},
    alias: ccTLDstlStVuDVTBMeta?.alias || [],
    redirect: ccTLDstlStVuDVTBMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ccTLDs.vue").then(m => m.default || m)
  },
  {
    name: ccTLDstlStVuDVTBMeta?.name ?? "ccTLDs___de",
    path: ccTLDstlStVuDVTBMeta?.path ?? "/de/ccTLDs",
    meta: ccTLDstlStVuDVTBMeta || {},
    alias: ccTLDstlStVuDVTBMeta?.alias || [],
    redirect: ccTLDstlStVuDVTBMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ccTLDs.vue").then(m => m.default || m)
  },
  {
    name: ccTLDstlStVuDVTBMeta?.name ?? "ccTLDs___kr",
    path: ccTLDstlStVuDVTBMeta?.path ?? "/kr/ccTLDs",
    meta: ccTLDstlStVuDVTBMeta || {},
    alias: ccTLDstlStVuDVTBMeta?.alias || [],
    redirect: ccTLDstlStVuDVTBMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ccTLDs.vue").then(m => m.default || m)
  },
  {
    name: ccTLDstlStVuDVTBMeta?.name ?? "ccTLDs___vn",
    path: ccTLDstlStVuDVTBMeta?.path ?? "/vn/ccTLDs",
    meta: ccTLDstlStVuDVTBMeta || {},
    alias: ccTLDstlStVuDVTBMeta?.alias || [],
    redirect: ccTLDstlStVuDVTBMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ccTLDs.vue").then(m => m.default || m)
  },
  {
    name: ccTLDstlStVuDVTBMeta?.name ?? "ccTLDs___th",
    path: ccTLDstlStVuDVTBMeta?.path ?? "/th/ccTLDs",
    meta: ccTLDstlStVuDVTBMeta || {},
    alias: ccTLDstlStVuDVTBMeta?.alias || [],
    redirect: ccTLDstlStVuDVTBMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ccTLDs.vue").then(m => m.default || m)
  },
  {
    name: ccTLDstlStVuDVTBMeta?.name ?? "ccTLDs___ru",
    path: ccTLDstlStVuDVTBMeta?.path ?? "/ru/ccTLDs",
    meta: ccTLDstlStVuDVTBMeta || {},
    alias: ccTLDstlStVuDVTBMeta?.alias || [],
    redirect: ccTLDstlStVuDVTBMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ccTLDs.vue").then(m => m.default || m)
  },
  {
    name: ccTLDstlStVuDVTBMeta?.name ?? "ccTLDs___tr",
    path: ccTLDstlStVuDVTBMeta?.path ?? "/tr/ccTLDs",
    meta: ccTLDstlStVuDVTBMeta || {},
    alias: ccTLDstlStVuDVTBMeta?.alias || [],
    redirect: ccTLDstlStVuDVTBMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ccTLDs.vue").then(m => m.default || m)
  },
  {
    name: cert_45file5Gnj0Hcv2IMeta?.name ?? "cert-file___en",
    path: cert_45file5Gnj0Hcv2IMeta?.path ?? "/cert-file",
    meta: cert_45file5Gnj0Hcv2IMeta || {},
    alias: cert_45file5Gnj0Hcv2IMeta?.alias || [],
    redirect: cert_45file5Gnj0Hcv2IMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/cert-file.vue").then(m => m.default || m)
  },
  {
    name: cert_45file5Gnj0Hcv2IMeta?.name ?? "cert-file___zh-cn",
    path: cert_45file5Gnj0Hcv2IMeta?.path ?? "/zh-cn/cert-file",
    meta: cert_45file5Gnj0Hcv2IMeta || {},
    alias: cert_45file5Gnj0Hcv2IMeta?.alias || [],
    redirect: cert_45file5Gnj0Hcv2IMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/cert-file.vue").then(m => m.default || m)
  },
  {
    name: cert_45file5Gnj0Hcv2IMeta?.name ?? "cert-file___zh-tw",
    path: cert_45file5Gnj0Hcv2IMeta?.path ?? "/zh-tw/cert-file",
    meta: cert_45file5Gnj0Hcv2IMeta || {},
    alias: cert_45file5Gnj0Hcv2IMeta?.alias || [],
    redirect: cert_45file5Gnj0Hcv2IMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/cert-file.vue").then(m => m.default || m)
  },
  {
    name: cert_45file5Gnj0Hcv2IMeta?.name ?? "cert-file___jp",
    path: cert_45file5Gnj0Hcv2IMeta?.path ?? "/jp/cert-file",
    meta: cert_45file5Gnj0Hcv2IMeta || {},
    alias: cert_45file5Gnj0Hcv2IMeta?.alias || [],
    redirect: cert_45file5Gnj0Hcv2IMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/cert-file.vue").then(m => m.default || m)
  },
  {
    name: cert_45file5Gnj0Hcv2IMeta?.name ?? "cert-file___es",
    path: cert_45file5Gnj0Hcv2IMeta?.path ?? "/es/cert-file",
    meta: cert_45file5Gnj0Hcv2IMeta || {},
    alias: cert_45file5Gnj0Hcv2IMeta?.alias || [],
    redirect: cert_45file5Gnj0Hcv2IMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/cert-file.vue").then(m => m.default || m)
  },
  {
    name: cert_45file5Gnj0Hcv2IMeta?.name ?? "cert-file___fr",
    path: cert_45file5Gnj0Hcv2IMeta?.path ?? "/fr/cert-file",
    meta: cert_45file5Gnj0Hcv2IMeta || {},
    alias: cert_45file5Gnj0Hcv2IMeta?.alias || [],
    redirect: cert_45file5Gnj0Hcv2IMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/cert-file.vue").then(m => m.default || m)
  },
  {
    name: cert_45file5Gnj0Hcv2IMeta?.name ?? "cert-file___de",
    path: cert_45file5Gnj0Hcv2IMeta?.path ?? "/de/cert-file",
    meta: cert_45file5Gnj0Hcv2IMeta || {},
    alias: cert_45file5Gnj0Hcv2IMeta?.alias || [],
    redirect: cert_45file5Gnj0Hcv2IMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/cert-file.vue").then(m => m.default || m)
  },
  {
    name: cert_45file5Gnj0Hcv2IMeta?.name ?? "cert-file___kr",
    path: cert_45file5Gnj0Hcv2IMeta?.path ?? "/kr/cert-file",
    meta: cert_45file5Gnj0Hcv2IMeta || {},
    alias: cert_45file5Gnj0Hcv2IMeta?.alias || [],
    redirect: cert_45file5Gnj0Hcv2IMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/cert-file.vue").then(m => m.default || m)
  },
  {
    name: cert_45file5Gnj0Hcv2IMeta?.name ?? "cert-file___vn",
    path: cert_45file5Gnj0Hcv2IMeta?.path ?? "/vn/cert-file",
    meta: cert_45file5Gnj0Hcv2IMeta || {},
    alias: cert_45file5Gnj0Hcv2IMeta?.alias || [],
    redirect: cert_45file5Gnj0Hcv2IMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/cert-file.vue").then(m => m.default || m)
  },
  {
    name: cert_45file5Gnj0Hcv2IMeta?.name ?? "cert-file___th",
    path: cert_45file5Gnj0Hcv2IMeta?.path ?? "/th/cert-file",
    meta: cert_45file5Gnj0Hcv2IMeta || {},
    alias: cert_45file5Gnj0Hcv2IMeta?.alias || [],
    redirect: cert_45file5Gnj0Hcv2IMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/cert-file.vue").then(m => m.default || m)
  },
  {
    name: cert_45file5Gnj0Hcv2IMeta?.name ?? "cert-file___ru",
    path: cert_45file5Gnj0Hcv2IMeta?.path ?? "/ru/cert-file",
    meta: cert_45file5Gnj0Hcv2IMeta || {},
    alias: cert_45file5Gnj0Hcv2IMeta?.alias || [],
    redirect: cert_45file5Gnj0Hcv2IMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/cert-file.vue").then(m => m.default || m)
  },
  {
    name: cert_45file5Gnj0Hcv2IMeta?.name ?? "cert-file___tr",
    path: cert_45file5Gnj0Hcv2IMeta?.path ?? "/tr/cert-file",
    meta: cert_45file5Gnj0Hcv2IMeta || {},
    alias: cert_45file5Gnj0Hcv2IMeta?.alias || [],
    redirect: cert_45file5Gnj0Hcv2IMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/cert-file.vue").then(m => m.default || m)
  },
  {
    name: check_45ct_45logJZne3aLxGhMeta?.name ?? "check-ct-log___en",
    path: check_45ct_45logJZne3aLxGhMeta?.path ?? "/check-ct-log",
    meta: check_45ct_45logJZne3aLxGhMeta || {},
    alias: check_45ct_45logJZne3aLxGhMeta?.alias || [],
    redirect: check_45ct_45logJZne3aLxGhMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/check-ct-log.vue").then(m => m.default || m)
  },
  {
    name: check_45ct_45logJZne3aLxGhMeta?.name ?? "check-ct-log___zh-cn",
    path: check_45ct_45logJZne3aLxGhMeta?.path ?? "/zh-cn/check-ct-log",
    meta: check_45ct_45logJZne3aLxGhMeta || {},
    alias: check_45ct_45logJZne3aLxGhMeta?.alias || [],
    redirect: check_45ct_45logJZne3aLxGhMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/check-ct-log.vue").then(m => m.default || m)
  },
  {
    name: check_45ct_45logJZne3aLxGhMeta?.name ?? "check-ct-log___zh-tw",
    path: check_45ct_45logJZne3aLxGhMeta?.path ?? "/zh-tw/check-ct-log",
    meta: check_45ct_45logJZne3aLxGhMeta || {},
    alias: check_45ct_45logJZne3aLxGhMeta?.alias || [],
    redirect: check_45ct_45logJZne3aLxGhMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/check-ct-log.vue").then(m => m.default || m)
  },
  {
    name: check_45ct_45logJZne3aLxGhMeta?.name ?? "check-ct-log___jp",
    path: check_45ct_45logJZne3aLxGhMeta?.path ?? "/jp/check-ct-log",
    meta: check_45ct_45logJZne3aLxGhMeta || {},
    alias: check_45ct_45logJZne3aLxGhMeta?.alias || [],
    redirect: check_45ct_45logJZne3aLxGhMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/check-ct-log.vue").then(m => m.default || m)
  },
  {
    name: check_45ct_45logJZne3aLxGhMeta?.name ?? "check-ct-log___es",
    path: check_45ct_45logJZne3aLxGhMeta?.path ?? "/es/check-ct-log",
    meta: check_45ct_45logJZne3aLxGhMeta || {},
    alias: check_45ct_45logJZne3aLxGhMeta?.alias || [],
    redirect: check_45ct_45logJZne3aLxGhMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/check-ct-log.vue").then(m => m.default || m)
  },
  {
    name: check_45ct_45logJZne3aLxGhMeta?.name ?? "check-ct-log___fr",
    path: check_45ct_45logJZne3aLxGhMeta?.path ?? "/fr/check-ct-log",
    meta: check_45ct_45logJZne3aLxGhMeta || {},
    alias: check_45ct_45logJZne3aLxGhMeta?.alias || [],
    redirect: check_45ct_45logJZne3aLxGhMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/check-ct-log.vue").then(m => m.default || m)
  },
  {
    name: check_45ct_45logJZne3aLxGhMeta?.name ?? "check-ct-log___de",
    path: check_45ct_45logJZne3aLxGhMeta?.path ?? "/de/check-ct-log",
    meta: check_45ct_45logJZne3aLxGhMeta || {},
    alias: check_45ct_45logJZne3aLxGhMeta?.alias || [],
    redirect: check_45ct_45logJZne3aLxGhMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/check-ct-log.vue").then(m => m.default || m)
  },
  {
    name: check_45ct_45logJZne3aLxGhMeta?.name ?? "check-ct-log___kr",
    path: check_45ct_45logJZne3aLxGhMeta?.path ?? "/kr/check-ct-log",
    meta: check_45ct_45logJZne3aLxGhMeta || {},
    alias: check_45ct_45logJZne3aLxGhMeta?.alias || [],
    redirect: check_45ct_45logJZne3aLxGhMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/check-ct-log.vue").then(m => m.default || m)
  },
  {
    name: check_45ct_45logJZne3aLxGhMeta?.name ?? "check-ct-log___vn",
    path: check_45ct_45logJZne3aLxGhMeta?.path ?? "/vn/check-ct-log",
    meta: check_45ct_45logJZne3aLxGhMeta || {},
    alias: check_45ct_45logJZne3aLxGhMeta?.alias || [],
    redirect: check_45ct_45logJZne3aLxGhMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/check-ct-log.vue").then(m => m.default || m)
  },
  {
    name: check_45ct_45logJZne3aLxGhMeta?.name ?? "check-ct-log___th",
    path: check_45ct_45logJZne3aLxGhMeta?.path ?? "/th/check-ct-log",
    meta: check_45ct_45logJZne3aLxGhMeta || {},
    alias: check_45ct_45logJZne3aLxGhMeta?.alias || [],
    redirect: check_45ct_45logJZne3aLxGhMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/check-ct-log.vue").then(m => m.default || m)
  },
  {
    name: check_45ct_45logJZne3aLxGhMeta?.name ?? "check-ct-log___ru",
    path: check_45ct_45logJZne3aLxGhMeta?.path ?? "/ru/check-ct-log",
    meta: check_45ct_45logJZne3aLxGhMeta || {},
    alias: check_45ct_45logJZne3aLxGhMeta?.alias || [],
    redirect: check_45ct_45logJZne3aLxGhMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/check-ct-log.vue").then(m => m.default || m)
  },
  {
    name: check_45ct_45logJZne3aLxGhMeta?.name ?? "check-ct-log___tr",
    path: check_45ct_45logJZne3aLxGhMeta?.path ?? "/tr/check-ct-log",
    meta: check_45ct_45logJZne3aLxGhMeta || {},
    alias: check_45ct_45logJZne3aLxGhMeta?.alias || [],
    redirect: check_45ct_45logJZne3aLxGhMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/check-ct-log.vue").then(m => m.default || m)
  },
  {
    name: domaingEdVW4SaQIMeta?.name ?? "check-domain___en",
    path: domaingEdVW4SaQIMeta?.path ?? "/check/domain",
    meta: domaingEdVW4SaQIMeta || {},
    alias: domaingEdVW4SaQIMeta?.alias || [],
    redirect: domaingEdVW4SaQIMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/check/domain.vue").then(m => m.default || m)
  },
  {
    name: domaingEdVW4SaQIMeta?.name ?? "check-domain___zh-cn",
    path: domaingEdVW4SaQIMeta?.path ?? "/zh-cn/check/domain",
    meta: domaingEdVW4SaQIMeta || {},
    alias: domaingEdVW4SaQIMeta?.alias || [],
    redirect: domaingEdVW4SaQIMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/check/domain.vue").then(m => m.default || m)
  },
  {
    name: domaingEdVW4SaQIMeta?.name ?? "check-domain___zh-tw",
    path: domaingEdVW4SaQIMeta?.path ?? "/zh-tw/check/domain",
    meta: domaingEdVW4SaQIMeta || {},
    alias: domaingEdVW4SaQIMeta?.alias || [],
    redirect: domaingEdVW4SaQIMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/check/domain.vue").then(m => m.default || m)
  },
  {
    name: domaingEdVW4SaQIMeta?.name ?? "check-domain___jp",
    path: domaingEdVW4SaQIMeta?.path ?? "/jp/check/domain",
    meta: domaingEdVW4SaQIMeta || {},
    alias: domaingEdVW4SaQIMeta?.alias || [],
    redirect: domaingEdVW4SaQIMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/check/domain.vue").then(m => m.default || m)
  },
  {
    name: domaingEdVW4SaQIMeta?.name ?? "check-domain___es",
    path: domaingEdVW4SaQIMeta?.path ?? "/es/check/domain",
    meta: domaingEdVW4SaQIMeta || {},
    alias: domaingEdVW4SaQIMeta?.alias || [],
    redirect: domaingEdVW4SaQIMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/check/domain.vue").then(m => m.default || m)
  },
  {
    name: domaingEdVW4SaQIMeta?.name ?? "check-domain___fr",
    path: domaingEdVW4SaQIMeta?.path ?? "/fr/check/domain",
    meta: domaingEdVW4SaQIMeta || {},
    alias: domaingEdVW4SaQIMeta?.alias || [],
    redirect: domaingEdVW4SaQIMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/check/domain.vue").then(m => m.default || m)
  },
  {
    name: domaingEdVW4SaQIMeta?.name ?? "check-domain___de",
    path: domaingEdVW4SaQIMeta?.path ?? "/de/check/domain",
    meta: domaingEdVW4SaQIMeta || {},
    alias: domaingEdVW4SaQIMeta?.alias || [],
    redirect: domaingEdVW4SaQIMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/check/domain.vue").then(m => m.default || m)
  },
  {
    name: domaingEdVW4SaQIMeta?.name ?? "check-domain___kr",
    path: domaingEdVW4SaQIMeta?.path ?? "/kr/check/domain",
    meta: domaingEdVW4SaQIMeta || {},
    alias: domaingEdVW4SaQIMeta?.alias || [],
    redirect: domaingEdVW4SaQIMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/check/domain.vue").then(m => m.default || m)
  },
  {
    name: domaingEdVW4SaQIMeta?.name ?? "check-domain___vn",
    path: domaingEdVW4SaQIMeta?.path ?? "/vn/check/domain",
    meta: domaingEdVW4SaQIMeta || {},
    alias: domaingEdVW4SaQIMeta?.alias || [],
    redirect: domaingEdVW4SaQIMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/check/domain.vue").then(m => m.default || m)
  },
  {
    name: domaingEdVW4SaQIMeta?.name ?? "check-domain___th",
    path: domaingEdVW4SaQIMeta?.path ?? "/th/check/domain",
    meta: domaingEdVW4SaQIMeta || {},
    alias: domaingEdVW4SaQIMeta?.alias || [],
    redirect: domaingEdVW4SaQIMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/check/domain.vue").then(m => m.default || m)
  },
  {
    name: domaingEdVW4SaQIMeta?.name ?? "check-domain___ru",
    path: domaingEdVW4SaQIMeta?.path ?? "/ru/check/domain",
    meta: domaingEdVW4SaQIMeta || {},
    alias: domaingEdVW4SaQIMeta?.alias || [],
    redirect: domaingEdVW4SaQIMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/check/domain.vue").then(m => m.default || m)
  },
  {
    name: domaingEdVW4SaQIMeta?.name ?? "check-domain___tr",
    path: domaingEdVW4SaQIMeta?.path ?? "/tr/check/domain",
    meta: domaingEdVW4SaQIMeta || {},
    alias: domaingEdVW4SaQIMeta?.alias || [],
    redirect: domaingEdVW4SaQIMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/check/domain.vue").then(m => m.default || m)
  },
  {
    name: clm_45sslpDWFpMZDgVMeta?.name ?? "clm-ssl___en",
    path: clm_45sslpDWFpMZDgVMeta?.path ?? "/clm-ssl",
    meta: clm_45sslpDWFpMZDgVMeta || {},
    alias: clm_45sslpDWFpMZDgVMeta?.alias || [],
    redirect: clm_45sslpDWFpMZDgVMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/clm-ssl.vue").then(m => m.default || m)
  },
  {
    name: clm_45sslpDWFpMZDgVMeta?.name ?? "clm-ssl___zh-cn",
    path: clm_45sslpDWFpMZDgVMeta?.path ?? "/zh-cn/clm-ssl",
    meta: clm_45sslpDWFpMZDgVMeta || {},
    alias: clm_45sslpDWFpMZDgVMeta?.alias || [],
    redirect: clm_45sslpDWFpMZDgVMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/clm-ssl.vue").then(m => m.default || m)
  },
  {
    name: clm_45sslpDWFpMZDgVMeta?.name ?? "clm-ssl___zh-tw",
    path: clm_45sslpDWFpMZDgVMeta?.path ?? "/zh-tw/clm-ssl",
    meta: clm_45sslpDWFpMZDgVMeta || {},
    alias: clm_45sslpDWFpMZDgVMeta?.alias || [],
    redirect: clm_45sslpDWFpMZDgVMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/clm-ssl.vue").then(m => m.default || m)
  },
  {
    name: clm_45sslpDWFpMZDgVMeta?.name ?? "clm-ssl___jp",
    path: clm_45sslpDWFpMZDgVMeta?.path ?? "/jp/clm-ssl",
    meta: clm_45sslpDWFpMZDgVMeta || {},
    alias: clm_45sslpDWFpMZDgVMeta?.alias || [],
    redirect: clm_45sslpDWFpMZDgVMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/clm-ssl.vue").then(m => m.default || m)
  },
  {
    name: clm_45sslpDWFpMZDgVMeta?.name ?? "clm-ssl___es",
    path: clm_45sslpDWFpMZDgVMeta?.path ?? "/es/clm-ssl",
    meta: clm_45sslpDWFpMZDgVMeta || {},
    alias: clm_45sslpDWFpMZDgVMeta?.alias || [],
    redirect: clm_45sslpDWFpMZDgVMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/clm-ssl.vue").then(m => m.default || m)
  },
  {
    name: clm_45sslpDWFpMZDgVMeta?.name ?? "clm-ssl___fr",
    path: clm_45sslpDWFpMZDgVMeta?.path ?? "/fr/clm-ssl",
    meta: clm_45sslpDWFpMZDgVMeta || {},
    alias: clm_45sslpDWFpMZDgVMeta?.alias || [],
    redirect: clm_45sslpDWFpMZDgVMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/clm-ssl.vue").then(m => m.default || m)
  },
  {
    name: clm_45sslpDWFpMZDgVMeta?.name ?? "clm-ssl___de",
    path: clm_45sslpDWFpMZDgVMeta?.path ?? "/de/clm-ssl",
    meta: clm_45sslpDWFpMZDgVMeta || {},
    alias: clm_45sslpDWFpMZDgVMeta?.alias || [],
    redirect: clm_45sslpDWFpMZDgVMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/clm-ssl.vue").then(m => m.default || m)
  },
  {
    name: clm_45sslpDWFpMZDgVMeta?.name ?? "clm-ssl___kr",
    path: clm_45sslpDWFpMZDgVMeta?.path ?? "/kr/clm-ssl",
    meta: clm_45sslpDWFpMZDgVMeta || {},
    alias: clm_45sslpDWFpMZDgVMeta?.alias || [],
    redirect: clm_45sslpDWFpMZDgVMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/clm-ssl.vue").then(m => m.default || m)
  },
  {
    name: clm_45sslpDWFpMZDgVMeta?.name ?? "clm-ssl___vn",
    path: clm_45sslpDWFpMZDgVMeta?.path ?? "/vn/clm-ssl",
    meta: clm_45sslpDWFpMZDgVMeta || {},
    alias: clm_45sslpDWFpMZDgVMeta?.alias || [],
    redirect: clm_45sslpDWFpMZDgVMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/clm-ssl.vue").then(m => m.default || m)
  },
  {
    name: clm_45sslpDWFpMZDgVMeta?.name ?? "clm-ssl___th",
    path: clm_45sslpDWFpMZDgVMeta?.path ?? "/th/clm-ssl",
    meta: clm_45sslpDWFpMZDgVMeta || {},
    alias: clm_45sslpDWFpMZDgVMeta?.alias || [],
    redirect: clm_45sslpDWFpMZDgVMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/clm-ssl.vue").then(m => m.default || m)
  },
  {
    name: clm_45sslpDWFpMZDgVMeta?.name ?? "clm-ssl___ru",
    path: clm_45sslpDWFpMZDgVMeta?.path ?? "/ru/clm-ssl",
    meta: clm_45sslpDWFpMZDgVMeta || {},
    alias: clm_45sslpDWFpMZDgVMeta?.alias || [],
    redirect: clm_45sslpDWFpMZDgVMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/clm-ssl.vue").then(m => m.default || m)
  },
  {
    name: clm_45sslpDWFpMZDgVMeta?.name ?? "clm-ssl___tr",
    path: clm_45sslpDWFpMZDgVMeta?.path ?? "/tr/clm-ssl",
    meta: clm_45sslpDWFpMZDgVMeta || {},
    alias: clm_45sslpDWFpMZDgVMeta?.alias || [],
    redirect: clm_45sslpDWFpMZDgVMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/clm-ssl.vue").then(m => m.default || m)
  },
  {
    name: clmQYxAWciJjWMeta?.name ?? "clm___en",
    path: clmQYxAWciJjWMeta?.path ?? "/clm",
    meta: clmQYxAWciJjWMeta || {},
    alias: clmQYxAWciJjWMeta?.alias || [],
    redirect: clmQYxAWciJjWMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/clm.vue").then(m => m.default || m)
  },
  {
    name: clmQYxAWciJjWMeta?.name ?? "clm___zh-cn",
    path: clmQYxAWciJjWMeta?.path ?? "/zh-cn/clm",
    meta: clmQYxAWciJjWMeta || {},
    alias: clmQYxAWciJjWMeta?.alias || [],
    redirect: clmQYxAWciJjWMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/clm.vue").then(m => m.default || m)
  },
  {
    name: clmQYxAWciJjWMeta?.name ?? "clm___zh-tw",
    path: clmQYxAWciJjWMeta?.path ?? "/zh-tw/clm",
    meta: clmQYxAWciJjWMeta || {},
    alias: clmQYxAWciJjWMeta?.alias || [],
    redirect: clmQYxAWciJjWMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/clm.vue").then(m => m.default || m)
  },
  {
    name: clmQYxAWciJjWMeta?.name ?? "clm___jp",
    path: clmQYxAWciJjWMeta?.path ?? "/jp/clm",
    meta: clmQYxAWciJjWMeta || {},
    alias: clmQYxAWciJjWMeta?.alias || [],
    redirect: clmQYxAWciJjWMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/clm.vue").then(m => m.default || m)
  },
  {
    name: clmQYxAWciJjWMeta?.name ?? "clm___es",
    path: clmQYxAWciJjWMeta?.path ?? "/es/clm",
    meta: clmQYxAWciJjWMeta || {},
    alias: clmQYxAWciJjWMeta?.alias || [],
    redirect: clmQYxAWciJjWMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/clm.vue").then(m => m.default || m)
  },
  {
    name: clmQYxAWciJjWMeta?.name ?? "clm___fr",
    path: clmQYxAWciJjWMeta?.path ?? "/fr/clm",
    meta: clmQYxAWciJjWMeta || {},
    alias: clmQYxAWciJjWMeta?.alias || [],
    redirect: clmQYxAWciJjWMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/clm.vue").then(m => m.default || m)
  },
  {
    name: clmQYxAWciJjWMeta?.name ?? "clm___de",
    path: clmQYxAWciJjWMeta?.path ?? "/de/clm",
    meta: clmQYxAWciJjWMeta || {},
    alias: clmQYxAWciJjWMeta?.alias || [],
    redirect: clmQYxAWciJjWMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/clm.vue").then(m => m.default || m)
  },
  {
    name: clmQYxAWciJjWMeta?.name ?? "clm___kr",
    path: clmQYxAWciJjWMeta?.path ?? "/kr/clm",
    meta: clmQYxAWciJjWMeta || {},
    alias: clmQYxAWciJjWMeta?.alias || [],
    redirect: clmQYxAWciJjWMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/clm.vue").then(m => m.default || m)
  },
  {
    name: clmQYxAWciJjWMeta?.name ?? "clm___vn",
    path: clmQYxAWciJjWMeta?.path ?? "/vn/clm",
    meta: clmQYxAWciJjWMeta || {},
    alias: clmQYxAWciJjWMeta?.alias || [],
    redirect: clmQYxAWciJjWMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/clm.vue").then(m => m.default || m)
  },
  {
    name: clmQYxAWciJjWMeta?.name ?? "clm___th",
    path: clmQYxAWciJjWMeta?.path ?? "/th/clm",
    meta: clmQYxAWciJjWMeta || {},
    alias: clmQYxAWciJjWMeta?.alias || [],
    redirect: clmQYxAWciJjWMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/clm.vue").then(m => m.default || m)
  },
  {
    name: clmQYxAWciJjWMeta?.name ?? "clm___ru",
    path: clmQYxAWciJjWMeta?.path ?? "/ru/clm",
    meta: clmQYxAWciJjWMeta || {},
    alias: clmQYxAWciJjWMeta?.alias || [],
    redirect: clmQYxAWciJjWMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/clm.vue").then(m => m.default || m)
  },
  {
    name: clmQYxAWciJjWMeta?.name ?? "clm___tr",
    path: clmQYxAWciJjWMeta?.path ?? "/tr/clm",
    meta: clmQYxAWciJjWMeta || {},
    alias: clmQYxAWciJjWMeta?.alias || [],
    redirect: clmQYxAWciJjWMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/clm.vue").then(m => m.default || m)
  },
  {
    name: cloud_45code_45signingXnBZAsXZoOMeta?.name ?? "cloud-code-signing___en",
    path: cloud_45code_45signingXnBZAsXZoOMeta?.path ?? "/cloud-code-signing",
    meta: cloud_45code_45signingXnBZAsXZoOMeta || {},
    alias: cloud_45code_45signingXnBZAsXZoOMeta?.alias || [],
    redirect: cloud_45code_45signingXnBZAsXZoOMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/cloud-code-signing.vue").then(m => m.default || m)
  },
  {
    name: cloud_45code_45signingXnBZAsXZoOMeta?.name ?? "cloud-code-signing___zh-cn",
    path: cloud_45code_45signingXnBZAsXZoOMeta?.path ?? "/zh-cn/cloud-code-signing",
    meta: cloud_45code_45signingXnBZAsXZoOMeta || {},
    alias: cloud_45code_45signingXnBZAsXZoOMeta?.alias || [],
    redirect: cloud_45code_45signingXnBZAsXZoOMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/cloud-code-signing.vue").then(m => m.default || m)
  },
  {
    name: cloud_45code_45signingXnBZAsXZoOMeta?.name ?? "cloud-code-signing___zh-tw",
    path: cloud_45code_45signingXnBZAsXZoOMeta?.path ?? "/zh-tw/cloud-code-signing",
    meta: cloud_45code_45signingXnBZAsXZoOMeta || {},
    alias: cloud_45code_45signingXnBZAsXZoOMeta?.alias || [],
    redirect: cloud_45code_45signingXnBZAsXZoOMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/cloud-code-signing.vue").then(m => m.default || m)
  },
  {
    name: cloud_45code_45signingXnBZAsXZoOMeta?.name ?? "cloud-code-signing___jp",
    path: cloud_45code_45signingXnBZAsXZoOMeta?.path ?? "/jp/cloud-code-signing",
    meta: cloud_45code_45signingXnBZAsXZoOMeta || {},
    alias: cloud_45code_45signingXnBZAsXZoOMeta?.alias || [],
    redirect: cloud_45code_45signingXnBZAsXZoOMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/cloud-code-signing.vue").then(m => m.default || m)
  },
  {
    name: cloud_45code_45signingXnBZAsXZoOMeta?.name ?? "cloud-code-signing___es",
    path: cloud_45code_45signingXnBZAsXZoOMeta?.path ?? "/es/cloud-code-signing",
    meta: cloud_45code_45signingXnBZAsXZoOMeta || {},
    alias: cloud_45code_45signingXnBZAsXZoOMeta?.alias || [],
    redirect: cloud_45code_45signingXnBZAsXZoOMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/cloud-code-signing.vue").then(m => m.default || m)
  },
  {
    name: cloud_45code_45signingXnBZAsXZoOMeta?.name ?? "cloud-code-signing___fr",
    path: cloud_45code_45signingXnBZAsXZoOMeta?.path ?? "/fr/cloud-code-signing",
    meta: cloud_45code_45signingXnBZAsXZoOMeta || {},
    alias: cloud_45code_45signingXnBZAsXZoOMeta?.alias || [],
    redirect: cloud_45code_45signingXnBZAsXZoOMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/cloud-code-signing.vue").then(m => m.default || m)
  },
  {
    name: cloud_45code_45signingXnBZAsXZoOMeta?.name ?? "cloud-code-signing___de",
    path: cloud_45code_45signingXnBZAsXZoOMeta?.path ?? "/de/cloud-code-signing",
    meta: cloud_45code_45signingXnBZAsXZoOMeta || {},
    alias: cloud_45code_45signingXnBZAsXZoOMeta?.alias || [],
    redirect: cloud_45code_45signingXnBZAsXZoOMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/cloud-code-signing.vue").then(m => m.default || m)
  },
  {
    name: cloud_45code_45signingXnBZAsXZoOMeta?.name ?? "cloud-code-signing___kr",
    path: cloud_45code_45signingXnBZAsXZoOMeta?.path ?? "/kr/cloud-code-signing",
    meta: cloud_45code_45signingXnBZAsXZoOMeta || {},
    alias: cloud_45code_45signingXnBZAsXZoOMeta?.alias || [],
    redirect: cloud_45code_45signingXnBZAsXZoOMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/cloud-code-signing.vue").then(m => m.default || m)
  },
  {
    name: cloud_45code_45signingXnBZAsXZoOMeta?.name ?? "cloud-code-signing___vn",
    path: cloud_45code_45signingXnBZAsXZoOMeta?.path ?? "/vn/cloud-code-signing",
    meta: cloud_45code_45signingXnBZAsXZoOMeta || {},
    alias: cloud_45code_45signingXnBZAsXZoOMeta?.alias || [],
    redirect: cloud_45code_45signingXnBZAsXZoOMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/cloud-code-signing.vue").then(m => m.default || m)
  },
  {
    name: cloud_45code_45signingXnBZAsXZoOMeta?.name ?? "cloud-code-signing___th",
    path: cloud_45code_45signingXnBZAsXZoOMeta?.path ?? "/th/cloud-code-signing",
    meta: cloud_45code_45signingXnBZAsXZoOMeta || {},
    alias: cloud_45code_45signingXnBZAsXZoOMeta?.alias || [],
    redirect: cloud_45code_45signingXnBZAsXZoOMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/cloud-code-signing.vue").then(m => m.default || m)
  },
  {
    name: cloud_45code_45signingXnBZAsXZoOMeta?.name ?? "cloud-code-signing___ru",
    path: cloud_45code_45signingXnBZAsXZoOMeta?.path ?? "/ru/cloud-code-signing",
    meta: cloud_45code_45signingXnBZAsXZoOMeta || {},
    alias: cloud_45code_45signingXnBZAsXZoOMeta?.alias || [],
    redirect: cloud_45code_45signingXnBZAsXZoOMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/cloud-code-signing.vue").then(m => m.default || m)
  },
  {
    name: cloud_45code_45signingXnBZAsXZoOMeta?.name ?? "cloud-code-signing___tr",
    path: cloud_45code_45signingXnBZAsXZoOMeta?.path ?? "/tr/cloud-code-signing",
    meta: cloud_45code_45signingXnBZAsXZoOMeta || {},
    alias: cloud_45code_45signingXnBZAsXZoOMeta?.alias || [],
    redirect: cloud_45code_45signingXnBZAsXZoOMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/cloud-code-signing.vue").then(m => m.default || m)
  },
  {
    name: cloud_45mpkiYe6EurE5MgMeta?.name ?? "cloud-mpki___en",
    path: cloud_45mpkiYe6EurE5MgMeta?.path ?? "/cloud-mpki",
    meta: cloud_45mpkiYe6EurE5MgMeta || {},
    alias: cloud_45mpkiYe6EurE5MgMeta?.alias || [],
    redirect: cloud_45mpkiYe6EurE5MgMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/cloud-mpki.vue").then(m => m.default || m)
  },
  {
    name: cloud_45mpkiYe6EurE5MgMeta?.name ?? "cloud-mpki___zh-cn",
    path: cloud_45mpkiYe6EurE5MgMeta?.path ?? "/zh-cn/cloud-mpki",
    meta: cloud_45mpkiYe6EurE5MgMeta || {},
    alias: cloud_45mpkiYe6EurE5MgMeta?.alias || [],
    redirect: cloud_45mpkiYe6EurE5MgMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/cloud-mpki.vue").then(m => m.default || m)
  },
  {
    name: cloud_45mpkiYe6EurE5MgMeta?.name ?? "cloud-mpki___zh-tw",
    path: cloud_45mpkiYe6EurE5MgMeta?.path ?? "/zh-tw/cloud-mpki",
    meta: cloud_45mpkiYe6EurE5MgMeta || {},
    alias: cloud_45mpkiYe6EurE5MgMeta?.alias || [],
    redirect: cloud_45mpkiYe6EurE5MgMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/cloud-mpki.vue").then(m => m.default || m)
  },
  {
    name: cloud_45mpkiYe6EurE5MgMeta?.name ?? "cloud-mpki___jp",
    path: cloud_45mpkiYe6EurE5MgMeta?.path ?? "/jp/cloud-mpki",
    meta: cloud_45mpkiYe6EurE5MgMeta || {},
    alias: cloud_45mpkiYe6EurE5MgMeta?.alias || [],
    redirect: cloud_45mpkiYe6EurE5MgMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/cloud-mpki.vue").then(m => m.default || m)
  },
  {
    name: cloud_45mpkiYe6EurE5MgMeta?.name ?? "cloud-mpki___es",
    path: cloud_45mpkiYe6EurE5MgMeta?.path ?? "/es/cloud-mpki",
    meta: cloud_45mpkiYe6EurE5MgMeta || {},
    alias: cloud_45mpkiYe6EurE5MgMeta?.alias || [],
    redirect: cloud_45mpkiYe6EurE5MgMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/cloud-mpki.vue").then(m => m.default || m)
  },
  {
    name: cloud_45mpkiYe6EurE5MgMeta?.name ?? "cloud-mpki___fr",
    path: cloud_45mpkiYe6EurE5MgMeta?.path ?? "/fr/cloud-mpki",
    meta: cloud_45mpkiYe6EurE5MgMeta || {},
    alias: cloud_45mpkiYe6EurE5MgMeta?.alias || [],
    redirect: cloud_45mpkiYe6EurE5MgMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/cloud-mpki.vue").then(m => m.default || m)
  },
  {
    name: cloud_45mpkiYe6EurE5MgMeta?.name ?? "cloud-mpki___de",
    path: cloud_45mpkiYe6EurE5MgMeta?.path ?? "/de/cloud-mpki",
    meta: cloud_45mpkiYe6EurE5MgMeta || {},
    alias: cloud_45mpkiYe6EurE5MgMeta?.alias || [],
    redirect: cloud_45mpkiYe6EurE5MgMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/cloud-mpki.vue").then(m => m.default || m)
  },
  {
    name: cloud_45mpkiYe6EurE5MgMeta?.name ?? "cloud-mpki___kr",
    path: cloud_45mpkiYe6EurE5MgMeta?.path ?? "/kr/cloud-mpki",
    meta: cloud_45mpkiYe6EurE5MgMeta || {},
    alias: cloud_45mpkiYe6EurE5MgMeta?.alias || [],
    redirect: cloud_45mpkiYe6EurE5MgMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/cloud-mpki.vue").then(m => m.default || m)
  },
  {
    name: cloud_45mpkiYe6EurE5MgMeta?.name ?? "cloud-mpki___vn",
    path: cloud_45mpkiYe6EurE5MgMeta?.path ?? "/vn/cloud-mpki",
    meta: cloud_45mpkiYe6EurE5MgMeta || {},
    alias: cloud_45mpkiYe6EurE5MgMeta?.alias || [],
    redirect: cloud_45mpkiYe6EurE5MgMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/cloud-mpki.vue").then(m => m.default || m)
  },
  {
    name: cloud_45mpkiYe6EurE5MgMeta?.name ?? "cloud-mpki___th",
    path: cloud_45mpkiYe6EurE5MgMeta?.path ?? "/th/cloud-mpki",
    meta: cloud_45mpkiYe6EurE5MgMeta || {},
    alias: cloud_45mpkiYe6EurE5MgMeta?.alias || [],
    redirect: cloud_45mpkiYe6EurE5MgMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/cloud-mpki.vue").then(m => m.default || m)
  },
  {
    name: cloud_45mpkiYe6EurE5MgMeta?.name ?? "cloud-mpki___ru",
    path: cloud_45mpkiYe6EurE5MgMeta?.path ?? "/ru/cloud-mpki",
    meta: cloud_45mpkiYe6EurE5MgMeta || {},
    alias: cloud_45mpkiYe6EurE5MgMeta?.alias || [],
    redirect: cloud_45mpkiYe6EurE5MgMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/cloud-mpki.vue").then(m => m.default || m)
  },
  {
    name: cloud_45mpkiYe6EurE5MgMeta?.name ?? "cloud-mpki___tr",
    path: cloud_45mpkiYe6EurE5MgMeta?.path ?? "/tr/cloud-mpki",
    meta: cloud_45mpkiYe6EurE5MgMeta || {},
    alias: cloud_45mpkiYe6EurE5MgMeta?.alias || [],
    redirect: cloud_45mpkiYe6EurE5MgMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/cloud-mpki.vue").then(m => m.default || m)
  },
  {
    name: code_45signing_45certificateE0rqJiDF66Meta?.name ?? "code-signing-certificate___en",
    path: code_45signing_45certificateE0rqJiDF66Meta?.path ?? "/code-signing-certificate",
    meta: code_45signing_45certificateE0rqJiDF66Meta || {},
    alias: code_45signing_45certificateE0rqJiDF66Meta?.alias || [],
    redirect: code_45signing_45certificateE0rqJiDF66Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/code-signing-certificate.vue").then(m => m.default || m)
  },
  {
    name: code_45signing_45certificateE0rqJiDF66Meta?.name ?? "code-signing-certificate___zh-cn",
    path: code_45signing_45certificateE0rqJiDF66Meta?.path ?? "/zh-cn/code-signing-certificate",
    meta: code_45signing_45certificateE0rqJiDF66Meta || {},
    alias: code_45signing_45certificateE0rqJiDF66Meta?.alias || [],
    redirect: code_45signing_45certificateE0rqJiDF66Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/code-signing-certificate.vue").then(m => m.default || m)
  },
  {
    name: code_45signing_45certificateE0rqJiDF66Meta?.name ?? "code-signing-certificate___zh-tw",
    path: code_45signing_45certificateE0rqJiDF66Meta?.path ?? "/zh-tw/code-signing-certificate",
    meta: code_45signing_45certificateE0rqJiDF66Meta || {},
    alias: code_45signing_45certificateE0rqJiDF66Meta?.alias || [],
    redirect: code_45signing_45certificateE0rqJiDF66Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/code-signing-certificate.vue").then(m => m.default || m)
  },
  {
    name: code_45signing_45certificateE0rqJiDF66Meta?.name ?? "code-signing-certificate___jp",
    path: code_45signing_45certificateE0rqJiDF66Meta?.path ?? "/jp/code-signing-certificate",
    meta: code_45signing_45certificateE0rqJiDF66Meta || {},
    alias: code_45signing_45certificateE0rqJiDF66Meta?.alias || [],
    redirect: code_45signing_45certificateE0rqJiDF66Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/code-signing-certificate.vue").then(m => m.default || m)
  },
  {
    name: code_45signing_45certificateE0rqJiDF66Meta?.name ?? "code-signing-certificate___es",
    path: code_45signing_45certificateE0rqJiDF66Meta?.path ?? "/es/code-signing-certificate",
    meta: code_45signing_45certificateE0rqJiDF66Meta || {},
    alias: code_45signing_45certificateE0rqJiDF66Meta?.alias || [],
    redirect: code_45signing_45certificateE0rqJiDF66Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/code-signing-certificate.vue").then(m => m.default || m)
  },
  {
    name: code_45signing_45certificateE0rqJiDF66Meta?.name ?? "code-signing-certificate___fr",
    path: code_45signing_45certificateE0rqJiDF66Meta?.path ?? "/fr/code-signing-certificate",
    meta: code_45signing_45certificateE0rqJiDF66Meta || {},
    alias: code_45signing_45certificateE0rqJiDF66Meta?.alias || [],
    redirect: code_45signing_45certificateE0rqJiDF66Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/code-signing-certificate.vue").then(m => m.default || m)
  },
  {
    name: code_45signing_45certificateE0rqJiDF66Meta?.name ?? "code-signing-certificate___de",
    path: code_45signing_45certificateE0rqJiDF66Meta?.path ?? "/de/code-signing-certificate",
    meta: code_45signing_45certificateE0rqJiDF66Meta || {},
    alias: code_45signing_45certificateE0rqJiDF66Meta?.alias || [],
    redirect: code_45signing_45certificateE0rqJiDF66Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/code-signing-certificate.vue").then(m => m.default || m)
  },
  {
    name: code_45signing_45certificateE0rqJiDF66Meta?.name ?? "code-signing-certificate___kr",
    path: code_45signing_45certificateE0rqJiDF66Meta?.path ?? "/kr/code-signing-certificate",
    meta: code_45signing_45certificateE0rqJiDF66Meta || {},
    alias: code_45signing_45certificateE0rqJiDF66Meta?.alias || [],
    redirect: code_45signing_45certificateE0rqJiDF66Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/code-signing-certificate.vue").then(m => m.default || m)
  },
  {
    name: code_45signing_45certificateE0rqJiDF66Meta?.name ?? "code-signing-certificate___vn",
    path: code_45signing_45certificateE0rqJiDF66Meta?.path ?? "/vn/code-signing-certificate",
    meta: code_45signing_45certificateE0rqJiDF66Meta || {},
    alias: code_45signing_45certificateE0rqJiDF66Meta?.alias || [],
    redirect: code_45signing_45certificateE0rqJiDF66Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/code-signing-certificate.vue").then(m => m.default || m)
  },
  {
    name: code_45signing_45certificateE0rqJiDF66Meta?.name ?? "code-signing-certificate___th",
    path: code_45signing_45certificateE0rqJiDF66Meta?.path ?? "/th/code-signing-certificate",
    meta: code_45signing_45certificateE0rqJiDF66Meta || {},
    alias: code_45signing_45certificateE0rqJiDF66Meta?.alias || [],
    redirect: code_45signing_45certificateE0rqJiDF66Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/code-signing-certificate.vue").then(m => m.default || m)
  },
  {
    name: code_45signing_45certificateE0rqJiDF66Meta?.name ?? "code-signing-certificate___ru",
    path: code_45signing_45certificateE0rqJiDF66Meta?.path ?? "/ru/code-signing-certificate",
    meta: code_45signing_45certificateE0rqJiDF66Meta || {},
    alias: code_45signing_45certificateE0rqJiDF66Meta?.alias || [],
    redirect: code_45signing_45certificateE0rqJiDF66Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/code-signing-certificate.vue").then(m => m.default || m)
  },
  {
    name: code_45signing_45certificateE0rqJiDF66Meta?.name ?? "code-signing-certificate___tr",
    path: code_45signing_45certificateE0rqJiDF66Meta?.path ?? "/tr/code-signing-certificate",
    meta: code_45signing_45certificateE0rqJiDF66Meta || {},
    alias: code_45signing_45certificateE0rqJiDF66Meta?.alias || [],
    redirect: code_45signing_45certificateE0rqJiDF66Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/code-signing-certificate.vue").then(m => m.default || m)
  },
  {
    name: contactE9OT4OE3cGMeta?.name ?? "contact___en",
    path: contactE9OT4OE3cGMeta?.path ?? "/contact",
    meta: contactE9OT4OE3cGMeta || {},
    alias: contactE9OT4OE3cGMeta?.alias || [],
    redirect: contactE9OT4OE3cGMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: contactE9OT4OE3cGMeta?.name ?? "contact___zh-cn",
    path: contactE9OT4OE3cGMeta?.path ?? "/zh-cn/contact",
    meta: contactE9OT4OE3cGMeta || {},
    alias: contactE9OT4OE3cGMeta?.alias || [],
    redirect: contactE9OT4OE3cGMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: contactE9OT4OE3cGMeta?.name ?? "contact___zh-tw",
    path: contactE9OT4OE3cGMeta?.path ?? "/zh-tw/contact",
    meta: contactE9OT4OE3cGMeta || {},
    alias: contactE9OT4OE3cGMeta?.alias || [],
    redirect: contactE9OT4OE3cGMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: contactE9OT4OE3cGMeta?.name ?? "contact___jp",
    path: contactE9OT4OE3cGMeta?.path ?? "/jp/contact",
    meta: contactE9OT4OE3cGMeta || {},
    alias: contactE9OT4OE3cGMeta?.alias || [],
    redirect: contactE9OT4OE3cGMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: contactE9OT4OE3cGMeta?.name ?? "contact___es",
    path: contactE9OT4OE3cGMeta?.path ?? "/es/contact",
    meta: contactE9OT4OE3cGMeta || {},
    alias: contactE9OT4OE3cGMeta?.alias || [],
    redirect: contactE9OT4OE3cGMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: contactE9OT4OE3cGMeta?.name ?? "contact___fr",
    path: contactE9OT4OE3cGMeta?.path ?? "/fr/contact",
    meta: contactE9OT4OE3cGMeta || {},
    alias: contactE9OT4OE3cGMeta?.alias || [],
    redirect: contactE9OT4OE3cGMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: contactE9OT4OE3cGMeta?.name ?? "contact___de",
    path: contactE9OT4OE3cGMeta?.path ?? "/de/contact",
    meta: contactE9OT4OE3cGMeta || {},
    alias: contactE9OT4OE3cGMeta?.alias || [],
    redirect: contactE9OT4OE3cGMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: contactE9OT4OE3cGMeta?.name ?? "contact___kr",
    path: contactE9OT4OE3cGMeta?.path ?? "/kr/contact",
    meta: contactE9OT4OE3cGMeta || {},
    alias: contactE9OT4OE3cGMeta?.alias || [],
    redirect: contactE9OT4OE3cGMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: contactE9OT4OE3cGMeta?.name ?? "contact___vn",
    path: contactE9OT4OE3cGMeta?.path ?? "/vn/contact",
    meta: contactE9OT4OE3cGMeta || {},
    alias: contactE9OT4OE3cGMeta?.alias || [],
    redirect: contactE9OT4OE3cGMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: contactE9OT4OE3cGMeta?.name ?? "contact___th",
    path: contactE9OT4OE3cGMeta?.path ?? "/th/contact",
    meta: contactE9OT4OE3cGMeta || {},
    alias: contactE9OT4OE3cGMeta?.alias || [],
    redirect: contactE9OT4OE3cGMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: contactE9OT4OE3cGMeta?.name ?? "contact___ru",
    path: contactE9OT4OE3cGMeta?.path ?? "/ru/contact",
    meta: contactE9OT4OE3cGMeta || {},
    alias: contactE9OT4OE3cGMeta?.alias || [],
    redirect: contactE9OT4OE3cGMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: contactE9OT4OE3cGMeta?.name ?? "contact___tr",
    path: contactE9OT4OE3cGMeta?.path ?? "/tr/contact",
    meta: contactE9OT4OE3cGMeta || {},
    alias: contactE9OT4OE3cGMeta?.alias || [],
    redirect: contactE9OT4OE3cGMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/contact.vue").then(m => m.default || m)
  },
  {
    name: cpanel17mmSRhj04Meta?.name ?? "cpanel___en",
    path: cpanel17mmSRhj04Meta?.path ?? "/cpanel",
    meta: cpanel17mmSRhj04Meta || {},
    alias: cpanel17mmSRhj04Meta?.alias || [],
    redirect: cpanel17mmSRhj04Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/cpanel.vue").then(m => m.default || m)
  },
  {
    name: cpanel17mmSRhj04Meta?.name ?? "cpanel___zh-cn",
    path: cpanel17mmSRhj04Meta?.path ?? "/zh-cn/cpanel",
    meta: cpanel17mmSRhj04Meta || {},
    alias: cpanel17mmSRhj04Meta?.alias || [],
    redirect: cpanel17mmSRhj04Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/cpanel.vue").then(m => m.default || m)
  },
  {
    name: cpanel17mmSRhj04Meta?.name ?? "cpanel___zh-tw",
    path: cpanel17mmSRhj04Meta?.path ?? "/zh-tw/cpanel",
    meta: cpanel17mmSRhj04Meta || {},
    alias: cpanel17mmSRhj04Meta?.alias || [],
    redirect: cpanel17mmSRhj04Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/cpanel.vue").then(m => m.default || m)
  },
  {
    name: cpanel17mmSRhj04Meta?.name ?? "cpanel___jp",
    path: cpanel17mmSRhj04Meta?.path ?? "/jp/cpanel",
    meta: cpanel17mmSRhj04Meta || {},
    alias: cpanel17mmSRhj04Meta?.alias || [],
    redirect: cpanel17mmSRhj04Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/cpanel.vue").then(m => m.default || m)
  },
  {
    name: cpanel17mmSRhj04Meta?.name ?? "cpanel___es",
    path: cpanel17mmSRhj04Meta?.path ?? "/es/cpanel",
    meta: cpanel17mmSRhj04Meta || {},
    alias: cpanel17mmSRhj04Meta?.alias || [],
    redirect: cpanel17mmSRhj04Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/cpanel.vue").then(m => m.default || m)
  },
  {
    name: cpanel17mmSRhj04Meta?.name ?? "cpanel___fr",
    path: cpanel17mmSRhj04Meta?.path ?? "/fr/cpanel",
    meta: cpanel17mmSRhj04Meta || {},
    alias: cpanel17mmSRhj04Meta?.alias || [],
    redirect: cpanel17mmSRhj04Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/cpanel.vue").then(m => m.default || m)
  },
  {
    name: cpanel17mmSRhj04Meta?.name ?? "cpanel___de",
    path: cpanel17mmSRhj04Meta?.path ?? "/de/cpanel",
    meta: cpanel17mmSRhj04Meta || {},
    alias: cpanel17mmSRhj04Meta?.alias || [],
    redirect: cpanel17mmSRhj04Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/cpanel.vue").then(m => m.default || m)
  },
  {
    name: cpanel17mmSRhj04Meta?.name ?? "cpanel___kr",
    path: cpanel17mmSRhj04Meta?.path ?? "/kr/cpanel",
    meta: cpanel17mmSRhj04Meta || {},
    alias: cpanel17mmSRhj04Meta?.alias || [],
    redirect: cpanel17mmSRhj04Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/cpanel.vue").then(m => m.default || m)
  },
  {
    name: cpanel17mmSRhj04Meta?.name ?? "cpanel___vn",
    path: cpanel17mmSRhj04Meta?.path ?? "/vn/cpanel",
    meta: cpanel17mmSRhj04Meta || {},
    alias: cpanel17mmSRhj04Meta?.alias || [],
    redirect: cpanel17mmSRhj04Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/cpanel.vue").then(m => m.default || m)
  },
  {
    name: cpanel17mmSRhj04Meta?.name ?? "cpanel___th",
    path: cpanel17mmSRhj04Meta?.path ?? "/th/cpanel",
    meta: cpanel17mmSRhj04Meta || {},
    alias: cpanel17mmSRhj04Meta?.alias || [],
    redirect: cpanel17mmSRhj04Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/cpanel.vue").then(m => m.default || m)
  },
  {
    name: cpanel17mmSRhj04Meta?.name ?? "cpanel___ru",
    path: cpanel17mmSRhj04Meta?.path ?? "/ru/cpanel",
    meta: cpanel17mmSRhj04Meta || {},
    alias: cpanel17mmSRhj04Meta?.alias || [],
    redirect: cpanel17mmSRhj04Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/cpanel.vue").then(m => m.default || m)
  },
  {
    name: cpanel17mmSRhj04Meta?.name ?? "cpanel___tr",
    path: cpanel17mmSRhj04Meta?.path ?? "/tr/cpanel",
    meta: cpanel17mmSRhj04Meta || {},
    alias: cpanel17mmSRhj04Meta?.alias || [],
    redirect: cpanel17mmSRhj04Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/cpanel.vue").then(m => m.default || m)
  },
  {
    name: csr_45decoderuQU5laFg5hMeta?.name ?? "csr-decoder___en",
    path: csr_45decoderuQU5laFg5hMeta?.path ?? "/csr-decoder",
    meta: csr_45decoderuQU5laFg5hMeta || {},
    alias: csr_45decoderuQU5laFg5hMeta?.alias || [],
    redirect: csr_45decoderuQU5laFg5hMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/csr-decoder.vue").then(m => m.default || m)
  },
  {
    name: csr_45decoderuQU5laFg5hMeta?.name ?? "csr-decoder___zh-cn",
    path: csr_45decoderuQU5laFg5hMeta?.path ?? "/zh-cn/csr-decoder",
    meta: csr_45decoderuQU5laFg5hMeta || {},
    alias: csr_45decoderuQU5laFg5hMeta?.alias || [],
    redirect: csr_45decoderuQU5laFg5hMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/csr-decoder.vue").then(m => m.default || m)
  },
  {
    name: csr_45decoderuQU5laFg5hMeta?.name ?? "csr-decoder___zh-tw",
    path: csr_45decoderuQU5laFg5hMeta?.path ?? "/zh-tw/csr-decoder",
    meta: csr_45decoderuQU5laFg5hMeta || {},
    alias: csr_45decoderuQU5laFg5hMeta?.alias || [],
    redirect: csr_45decoderuQU5laFg5hMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/csr-decoder.vue").then(m => m.default || m)
  },
  {
    name: csr_45decoderuQU5laFg5hMeta?.name ?? "csr-decoder___jp",
    path: csr_45decoderuQU5laFg5hMeta?.path ?? "/jp/csr-decoder",
    meta: csr_45decoderuQU5laFg5hMeta || {},
    alias: csr_45decoderuQU5laFg5hMeta?.alias || [],
    redirect: csr_45decoderuQU5laFg5hMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/csr-decoder.vue").then(m => m.default || m)
  },
  {
    name: csr_45decoderuQU5laFg5hMeta?.name ?? "csr-decoder___es",
    path: csr_45decoderuQU5laFg5hMeta?.path ?? "/es/csr-decoder",
    meta: csr_45decoderuQU5laFg5hMeta || {},
    alias: csr_45decoderuQU5laFg5hMeta?.alias || [],
    redirect: csr_45decoderuQU5laFg5hMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/csr-decoder.vue").then(m => m.default || m)
  },
  {
    name: csr_45decoderuQU5laFg5hMeta?.name ?? "csr-decoder___fr",
    path: csr_45decoderuQU5laFg5hMeta?.path ?? "/fr/csr-decoder",
    meta: csr_45decoderuQU5laFg5hMeta || {},
    alias: csr_45decoderuQU5laFg5hMeta?.alias || [],
    redirect: csr_45decoderuQU5laFg5hMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/csr-decoder.vue").then(m => m.default || m)
  },
  {
    name: csr_45decoderuQU5laFg5hMeta?.name ?? "csr-decoder___de",
    path: csr_45decoderuQU5laFg5hMeta?.path ?? "/de/csr-decoder",
    meta: csr_45decoderuQU5laFg5hMeta || {},
    alias: csr_45decoderuQU5laFg5hMeta?.alias || [],
    redirect: csr_45decoderuQU5laFg5hMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/csr-decoder.vue").then(m => m.default || m)
  },
  {
    name: csr_45decoderuQU5laFg5hMeta?.name ?? "csr-decoder___kr",
    path: csr_45decoderuQU5laFg5hMeta?.path ?? "/kr/csr-decoder",
    meta: csr_45decoderuQU5laFg5hMeta || {},
    alias: csr_45decoderuQU5laFg5hMeta?.alias || [],
    redirect: csr_45decoderuQU5laFg5hMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/csr-decoder.vue").then(m => m.default || m)
  },
  {
    name: csr_45decoderuQU5laFg5hMeta?.name ?? "csr-decoder___vn",
    path: csr_45decoderuQU5laFg5hMeta?.path ?? "/vn/csr-decoder",
    meta: csr_45decoderuQU5laFg5hMeta || {},
    alias: csr_45decoderuQU5laFg5hMeta?.alias || [],
    redirect: csr_45decoderuQU5laFg5hMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/csr-decoder.vue").then(m => m.default || m)
  },
  {
    name: csr_45decoderuQU5laFg5hMeta?.name ?? "csr-decoder___th",
    path: csr_45decoderuQU5laFg5hMeta?.path ?? "/th/csr-decoder",
    meta: csr_45decoderuQU5laFg5hMeta || {},
    alias: csr_45decoderuQU5laFg5hMeta?.alias || [],
    redirect: csr_45decoderuQU5laFg5hMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/csr-decoder.vue").then(m => m.default || m)
  },
  {
    name: csr_45decoderuQU5laFg5hMeta?.name ?? "csr-decoder___ru",
    path: csr_45decoderuQU5laFg5hMeta?.path ?? "/ru/csr-decoder",
    meta: csr_45decoderuQU5laFg5hMeta || {},
    alias: csr_45decoderuQU5laFg5hMeta?.alias || [],
    redirect: csr_45decoderuQU5laFg5hMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/csr-decoder.vue").then(m => m.default || m)
  },
  {
    name: csr_45decoderuQU5laFg5hMeta?.name ?? "csr-decoder___tr",
    path: csr_45decoderuQU5laFg5hMeta?.path ?? "/tr/csr-decoder",
    meta: csr_45decoderuQU5laFg5hMeta || {},
    alias: csr_45decoderuQU5laFg5hMeta?.alias || [],
    redirect: csr_45decoderuQU5laFg5hMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/csr-decoder.vue").then(m => m.default || m)
  },
  {
    name: dns_45lookup0hGVZAd7y3Meta?.name ?? "dns-lookup___en",
    path: dns_45lookup0hGVZAd7y3Meta?.path ?? "/dns-lookup",
    meta: dns_45lookup0hGVZAd7y3Meta || {},
    alias: dns_45lookup0hGVZAd7y3Meta?.alias || [],
    redirect: dns_45lookup0hGVZAd7y3Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/dns-lookup.vue").then(m => m.default || m)
  },
  {
    name: dns_45lookup0hGVZAd7y3Meta?.name ?? "dns-lookup___zh-cn",
    path: dns_45lookup0hGVZAd7y3Meta?.path ?? "/zh-cn/dns-lookup",
    meta: dns_45lookup0hGVZAd7y3Meta || {},
    alias: dns_45lookup0hGVZAd7y3Meta?.alias || [],
    redirect: dns_45lookup0hGVZAd7y3Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/dns-lookup.vue").then(m => m.default || m)
  },
  {
    name: dns_45lookup0hGVZAd7y3Meta?.name ?? "dns-lookup___zh-tw",
    path: dns_45lookup0hGVZAd7y3Meta?.path ?? "/zh-tw/dns-lookup",
    meta: dns_45lookup0hGVZAd7y3Meta || {},
    alias: dns_45lookup0hGVZAd7y3Meta?.alias || [],
    redirect: dns_45lookup0hGVZAd7y3Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/dns-lookup.vue").then(m => m.default || m)
  },
  {
    name: dns_45lookup0hGVZAd7y3Meta?.name ?? "dns-lookup___jp",
    path: dns_45lookup0hGVZAd7y3Meta?.path ?? "/jp/dns-lookup",
    meta: dns_45lookup0hGVZAd7y3Meta || {},
    alias: dns_45lookup0hGVZAd7y3Meta?.alias || [],
    redirect: dns_45lookup0hGVZAd7y3Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/dns-lookup.vue").then(m => m.default || m)
  },
  {
    name: dns_45lookup0hGVZAd7y3Meta?.name ?? "dns-lookup___es",
    path: dns_45lookup0hGVZAd7y3Meta?.path ?? "/es/dns-lookup",
    meta: dns_45lookup0hGVZAd7y3Meta || {},
    alias: dns_45lookup0hGVZAd7y3Meta?.alias || [],
    redirect: dns_45lookup0hGVZAd7y3Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/dns-lookup.vue").then(m => m.default || m)
  },
  {
    name: dns_45lookup0hGVZAd7y3Meta?.name ?? "dns-lookup___fr",
    path: dns_45lookup0hGVZAd7y3Meta?.path ?? "/fr/dns-lookup",
    meta: dns_45lookup0hGVZAd7y3Meta || {},
    alias: dns_45lookup0hGVZAd7y3Meta?.alias || [],
    redirect: dns_45lookup0hGVZAd7y3Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/dns-lookup.vue").then(m => m.default || m)
  },
  {
    name: dns_45lookup0hGVZAd7y3Meta?.name ?? "dns-lookup___de",
    path: dns_45lookup0hGVZAd7y3Meta?.path ?? "/de/dns-lookup",
    meta: dns_45lookup0hGVZAd7y3Meta || {},
    alias: dns_45lookup0hGVZAd7y3Meta?.alias || [],
    redirect: dns_45lookup0hGVZAd7y3Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/dns-lookup.vue").then(m => m.default || m)
  },
  {
    name: dns_45lookup0hGVZAd7y3Meta?.name ?? "dns-lookup___kr",
    path: dns_45lookup0hGVZAd7y3Meta?.path ?? "/kr/dns-lookup",
    meta: dns_45lookup0hGVZAd7y3Meta || {},
    alias: dns_45lookup0hGVZAd7y3Meta?.alias || [],
    redirect: dns_45lookup0hGVZAd7y3Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/dns-lookup.vue").then(m => m.default || m)
  },
  {
    name: dns_45lookup0hGVZAd7y3Meta?.name ?? "dns-lookup___vn",
    path: dns_45lookup0hGVZAd7y3Meta?.path ?? "/vn/dns-lookup",
    meta: dns_45lookup0hGVZAd7y3Meta || {},
    alias: dns_45lookup0hGVZAd7y3Meta?.alias || [],
    redirect: dns_45lookup0hGVZAd7y3Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/dns-lookup.vue").then(m => m.default || m)
  },
  {
    name: dns_45lookup0hGVZAd7y3Meta?.name ?? "dns-lookup___th",
    path: dns_45lookup0hGVZAd7y3Meta?.path ?? "/th/dns-lookup",
    meta: dns_45lookup0hGVZAd7y3Meta || {},
    alias: dns_45lookup0hGVZAd7y3Meta?.alias || [],
    redirect: dns_45lookup0hGVZAd7y3Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/dns-lookup.vue").then(m => m.default || m)
  },
  {
    name: dns_45lookup0hGVZAd7y3Meta?.name ?? "dns-lookup___ru",
    path: dns_45lookup0hGVZAd7y3Meta?.path ?? "/ru/dns-lookup",
    meta: dns_45lookup0hGVZAd7y3Meta || {},
    alias: dns_45lookup0hGVZAd7y3Meta?.alias || [],
    redirect: dns_45lookup0hGVZAd7y3Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/dns-lookup.vue").then(m => m.default || m)
  },
  {
    name: dns_45lookup0hGVZAd7y3Meta?.name ?? "dns-lookup___tr",
    path: dns_45lookup0hGVZAd7y3Meta?.path ?? "/tr/dns-lookup",
    meta: dns_45lookup0hGVZAd7y3Meta || {},
    alias: dns_45lookup0hGVZAd7y3Meta?.alias || [],
    redirect: dns_45lookup0hGVZAd7y3Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/dns-lookup.vue").then(m => m.default || m)
  },
  {
    name: dnsQbL7cNA0y0Meta?.name ?? "dns___en",
    path: dnsQbL7cNA0y0Meta?.path ?? "/dns",
    meta: dnsQbL7cNA0y0Meta || {},
    alias: dnsQbL7cNA0y0Meta?.alias || [],
    redirect: dnsQbL7cNA0y0Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/dns.vue").then(m => m.default || m)
  },
  {
    name: dnsQbL7cNA0y0Meta?.name ?? "dns___zh-cn",
    path: dnsQbL7cNA0y0Meta?.path ?? "/zh-cn/dns",
    meta: dnsQbL7cNA0y0Meta || {},
    alias: dnsQbL7cNA0y0Meta?.alias || [],
    redirect: dnsQbL7cNA0y0Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/dns.vue").then(m => m.default || m)
  },
  {
    name: dnsQbL7cNA0y0Meta?.name ?? "dns___zh-tw",
    path: dnsQbL7cNA0y0Meta?.path ?? "/zh-tw/dns",
    meta: dnsQbL7cNA0y0Meta || {},
    alias: dnsQbL7cNA0y0Meta?.alias || [],
    redirect: dnsQbL7cNA0y0Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/dns.vue").then(m => m.default || m)
  },
  {
    name: dnsQbL7cNA0y0Meta?.name ?? "dns___jp",
    path: dnsQbL7cNA0y0Meta?.path ?? "/jp/dns",
    meta: dnsQbL7cNA0y0Meta || {},
    alias: dnsQbL7cNA0y0Meta?.alias || [],
    redirect: dnsQbL7cNA0y0Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/dns.vue").then(m => m.default || m)
  },
  {
    name: dnsQbL7cNA0y0Meta?.name ?? "dns___es",
    path: dnsQbL7cNA0y0Meta?.path ?? "/es/dns",
    meta: dnsQbL7cNA0y0Meta || {},
    alias: dnsQbL7cNA0y0Meta?.alias || [],
    redirect: dnsQbL7cNA0y0Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/dns.vue").then(m => m.default || m)
  },
  {
    name: dnsQbL7cNA0y0Meta?.name ?? "dns___fr",
    path: dnsQbL7cNA0y0Meta?.path ?? "/fr/dns",
    meta: dnsQbL7cNA0y0Meta || {},
    alias: dnsQbL7cNA0y0Meta?.alias || [],
    redirect: dnsQbL7cNA0y0Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/dns.vue").then(m => m.default || m)
  },
  {
    name: dnsQbL7cNA0y0Meta?.name ?? "dns___de",
    path: dnsQbL7cNA0y0Meta?.path ?? "/de/dns",
    meta: dnsQbL7cNA0y0Meta || {},
    alias: dnsQbL7cNA0y0Meta?.alias || [],
    redirect: dnsQbL7cNA0y0Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/dns.vue").then(m => m.default || m)
  },
  {
    name: dnsQbL7cNA0y0Meta?.name ?? "dns___kr",
    path: dnsQbL7cNA0y0Meta?.path ?? "/kr/dns",
    meta: dnsQbL7cNA0y0Meta || {},
    alias: dnsQbL7cNA0y0Meta?.alias || [],
    redirect: dnsQbL7cNA0y0Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/dns.vue").then(m => m.default || m)
  },
  {
    name: dnsQbL7cNA0y0Meta?.name ?? "dns___vn",
    path: dnsQbL7cNA0y0Meta?.path ?? "/vn/dns",
    meta: dnsQbL7cNA0y0Meta || {},
    alias: dnsQbL7cNA0y0Meta?.alias || [],
    redirect: dnsQbL7cNA0y0Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/dns.vue").then(m => m.default || m)
  },
  {
    name: dnsQbL7cNA0y0Meta?.name ?? "dns___th",
    path: dnsQbL7cNA0y0Meta?.path ?? "/th/dns",
    meta: dnsQbL7cNA0y0Meta || {},
    alias: dnsQbL7cNA0y0Meta?.alias || [],
    redirect: dnsQbL7cNA0y0Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/dns.vue").then(m => m.default || m)
  },
  {
    name: dnsQbL7cNA0y0Meta?.name ?? "dns___ru",
    path: dnsQbL7cNA0y0Meta?.path ?? "/ru/dns",
    meta: dnsQbL7cNA0y0Meta || {},
    alias: dnsQbL7cNA0y0Meta?.alias || [],
    redirect: dnsQbL7cNA0y0Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/dns.vue").then(m => m.default || m)
  },
  {
    name: dnsQbL7cNA0y0Meta?.name ?? "dns___tr",
    path: dnsQbL7cNA0y0Meta?.path ?? "/tr/dns",
    meta: dnsQbL7cNA0y0Meta || {},
    alias: dnsQbL7cNA0y0Meta?.alias || [],
    redirect: dnsQbL7cNA0y0Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/dns.vue").then(m => m.default || m)
  },
  {
    name: document_45signing_45certificatejWOBxwO5fSMeta?.name ?? "document-signing-certificate___en",
    path: document_45signing_45certificatejWOBxwO5fSMeta?.path ?? "/document-signing-certificate",
    meta: document_45signing_45certificatejWOBxwO5fSMeta || {},
    alias: document_45signing_45certificatejWOBxwO5fSMeta?.alias || [],
    redirect: document_45signing_45certificatejWOBxwO5fSMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/document-signing-certificate.vue").then(m => m.default || m)
  },
  {
    name: document_45signing_45certificatejWOBxwO5fSMeta?.name ?? "document-signing-certificate___zh-cn",
    path: document_45signing_45certificatejWOBxwO5fSMeta?.path ?? "/zh-cn/document-signing-certificate",
    meta: document_45signing_45certificatejWOBxwO5fSMeta || {},
    alias: document_45signing_45certificatejWOBxwO5fSMeta?.alias || [],
    redirect: document_45signing_45certificatejWOBxwO5fSMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/document-signing-certificate.vue").then(m => m.default || m)
  },
  {
    name: document_45signing_45certificatejWOBxwO5fSMeta?.name ?? "document-signing-certificate___zh-tw",
    path: document_45signing_45certificatejWOBxwO5fSMeta?.path ?? "/zh-tw/document-signing-certificate",
    meta: document_45signing_45certificatejWOBxwO5fSMeta || {},
    alias: document_45signing_45certificatejWOBxwO5fSMeta?.alias || [],
    redirect: document_45signing_45certificatejWOBxwO5fSMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/document-signing-certificate.vue").then(m => m.default || m)
  },
  {
    name: document_45signing_45certificatejWOBxwO5fSMeta?.name ?? "document-signing-certificate___jp",
    path: document_45signing_45certificatejWOBxwO5fSMeta?.path ?? "/jp/document-signing-certificate",
    meta: document_45signing_45certificatejWOBxwO5fSMeta || {},
    alias: document_45signing_45certificatejWOBxwO5fSMeta?.alias || [],
    redirect: document_45signing_45certificatejWOBxwO5fSMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/document-signing-certificate.vue").then(m => m.default || m)
  },
  {
    name: document_45signing_45certificatejWOBxwO5fSMeta?.name ?? "document-signing-certificate___es",
    path: document_45signing_45certificatejWOBxwO5fSMeta?.path ?? "/es/document-signing-certificate",
    meta: document_45signing_45certificatejWOBxwO5fSMeta || {},
    alias: document_45signing_45certificatejWOBxwO5fSMeta?.alias || [],
    redirect: document_45signing_45certificatejWOBxwO5fSMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/document-signing-certificate.vue").then(m => m.default || m)
  },
  {
    name: document_45signing_45certificatejWOBxwO5fSMeta?.name ?? "document-signing-certificate___fr",
    path: document_45signing_45certificatejWOBxwO5fSMeta?.path ?? "/fr/document-signing-certificate",
    meta: document_45signing_45certificatejWOBxwO5fSMeta || {},
    alias: document_45signing_45certificatejWOBxwO5fSMeta?.alias || [],
    redirect: document_45signing_45certificatejWOBxwO5fSMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/document-signing-certificate.vue").then(m => m.default || m)
  },
  {
    name: document_45signing_45certificatejWOBxwO5fSMeta?.name ?? "document-signing-certificate___de",
    path: document_45signing_45certificatejWOBxwO5fSMeta?.path ?? "/de/document-signing-certificate",
    meta: document_45signing_45certificatejWOBxwO5fSMeta || {},
    alias: document_45signing_45certificatejWOBxwO5fSMeta?.alias || [],
    redirect: document_45signing_45certificatejWOBxwO5fSMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/document-signing-certificate.vue").then(m => m.default || m)
  },
  {
    name: document_45signing_45certificatejWOBxwO5fSMeta?.name ?? "document-signing-certificate___kr",
    path: document_45signing_45certificatejWOBxwO5fSMeta?.path ?? "/kr/document-signing-certificate",
    meta: document_45signing_45certificatejWOBxwO5fSMeta || {},
    alias: document_45signing_45certificatejWOBxwO5fSMeta?.alias || [],
    redirect: document_45signing_45certificatejWOBxwO5fSMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/document-signing-certificate.vue").then(m => m.default || m)
  },
  {
    name: document_45signing_45certificatejWOBxwO5fSMeta?.name ?? "document-signing-certificate___vn",
    path: document_45signing_45certificatejWOBxwO5fSMeta?.path ?? "/vn/document-signing-certificate",
    meta: document_45signing_45certificatejWOBxwO5fSMeta || {},
    alias: document_45signing_45certificatejWOBxwO5fSMeta?.alias || [],
    redirect: document_45signing_45certificatejWOBxwO5fSMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/document-signing-certificate.vue").then(m => m.default || m)
  },
  {
    name: document_45signing_45certificatejWOBxwO5fSMeta?.name ?? "document-signing-certificate___th",
    path: document_45signing_45certificatejWOBxwO5fSMeta?.path ?? "/th/document-signing-certificate",
    meta: document_45signing_45certificatejWOBxwO5fSMeta || {},
    alias: document_45signing_45certificatejWOBxwO5fSMeta?.alias || [],
    redirect: document_45signing_45certificatejWOBxwO5fSMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/document-signing-certificate.vue").then(m => m.default || m)
  },
  {
    name: document_45signing_45certificatejWOBxwO5fSMeta?.name ?? "document-signing-certificate___ru",
    path: document_45signing_45certificatejWOBxwO5fSMeta?.path ?? "/ru/document-signing-certificate",
    meta: document_45signing_45certificatejWOBxwO5fSMeta || {},
    alias: document_45signing_45certificatejWOBxwO5fSMeta?.alias || [],
    redirect: document_45signing_45certificatejWOBxwO5fSMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/document-signing-certificate.vue").then(m => m.default || m)
  },
  {
    name: document_45signing_45certificatejWOBxwO5fSMeta?.name ?? "document-signing-certificate___tr",
    path: document_45signing_45certificatejWOBxwO5fSMeta?.path ?? "/tr/document-signing-certificate",
    meta: document_45signing_45certificatejWOBxwO5fSMeta || {},
    alias: document_45signing_45certificatejWOBxwO5fSMeta?.alias || [],
    redirect: document_45signing_45certificatejWOBxwO5fSMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/document-signing-certificate.vue").then(m => m.default || m)
  },
  {
    name: domain_45transfer1czu6y2FH3Meta?.name ?? "domain-transfer___en",
    path: domain_45transfer1czu6y2FH3Meta?.path ?? "/domain-transfer",
    meta: domain_45transfer1czu6y2FH3Meta || {},
    alias: domain_45transfer1czu6y2FH3Meta?.alias || [],
    redirect: domain_45transfer1czu6y2FH3Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/domain-transfer.vue").then(m => m.default || m)
  },
  {
    name: domain_45transfer1czu6y2FH3Meta?.name ?? "domain-transfer___zh-cn",
    path: domain_45transfer1czu6y2FH3Meta?.path ?? "/zh-cn/domain-transfer",
    meta: domain_45transfer1czu6y2FH3Meta || {},
    alias: domain_45transfer1czu6y2FH3Meta?.alias || [],
    redirect: domain_45transfer1czu6y2FH3Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/domain-transfer.vue").then(m => m.default || m)
  },
  {
    name: domain_45transfer1czu6y2FH3Meta?.name ?? "domain-transfer___zh-tw",
    path: domain_45transfer1czu6y2FH3Meta?.path ?? "/zh-tw/domain-transfer",
    meta: domain_45transfer1czu6y2FH3Meta || {},
    alias: domain_45transfer1czu6y2FH3Meta?.alias || [],
    redirect: domain_45transfer1czu6y2FH3Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/domain-transfer.vue").then(m => m.default || m)
  },
  {
    name: domain_45transfer1czu6y2FH3Meta?.name ?? "domain-transfer___jp",
    path: domain_45transfer1czu6y2FH3Meta?.path ?? "/jp/domain-transfer",
    meta: domain_45transfer1czu6y2FH3Meta || {},
    alias: domain_45transfer1czu6y2FH3Meta?.alias || [],
    redirect: domain_45transfer1czu6y2FH3Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/domain-transfer.vue").then(m => m.default || m)
  },
  {
    name: domain_45transfer1czu6y2FH3Meta?.name ?? "domain-transfer___es",
    path: domain_45transfer1czu6y2FH3Meta?.path ?? "/es/domain-transfer",
    meta: domain_45transfer1czu6y2FH3Meta || {},
    alias: domain_45transfer1czu6y2FH3Meta?.alias || [],
    redirect: domain_45transfer1czu6y2FH3Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/domain-transfer.vue").then(m => m.default || m)
  },
  {
    name: domain_45transfer1czu6y2FH3Meta?.name ?? "domain-transfer___fr",
    path: domain_45transfer1czu6y2FH3Meta?.path ?? "/fr/domain-transfer",
    meta: domain_45transfer1czu6y2FH3Meta || {},
    alias: domain_45transfer1czu6y2FH3Meta?.alias || [],
    redirect: domain_45transfer1czu6y2FH3Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/domain-transfer.vue").then(m => m.default || m)
  },
  {
    name: domain_45transfer1czu6y2FH3Meta?.name ?? "domain-transfer___de",
    path: domain_45transfer1czu6y2FH3Meta?.path ?? "/de/domain-transfer",
    meta: domain_45transfer1czu6y2FH3Meta || {},
    alias: domain_45transfer1czu6y2FH3Meta?.alias || [],
    redirect: domain_45transfer1czu6y2FH3Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/domain-transfer.vue").then(m => m.default || m)
  },
  {
    name: domain_45transfer1czu6y2FH3Meta?.name ?? "domain-transfer___kr",
    path: domain_45transfer1czu6y2FH3Meta?.path ?? "/kr/domain-transfer",
    meta: domain_45transfer1czu6y2FH3Meta || {},
    alias: domain_45transfer1czu6y2FH3Meta?.alias || [],
    redirect: domain_45transfer1czu6y2FH3Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/domain-transfer.vue").then(m => m.default || m)
  },
  {
    name: domain_45transfer1czu6y2FH3Meta?.name ?? "domain-transfer___vn",
    path: domain_45transfer1czu6y2FH3Meta?.path ?? "/vn/domain-transfer",
    meta: domain_45transfer1czu6y2FH3Meta || {},
    alias: domain_45transfer1czu6y2FH3Meta?.alias || [],
    redirect: domain_45transfer1czu6y2FH3Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/domain-transfer.vue").then(m => m.default || m)
  },
  {
    name: domain_45transfer1czu6y2FH3Meta?.name ?? "domain-transfer___th",
    path: domain_45transfer1czu6y2FH3Meta?.path ?? "/th/domain-transfer",
    meta: domain_45transfer1czu6y2FH3Meta || {},
    alias: domain_45transfer1czu6y2FH3Meta?.alias || [],
    redirect: domain_45transfer1czu6y2FH3Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/domain-transfer.vue").then(m => m.default || m)
  },
  {
    name: domain_45transfer1czu6y2FH3Meta?.name ?? "domain-transfer___ru",
    path: domain_45transfer1czu6y2FH3Meta?.path ?? "/ru/domain-transfer",
    meta: domain_45transfer1czu6y2FH3Meta || {},
    alias: domain_45transfer1czu6y2FH3Meta?.alias || [],
    redirect: domain_45transfer1czu6y2FH3Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/domain-transfer.vue").then(m => m.default || m)
  },
  {
    name: domain_45transfer1czu6y2FH3Meta?.name ?? "domain-transfer___tr",
    path: domain_45transfer1czu6y2FH3Meta?.path ?? "/tr/domain-transfer",
    meta: domain_45transfer1czu6y2FH3Meta || {},
    alias: domain_45transfer1czu6y2FH3Meta?.alias || [],
    redirect: domain_45transfer1czu6y2FH3Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/domain-transfer.vue").then(m => m.default || m)
  },
  {
    name: DomainCardiXdiIEvHUgMeta?.name ?? "domain-DomainCard___en",
    path: DomainCardiXdiIEvHUgMeta?.path ?? "/domain/DomainCard",
    meta: DomainCardiXdiIEvHUgMeta || {},
    alias: DomainCardiXdiIEvHUgMeta?.alias || [],
    redirect: DomainCardiXdiIEvHUgMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/domain/DomainCard.vue").then(m => m.default || m)
  },
  {
    name: DomainCardiXdiIEvHUgMeta?.name ?? "domain-DomainCard___zh-cn",
    path: DomainCardiXdiIEvHUgMeta?.path ?? "/zh-cn/domain/DomainCard",
    meta: DomainCardiXdiIEvHUgMeta || {},
    alias: DomainCardiXdiIEvHUgMeta?.alias || [],
    redirect: DomainCardiXdiIEvHUgMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/domain/DomainCard.vue").then(m => m.default || m)
  },
  {
    name: DomainCardiXdiIEvHUgMeta?.name ?? "domain-DomainCard___zh-tw",
    path: DomainCardiXdiIEvHUgMeta?.path ?? "/zh-tw/domain/DomainCard",
    meta: DomainCardiXdiIEvHUgMeta || {},
    alias: DomainCardiXdiIEvHUgMeta?.alias || [],
    redirect: DomainCardiXdiIEvHUgMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/domain/DomainCard.vue").then(m => m.default || m)
  },
  {
    name: DomainCardiXdiIEvHUgMeta?.name ?? "domain-DomainCard___jp",
    path: DomainCardiXdiIEvHUgMeta?.path ?? "/jp/domain/DomainCard",
    meta: DomainCardiXdiIEvHUgMeta || {},
    alias: DomainCardiXdiIEvHUgMeta?.alias || [],
    redirect: DomainCardiXdiIEvHUgMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/domain/DomainCard.vue").then(m => m.default || m)
  },
  {
    name: DomainCardiXdiIEvHUgMeta?.name ?? "domain-DomainCard___es",
    path: DomainCardiXdiIEvHUgMeta?.path ?? "/es/domain/DomainCard",
    meta: DomainCardiXdiIEvHUgMeta || {},
    alias: DomainCardiXdiIEvHUgMeta?.alias || [],
    redirect: DomainCardiXdiIEvHUgMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/domain/DomainCard.vue").then(m => m.default || m)
  },
  {
    name: DomainCardiXdiIEvHUgMeta?.name ?? "domain-DomainCard___fr",
    path: DomainCardiXdiIEvHUgMeta?.path ?? "/fr/domain/DomainCard",
    meta: DomainCardiXdiIEvHUgMeta || {},
    alias: DomainCardiXdiIEvHUgMeta?.alias || [],
    redirect: DomainCardiXdiIEvHUgMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/domain/DomainCard.vue").then(m => m.default || m)
  },
  {
    name: DomainCardiXdiIEvHUgMeta?.name ?? "domain-DomainCard___de",
    path: DomainCardiXdiIEvHUgMeta?.path ?? "/de/domain/DomainCard",
    meta: DomainCardiXdiIEvHUgMeta || {},
    alias: DomainCardiXdiIEvHUgMeta?.alias || [],
    redirect: DomainCardiXdiIEvHUgMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/domain/DomainCard.vue").then(m => m.default || m)
  },
  {
    name: DomainCardiXdiIEvHUgMeta?.name ?? "domain-DomainCard___kr",
    path: DomainCardiXdiIEvHUgMeta?.path ?? "/kr/domain/DomainCard",
    meta: DomainCardiXdiIEvHUgMeta || {},
    alias: DomainCardiXdiIEvHUgMeta?.alias || [],
    redirect: DomainCardiXdiIEvHUgMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/domain/DomainCard.vue").then(m => m.default || m)
  },
  {
    name: DomainCardiXdiIEvHUgMeta?.name ?? "domain-DomainCard___vn",
    path: DomainCardiXdiIEvHUgMeta?.path ?? "/vn/domain/DomainCard",
    meta: DomainCardiXdiIEvHUgMeta || {},
    alias: DomainCardiXdiIEvHUgMeta?.alias || [],
    redirect: DomainCardiXdiIEvHUgMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/domain/DomainCard.vue").then(m => m.default || m)
  },
  {
    name: DomainCardiXdiIEvHUgMeta?.name ?? "domain-DomainCard___th",
    path: DomainCardiXdiIEvHUgMeta?.path ?? "/th/domain/DomainCard",
    meta: DomainCardiXdiIEvHUgMeta || {},
    alias: DomainCardiXdiIEvHUgMeta?.alias || [],
    redirect: DomainCardiXdiIEvHUgMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/domain/DomainCard.vue").then(m => m.default || m)
  },
  {
    name: DomainCardiXdiIEvHUgMeta?.name ?? "domain-DomainCard___ru",
    path: DomainCardiXdiIEvHUgMeta?.path ?? "/ru/domain/DomainCard",
    meta: DomainCardiXdiIEvHUgMeta || {},
    alias: DomainCardiXdiIEvHUgMeta?.alias || [],
    redirect: DomainCardiXdiIEvHUgMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/domain/DomainCard.vue").then(m => m.default || m)
  },
  {
    name: DomainCardiXdiIEvHUgMeta?.name ?? "domain-DomainCard___tr",
    path: DomainCardiXdiIEvHUgMeta?.path ?? "/tr/domain/DomainCard",
    meta: DomainCardiXdiIEvHUgMeta || {},
    alias: DomainCardiXdiIEvHUgMeta?.alias || [],
    redirect: DomainCardiXdiIEvHUgMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/domain/DomainCard.vue").then(m => m.default || m)
  },
  {
    name: _91code_93yRrkFFxFnXMeta?.name ?? "domain-code___en",
    path: _91code_93yRrkFFxFnXMeta?.path ?? "/domain/:code()",
    meta: _91code_93yRrkFFxFnXMeta || {},
    alias: _91code_93yRrkFFxFnXMeta?.alias || [],
    redirect: _91code_93yRrkFFxFnXMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/domain/[code].vue").then(m => m.default || m)
  },
  {
    name: _91code_93yRrkFFxFnXMeta?.name ?? "domain-code___zh-cn",
    path: _91code_93yRrkFFxFnXMeta?.path ?? "/zh-cn/domain/:code()",
    meta: _91code_93yRrkFFxFnXMeta || {},
    alias: _91code_93yRrkFFxFnXMeta?.alias || [],
    redirect: _91code_93yRrkFFxFnXMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/domain/[code].vue").then(m => m.default || m)
  },
  {
    name: _91code_93yRrkFFxFnXMeta?.name ?? "domain-code___zh-tw",
    path: _91code_93yRrkFFxFnXMeta?.path ?? "/zh-tw/domain/:code()",
    meta: _91code_93yRrkFFxFnXMeta || {},
    alias: _91code_93yRrkFFxFnXMeta?.alias || [],
    redirect: _91code_93yRrkFFxFnXMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/domain/[code].vue").then(m => m.default || m)
  },
  {
    name: _91code_93yRrkFFxFnXMeta?.name ?? "domain-code___jp",
    path: _91code_93yRrkFFxFnXMeta?.path ?? "/jp/domain/:code()",
    meta: _91code_93yRrkFFxFnXMeta || {},
    alias: _91code_93yRrkFFxFnXMeta?.alias || [],
    redirect: _91code_93yRrkFFxFnXMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/domain/[code].vue").then(m => m.default || m)
  },
  {
    name: _91code_93yRrkFFxFnXMeta?.name ?? "domain-code___es",
    path: _91code_93yRrkFFxFnXMeta?.path ?? "/es/domain/:code()",
    meta: _91code_93yRrkFFxFnXMeta || {},
    alias: _91code_93yRrkFFxFnXMeta?.alias || [],
    redirect: _91code_93yRrkFFxFnXMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/domain/[code].vue").then(m => m.default || m)
  },
  {
    name: _91code_93yRrkFFxFnXMeta?.name ?? "domain-code___fr",
    path: _91code_93yRrkFFxFnXMeta?.path ?? "/fr/domain/:code()",
    meta: _91code_93yRrkFFxFnXMeta || {},
    alias: _91code_93yRrkFFxFnXMeta?.alias || [],
    redirect: _91code_93yRrkFFxFnXMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/domain/[code].vue").then(m => m.default || m)
  },
  {
    name: _91code_93yRrkFFxFnXMeta?.name ?? "domain-code___de",
    path: _91code_93yRrkFFxFnXMeta?.path ?? "/de/domain/:code()",
    meta: _91code_93yRrkFFxFnXMeta || {},
    alias: _91code_93yRrkFFxFnXMeta?.alias || [],
    redirect: _91code_93yRrkFFxFnXMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/domain/[code].vue").then(m => m.default || m)
  },
  {
    name: _91code_93yRrkFFxFnXMeta?.name ?? "domain-code___kr",
    path: _91code_93yRrkFFxFnXMeta?.path ?? "/kr/domain/:code()",
    meta: _91code_93yRrkFFxFnXMeta || {},
    alias: _91code_93yRrkFFxFnXMeta?.alias || [],
    redirect: _91code_93yRrkFFxFnXMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/domain/[code].vue").then(m => m.default || m)
  },
  {
    name: _91code_93yRrkFFxFnXMeta?.name ?? "domain-code___vn",
    path: _91code_93yRrkFFxFnXMeta?.path ?? "/vn/domain/:code()",
    meta: _91code_93yRrkFFxFnXMeta || {},
    alias: _91code_93yRrkFFxFnXMeta?.alias || [],
    redirect: _91code_93yRrkFFxFnXMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/domain/[code].vue").then(m => m.default || m)
  },
  {
    name: _91code_93yRrkFFxFnXMeta?.name ?? "domain-code___th",
    path: _91code_93yRrkFFxFnXMeta?.path ?? "/th/domain/:code()",
    meta: _91code_93yRrkFFxFnXMeta || {},
    alias: _91code_93yRrkFFxFnXMeta?.alias || [],
    redirect: _91code_93yRrkFFxFnXMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/domain/[code].vue").then(m => m.default || m)
  },
  {
    name: _91code_93yRrkFFxFnXMeta?.name ?? "domain-code___ru",
    path: _91code_93yRrkFFxFnXMeta?.path ?? "/ru/domain/:code()",
    meta: _91code_93yRrkFFxFnXMeta || {},
    alias: _91code_93yRrkFFxFnXMeta?.alias || [],
    redirect: _91code_93yRrkFFxFnXMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/domain/[code].vue").then(m => m.default || m)
  },
  {
    name: _91code_93yRrkFFxFnXMeta?.name ?? "domain-code___tr",
    path: _91code_93yRrkFFxFnXMeta?.path ?? "/tr/domain/:code()",
    meta: _91code_93yRrkFFxFnXMeta || {},
    alias: _91code_93yRrkFFxFnXMeta?.alias || [],
    redirect: _91code_93yRrkFFxFnXMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/domain/[code].vue").then(m => m.default || m)
  },
  {
    name: indexs1JptdUy19Meta?.name ?? "domain___en",
    path: indexs1JptdUy19Meta?.path ?? "/domain",
    meta: indexs1JptdUy19Meta || {},
    alias: indexs1JptdUy19Meta?.alias || [],
    redirect: indexs1JptdUy19Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/domain/index.vue").then(m => m.default || m)
  },
  {
    name: indexs1JptdUy19Meta?.name ?? "domain___zh-cn",
    path: indexs1JptdUy19Meta?.path ?? "/zh-cn/domain",
    meta: indexs1JptdUy19Meta || {},
    alias: indexs1JptdUy19Meta?.alias || [],
    redirect: indexs1JptdUy19Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/domain/index.vue").then(m => m.default || m)
  },
  {
    name: indexs1JptdUy19Meta?.name ?? "domain___zh-tw",
    path: indexs1JptdUy19Meta?.path ?? "/zh-tw/domain",
    meta: indexs1JptdUy19Meta || {},
    alias: indexs1JptdUy19Meta?.alias || [],
    redirect: indexs1JptdUy19Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/domain/index.vue").then(m => m.default || m)
  },
  {
    name: indexs1JptdUy19Meta?.name ?? "domain___jp",
    path: indexs1JptdUy19Meta?.path ?? "/jp/domain",
    meta: indexs1JptdUy19Meta || {},
    alias: indexs1JptdUy19Meta?.alias || [],
    redirect: indexs1JptdUy19Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/domain/index.vue").then(m => m.default || m)
  },
  {
    name: indexs1JptdUy19Meta?.name ?? "domain___es",
    path: indexs1JptdUy19Meta?.path ?? "/es/domain",
    meta: indexs1JptdUy19Meta || {},
    alias: indexs1JptdUy19Meta?.alias || [],
    redirect: indexs1JptdUy19Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/domain/index.vue").then(m => m.default || m)
  },
  {
    name: indexs1JptdUy19Meta?.name ?? "domain___fr",
    path: indexs1JptdUy19Meta?.path ?? "/fr/domain",
    meta: indexs1JptdUy19Meta || {},
    alias: indexs1JptdUy19Meta?.alias || [],
    redirect: indexs1JptdUy19Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/domain/index.vue").then(m => m.default || m)
  },
  {
    name: indexs1JptdUy19Meta?.name ?? "domain___de",
    path: indexs1JptdUy19Meta?.path ?? "/de/domain",
    meta: indexs1JptdUy19Meta || {},
    alias: indexs1JptdUy19Meta?.alias || [],
    redirect: indexs1JptdUy19Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/domain/index.vue").then(m => m.default || m)
  },
  {
    name: indexs1JptdUy19Meta?.name ?? "domain___kr",
    path: indexs1JptdUy19Meta?.path ?? "/kr/domain",
    meta: indexs1JptdUy19Meta || {},
    alias: indexs1JptdUy19Meta?.alias || [],
    redirect: indexs1JptdUy19Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/domain/index.vue").then(m => m.default || m)
  },
  {
    name: indexs1JptdUy19Meta?.name ?? "domain___vn",
    path: indexs1JptdUy19Meta?.path ?? "/vn/domain",
    meta: indexs1JptdUy19Meta || {},
    alias: indexs1JptdUy19Meta?.alias || [],
    redirect: indexs1JptdUy19Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/domain/index.vue").then(m => m.default || m)
  },
  {
    name: indexs1JptdUy19Meta?.name ?? "domain___th",
    path: indexs1JptdUy19Meta?.path ?? "/th/domain",
    meta: indexs1JptdUy19Meta || {},
    alias: indexs1JptdUy19Meta?.alias || [],
    redirect: indexs1JptdUy19Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/domain/index.vue").then(m => m.default || m)
  },
  {
    name: indexs1JptdUy19Meta?.name ?? "domain___ru",
    path: indexs1JptdUy19Meta?.path ?? "/ru/domain",
    meta: indexs1JptdUy19Meta || {},
    alias: indexs1JptdUy19Meta?.alias || [],
    redirect: indexs1JptdUy19Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/domain/index.vue").then(m => m.default || m)
  },
  {
    name: indexs1JptdUy19Meta?.name ?? "domain___tr",
    path: indexs1JptdUy19Meta?.path ?? "/tr/domain",
    meta: indexs1JptdUy19Meta || {},
    alias: indexs1JptdUy19Meta?.alias || [],
    redirect: indexs1JptdUy19Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/domain/index.vue").then(m => m.default || m)
  },
  {
    name: download_45cert_45chainMdvgkCrsopMeta?.name ?? "download-cert-chain___en",
    path: download_45cert_45chainMdvgkCrsopMeta?.path ?? "/download-cert-chain",
    meta: download_45cert_45chainMdvgkCrsopMeta || {},
    alias: download_45cert_45chainMdvgkCrsopMeta?.alias || [],
    redirect: download_45cert_45chainMdvgkCrsopMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/download-cert-chain.vue").then(m => m.default || m)
  },
  {
    name: download_45cert_45chainMdvgkCrsopMeta?.name ?? "download-cert-chain___zh-cn",
    path: download_45cert_45chainMdvgkCrsopMeta?.path ?? "/zh-cn/download-cert-chain",
    meta: download_45cert_45chainMdvgkCrsopMeta || {},
    alias: download_45cert_45chainMdvgkCrsopMeta?.alias || [],
    redirect: download_45cert_45chainMdvgkCrsopMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/download-cert-chain.vue").then(m => m.default || m)
  },
  {
    name: download_45cert_45chainMdvgkCrsopMeta?.name ?? "download-cert-chain___zh-tw",
    path: download_45cert_45chainMdvgkCrsopMeta?.path ?? "/zh-tw/download-cert-chain",
    meta: download_45cert_45chainMdvgkCrsopMeta || {},
    alias: download_45cert_45chainMdvgkCrsopMeta?.alias || [],
    redirect: download_45cert_45chainMdvgkCrsopMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/download-cert-chain.vue").then(m => m.default || m)
  },
  {
    name: download_45cert_45chainMdvgkCrsopMeta?.name ?? "download-cert-chain___jp",
    path: download_45cert_45chainMdvgkCrsopMeta?.path ?? "/jp/download-cert-chain",
    meta: download_45cert_45chainMdvgkCrsopMeta || {},
    alias: download_45cert_45chainMdvgkCrsopMeta?.alias || [],
    redirect: download_45cert_45chainMdvgkCrsopMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/download-cert-chain.vue").then(m => m.default || m)
  },
  {
    name: download_45cert_45chainMdvgkCrsopMeta?.name ?? "download-cert-chain___es",
    path: download_45cert_45chainMdvgkCrsopMeta?.path ?? "/es/download-cert-chain",
    meta: download_45cert_45chainMdvgkCrsopMeta || {},
    alias: download_45cert_45chainMdvgkCrsopMeta?.alias || [],
    redirect: download_45cert_45chainMdvgkCrsopMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/download-cert-chain.vue").then(m => m.default || m)
  },
  {
    name: download_45cert_45chainMdvgkCrsopMeta?.name ?? "download-cert-chain___fr",
    path: download_45cert_45chainMdvgkCrsopMeta?.path ?? "/fr/download-cert-chain",
    meta: download_45cert_45chainMdvgkCrsopMeta || {},
    alias: download_45cert_45chainMdvgkCrsopMeta?.alias || [],
    redirect: download_45cert_45chainMdvgkCrsopMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/download-cert-chain.vue").then(m => m.default || m)
  },
  {
    name: download_45cert_45chainMdvgkCrsopMeta?.name ?? "download-cert-chain___de",
    path: download_45cert_45chainMdvgkCrsopMeta?.path ?? "/de/download-cert-chain",
    meta: download_45cert_45chainMdvgkCrsopMeta || {},
    alias: download_45cert_45chainMdvgkCrsopMeta?.alias || [],
    redirect: download_45cert_45chainMdvgkCrsopMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/download-cert-chain.vue").then(m => m.default || m)
  },
  {
    name: download_45cert_45chainMdvgkCrsopMeta?.name ?? "download-cert-chain___kr",
    path: download_45cert_45chainMdvgkCrsopMeta?.path ?? "/kr/download-cert-chain",
    meta: download_45cert_45chainMdvgkCrsopMeta || {},
    alias: download_45cert_45chainMdvgkCrsopMeta?.alias || [],
    redirect: download_45cert_45chainMdvgkCrsopMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/download-cert-chain.vue").then(m => m.default || m)
  },
  {
    name: download_45cert_45chainMdvgkCrsopMeta?.name ?? "download-cert-chain___vn",
    path: download_45cert_45chainMdvgkCrsopMeta?.path ?? "/vn/download-cert-chain",
    meta: download_45cert_45chainMdvgkCrsopMeta || {},
    alias: download_45cert_45chainMdvgkCrsopMeta?.alias || [],
    redirect: download_45cert_45chainMdvgkCrsopMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/download-cert-chain.vue").then(m => m.default || m)
  },
  {
    name: download_45cert_45chainMdvgkCrsopMeta?.name ?? "download-cert-chain___th",
    path: download_45cert_45chainMdvgkCrsopMeta?.path ?? "/th/download-cert-chain",
    meta: download_45cert_45chainMdvgkCrsopMeta || {},
    alias: download_45cert_45chainMdvgkCrsopMeta?.alias || [],
    redirect: download_45cert_45chainMdvgkCrsopMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/download-cert-chain.vue").then(m => m.default || m)
  },
  {
    name: download_45cert_45chainMdvgkCrsopMeta?.name ?? "download-cert-chain___ru",
    path: download_45cert_45chainMdvgkCrsopMeta?.path ?? "/ru/download-cert-chain",
    meta: download_45cert_45chainMdvgkCrsopMeta || {},
    alias: download_45cert_45chainMdvgkCrsopMeta?.alias || [],
    redirect: download_45cert_45chainMdvgkCrsopMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/download-cert-chain.vue").then(m => m.default || m)
  },
  {
    name: download_45cert_45chainMdvgkCrsopMeta?.name ?? "download-cert-chain___tr",
    path: download_45cert_45chainMdvgkCrsopMeta?.path ?? "/tr/download-cert-chain",
    meta: download_45cert_45chainMdvgkCrsopMeta || {},
    alias: download_45cert_45chainMdvgkCrsopMeta?.alias || [],
    redirect: download_45cert_45chainMdvgkCrsopMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/download-cert-chain.vue").then(m => m.default || m)
  },
  {
    name: ecosystemLxfszMIKkQMeta?.name ?? "ecosystem___en",
    path: ecosystemLxfszMIKkQMeta?.path ?? "/ecosystem",
    meta: ecosystemLxfszMIKkQMeta || {},
    alias: ecosystemLxfszMIKkQMeta?.alias || [],
    redirect: ecosystemLxfszMIKkQMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ecosystem.vue").then(m => m.default || m)
  },
  {
    name: ecosystemLxfszMIKkQMeta?.name ?? "ecosystem___zh-cn",
    path: ecosystemLxfszMIKkQMeta?.path ?? "/zh-cn/ecosystem",
    meta: ecosystemLxfszMIKkQMeta || {},
    alias: ecosystemLxfszMIKkQMeta?.alias || [],
    redirect: ecosystemLxfszMIKkQMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ecosystem.vue").then(m => m.default || m)
  },
  {
    name: ecosystemLxfszMIKkQMeta?.name ?? "ecosystem___zh-tw",
    path: ecosystemLxfszMIKkQMeta?.path ?? "/zh-tw/ecosystem",
    meta: ecosystemLxfszMIKkQMeta || {},
    alias: ecosystemLxfszMIKkQMeta?.alias || [],
    redirect: ecosystemLxfszMIKkQMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ecosystem.vue").then(m => m.default || m)
  },
  {
    name: ecosystemLxfszMIKkQMeta?.name ?? "ecosystem___jp",
    path: ecosystemLxfszMIKkQMeta?.path ?? "/jp/ecosystem",
    meta: ecosystemLxfszMIKkQMeta || {},
    alias: ecosystemLxfszMIKkQMeta?.alias || [],
    redirect: ecosystemLxfszMIKkQMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ecosystem.vue").then(m => m.default || m)
  },
  {
    name: ecosystemLxfszMIKkQMeta?.name ?? "ecosystem___es",
    path: ecosystemLxfszMIKkQMeta?.path ?? "/es/ecosystem",
    meta: ecosystemLxfszMIKkQMeta || {},
    alias: ecosystemLxfszMIKkQMeta?.alias || [],
    redirect: ecosystemLxfszMIKkQMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ecosystem.vue").then(m => m.default || m)
  },
  {
    name: ecosystemLxfszMIKkQMeta?.name ?? "ecosystem___fr",
    path: ecosystemLxfszMIKkQMeta?.path ?? "/fr/ecosystem",
    meta: ecosystemLxfszMIKkQMeta || {},
    alias: ecosystemLxfszMIKkQMeta?.alias || [],
    redirect: ecosystemLxfszMIKkQMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ecosystem.vue").then(m => m.default || m)
  },
  {
    name: ecosystemLxfszMIKkQMeta?.name ?? "ecosystem___de",
    path: ecosystemLxfszMIKkQMeta?.path ?? "/de/ecosystem",
    meta: ecosystemLxfszMIKkQMeta || {},
    alias: ecosystemLxfszMIKkQMeta?.alias || [],
    redirect: ecosystemLxfszMIKkQMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ecosystem.vue").then(m => m.default || m)
  },
  {
    name: ecosystemLxfszMIKkQMeta?.name ?? "ecosystem___kr",
    path: ecosystemLxfszMIKkQMeta?.path ?? "/kr/ecosystem",
    meta: ecosystemLxfszMIKkQMeta || {},
    alias: ecosystemLxfszMIKkQMeta?.alias || [],
    redirect: ecosystemLxfszMIKkQMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ecosystem.vue").then(m => m.default || m)
  },
  {
    name: ecosystemLxfszMIKkQMeta?.name ?? "ecosystem___vn",
    path: ecosystemLxfszMIKkQMeta?.path ?? "/vn/ecosystem",
    meta: ecosystemLxfszMIKkQMeta || {},
    alias: ecosystemLxfszMIKkQMeta?.alias || [],
    redirect: ecosystemLxfszMIKkQMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ecosystem.vue").then(m => m.default || m)
  },
  {
    name: ecosystemLxfszMIKkQMeta?.name ?? "ecosystem___th",
    path: ecosystemLxfszMIKkQMeta?.path ?? "/th/ecosystem",
    meta: ecosystemLxfszMIKkQMeta || {},
    alias: ecosystemLxfszMIKkQMeta?.alias || [],
    redirect: ecosystemLxfszMIKkQMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ecosystem.vue").then(m => m.default || m)
  },
  {
    name: ecosystemLxfszMIKkQMeta?.name ?? "ecosystem___ru",
    path: ecosystemLxfszMIKkQMeta?.path ?? "/ru/ecosystem",
    meta: ecosystemLxfszMIKkQMeta || {},
    alias: ecosystemLxfszMIKkQMeta?.alias || [],
    redirect: ecosystemLxfszMIKkQMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ecosystem.vue").then(m => m.default || m)
  },
  {
    name: ecosystemLxfszMIKkQMeta?.name ?? "ecosystem___tr",
    path: ecosystemLxfszMIKkQMeta?.path ?? "/tr/ecosystem",
    meta: ecosystemLxfszMIKkQMeta || {},
    alias: ecosystemLxfszMIKkQMeta?.alias || [],
    redirect: ecosystemLxfszMIKkQMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ecosystem.vue").then(m => m.default || m)
  },
  {
    name: email_45signing_45certificateYUTTR0tFr5Meta?.name ?? "email-signing-certificate___en",
    path: email_45signing_45certificateYUTTR0tFr5Meta?.path ?? "/email-signing-certificate",
    meta: email_45signing_45certificateYUTTR0tFr5Meta || {},
    alias: email_45signing_45certificateYUTTR0tFr5Meta?.alias || [],
    redirect: email_45signing_45certificateYUTTR0tFr5Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/email-signing-certificate.vue").then(m => m.default || m)
  },
  {
    name: email_45signing_45certificateYUTTR0tFr5Meta?.name ?? "email-signing-certificate___zh-cn",
    path: email_45signing_45certificateYUTTR0tFr5Meta?.path ?? "/zh-cn/email-signing-certificate",
    meta: email_45signing_45certificateYUTTR0tFr5Meta || {},
    alias: email_45signing_45certificateYUTTR0tFr5Meta?.alias || [],
    redirect: email_45signing_45certificateYUTTR0tFr5Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/email-signing-certificate.vue").then(m => m.default || m)
  },
  {
    name: email_45signing_45certificateYUTTR0tFr5Meta?.name ?? "email-signing-certificate___zh-tw",
    path: email_45signing_45certificateYUTTR0tFr5Meta?.path ?? "/zh-tw/email-signing-certificate",
    meta: email_45signing_45certificateYUTTR0tFr5Meta || {},
    alias: email_45signing_45certificateYUTTR0tFr5Meta?.alias || [],
    redirect: email_45signing_45certificateYUTTR0tFr5Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/email-signing-certificate.vue").then(m => m.default || m)
  },
  {
    name: email_45signing_45certificateYUTTR0tFr5Meta?.name ?? "email-signing-certificate___jp",
    path: email_45signing_45certificateYUTTR0tFr5Meta?.path ?? "/jp/email-signing-certificate",
    meta: email_45signing_45certificateYUTTR0tFr5Meta || {},
    alias: email_45signing_45certificateYUTTR0tFr5Meta?.alias || [],
    redirect: email_45signing_45certificateYUTTR0tFr5Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/email-signing-certificate.vue").then(m => m.default || m)
  },
  {
    name: email_45signing_45certificateYUTTR0tFr5Meta?.name ?? "email-signing-certificate___es",
    path: email_45signing_45certificateYUTTR0tFr5Meta?.path ?? "/es/email-signing-certificate",
    meta: email_45signing_45certificateYUTTR0tFr5Meta || {},
    alias: email_45signing_45certificateYUTTR0tFr5Meta?.alias || [],
    redirect: email_45signing_45certificateYUTTR0tFr5Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/email-signing-certificate.vue").then(m => m.default || m)
  },
  {
    name: email_45signing_45certificateYUTTR0tFr5Meta?.name ?? "email-signing-certificate___fr",
    path: email_45signing_45certificateYUTTR0tFr5Meta?.path ?? "/fr/email-signing-certificate",
    meta: email_45signing_45certificateYUTTR0tFr5Meta || {},
    alias: email_45signing_45certificateYUTTR0tFr5Meta?.alias || [],
    redirect: email_45signing_45certificateYUTTR0tFr5Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/email-signing-certificate.vue").then(m => m.default || m)
  },
  {
    name: email_45signing_45certificateYUTTR0tFr5Meta?.name ?? "email-signing-certificate___de",
    path: email_45signing_45certificateYUTTR0tFr5Meta?.path ?? "/de/email-signing-certificate",
    meta: email_45signing_45certificateYUTTR0tFr5Meta || {},
    alias: email_45signing_45certificateYUTTR0tFr5Meta?.alias || [],
    redirect: email_45signing_45certificateYUTTR0tFr5Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/email-signing-certificate.vue").then(m => m.default || m)
  },
  {
    name: email_45signing_45certificateYUTTR0tFr5Meta?.name ?? "email-signing-certificate___kr",
    path: email_45signing_45certificateYUTTR0tFr5Meta?.path ?? "/kr/email-signing-certificate",
    meta: email_45signing_45certificateYUTTR0tFr5Meta || {},
    alias: email_45signing_45certificateYUTTR0tFr5Meta?.alias || [],
    redirect: email_45signing_45certificateYUTTR0tFr5Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/email-signing-certificate.vue").then(m => m.default || m)
  },
  {
    name: email_45signing_45certificateYUTTR0tFr5Meta?.name ?? "email-signing-certificate___vn",
    path: email_45signing_45certificateYUTTR0tFr5Meta?.path ?? "/vn/email-signing-certificate",
    meta: email_45signing_45certificateYUTTR0tFr5Meta || {},
    alias: email_45signing_45certificateYUTTR0tFr5Meta?.alias || [],
    redirect: email_45signing_45certificateYUTTR0tFr5Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/email-signing-certificate.vue").then(m => m.default || m)
  },
  {
    name: email_45signing_45certificateYUTTR0tFr5Meta?.name ?? "email-signing-certificate___th",
    path: email_45signing_45certificateYUTTR0tFr5Meta?.path ?? "/th/email-signing-certificate",
    meta: email_45signing_45certificateYUTTR0tFr5Meta || {},
    alias: email_45signing_45certificateYUTTR0tFr5Meta?.alias || [],
    redirect: email_45signing_45certificateYUTTR0tFr5Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/email-signing-certificate.vue").then(m => m.default || m)
  },
  {
    name: email_45signing_45certificateYUTTR0tFr5Meta?.name ?? "email-signing-certificate___ru",
    path: email_45signing_45certificateYUTTR0tFr5Meta?.path ?? "/ru/email-signing-certificate",
    meta: email_45signing_45certificateYUTTR0tFr5Meta || {},
    alias: email_45signing_45certificateYUTTR0tFr5Meta?.alias || [],
    redirect: email_45signing_45certificateYUTTR0tFr5Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/email-signing-certificate.vue").then(m => m.default || m)
  },
  {
    name: email_45signing_45certificateYUTTR0tFr5Meta?.name ?? "email-signing-certificate___tr",
    path: email_45signing_45certificateYUTTR0tFr5Meta?.path ?? "/tr/email-signing-certificate",
    meta: email_45signing_45certificateYUTTR0tFr5Meta || {},
    alias: email_45signing_45certificateYUTTR0tFr5Meta?.alias || [],
    redirect: email_45signing_45certificateYUTTR0tFr5Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/email-signing-certificate.vue").then(m => m.default || m)
  },
  {
    name: emailNm3dg7jxqiMeta?.name ?? "email___en",
    path: emailNm3dg7jxqiMeta?.path ?? "/email",
    meta: emailNm3dg7jxqiMeta || {},
    alias: emailNm3dg7jxqiMeta?.alias || [],
    redirect: emailNm3dg7jxqiMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/email.vue").then(m => m.default || m)
  },
  {
    name: emailNm3dg7jxqiMeta?.name ?? "email___zh-cn",
    path: emailNm3dg7jxqiMeta?.path ?? "/zh-cn/email",
    meta: emailNm3dg7jxqiMeta || {},
    alias: emailNm3dg7jxqiMeta?.alias || [],
    redirect: emailNm3dg7jxqiMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/email.vue").then(m => m.default || m)
  },
  {
    name: emailNm3dg7jxqiMeta?.name ?? "email___zh-tw",
    path: emailNm3dg7jxqiMeta?.path ?? "/zh-tw/email",
    meta: emailNm3dg7jxqiMeta || {},
    alias: emailNm3dg7jxqiMeta?.alias || [],
    redirect: emailNm3dg7jxqiMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/email.vue").then(m => m.default || m)
  },
  {
    name: emailNm3dg7jxqiMeta?.name ?? "email___jp",
    path: emailNm3dg7jxqiMeta?.path ?? "/jp/email",
    meta: emailNm3dg7jxqiMeta || {},
    alias: emailNm3dg7jxqiMeta?.alias || [],
    redirect: emailNm3dg7jxqiMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/email.vue").then(m => m.default || m)
  },
  {
    name: emailNm3dg7jxqiMeta?.name ?? "email___es",
    path: emailNm3dg7jxqiMeta?.path ?? "/es/email",
    meta: emailNm3dg7jxqiMeta || {},
    alias: emailNm3dg7jxqiMeta?.alias || [],
    redirect: emailNm3dg7jxqiMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/email.vue").then(m => m.default || m)
  },
  {
    name: emailNm3dg7jxqiMeta?.name ?? "email___fr",
    path: emailNm3dg7jxqiMeta?.path ?? "/fr/email",
    meta: emailNm3dg7jxqiMeta || {},
    alias: emailNm3dg7jxqiMeta?.alias || [],
    redirect: emailNm3dg7jxqiMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/email.vue").then(m => m.default || m)
  },
  {
    name: emailNm3dg7jxqiMeta?.name ?? "email___de",
    path: emailNm3dg7jxqiMeta?.path ?? "/de/email",
    meta: emailNm3dg7jxqiMeta || {},
    alias: emailNm3dg7jxqiMeta?.alias || [],
    redirect: emailNm3dg7jxqiMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/email.vue").then(m => m.default || m)
  },
  {
    name: emailNm3dg7jxqiMeta?.name ?? "email___kr",
    path: emailNm3dg7jxqiMeta?.path ?? "/kr/email",
    meta: emailNm3dg7jxqiMeta || {},
    alias: emailNm3dg7jxqiMeta?.alias || [],
    redirect: emailNm3dg7jxqiMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/email.vue").then(m => m.default || m)
  },
  {
    name: emailNm3dg7jxqiMeta?.name ?? "email___vn",
    path: emailNm3dg7jxqiMeta?.path ?? "/vn/email",
    meta: emailNm3dg7jxqiMeta || {},
    alias: emailNm3dg7jxqiMeta?.alias || [],
    redirect: emailNm3dg7jxqiMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/email.vue").then(m => m.default || m)
  },
  {
    name: emailNm3dg7jxqiMeta?.name ?? "email___th",
    path: emailNm3dg7jxqiMeta?.path ?? "/th/email",
    meta: emailNm3dg7jxqiMeta || {},
    alias: emailNm3dg7jxqiMeta?.alias || [],
    redirect: emailNm3dg7jxqiMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/email.vue").then(m => m.default || m)
  },
  {
    name: emailNm3dg7jxqiMeta?.name ?? "email___ru",
    path: emailNm3dg7jxqiMeta?.path ?? "/ru/email",
    meta: emailNm3dg7jxqiMeta || {},
    alias: emailNm3dg7jxqiMeta?.alias || [],
    redirect: emailNm3dg7jxqiMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/email.vue").then(m => m.default || m)
  },
  {
    name: emailNm3dg7jxqiMeta?.name ?? "email___tr",
    path: emailNm3dg7jxqiMeta?.path ?? "/tr/email",
    meta: emailNm3dg7jxqiMeta || {},
    alias: emailNm3dg7jxqiMeta?.alias || [],
    redirect: emailNm3dg7jxqiMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/email.vue").then(m => m.default || m)
  },
  {
    name: generate_45csrozaAjAzDhzMeta?.name ?? "generate-csr___en",
    path: generate_45csrozaAjAzDhzMeta?.path ?? "/generate-csr",
    meta: generate_45csrozaAjAzDhzMeta || {},
    alias: generate_45csrozaAjAzDhzMeta?.alias || [],
    redirect: generate_45csrozaAjAzDhzMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/generate-csr.vue").then(m => m.default || m)
  },
  {
    name: generate_45csrozaAjAzDhzMeta?.name ?? "generate-csr___zh-cn",
    path: generate_45csrozaAjAzDhzMeta?.path ?? "/zh-cn/generate-csr",
    meta: generate_45csrozaAjAzDhzMeta || {},
    alias: generate_45csrozaAjAzDhzMeta?.alias || [],
    redirect: generate_45csrozaAjAzDhzMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/generate-csr.vue").then(m => m.default || m)
  },
  {
    name: generate_45csrozaAjAzDhzMeta?.name ?? "generate-csr___zh-tw",
    path: generate_45csrozaAjAzDhzMeta?.path ?? "/zh-tw/generate-csr",
    meta: generate_45csrozaAjAzDhzMeta || {},
    alias: generate_45csrozaAjAzDhzMeta?.alias || [],
    redirect: generate_45csrozaAjAzDhzMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/generate-csr.vue").then(m => m.default || m)
  },
  {
    name: generate_45csrozaAjAzDhzMeta?.name ?? "generate-csr___jp",
    path: generate_45csrozaAjAzDhzMeta?.path ?? "/jp/generate-csr",
    meta: generate_45csrozaAjAzDhzMeta || {},
    alias: generate_45csrozaAjAzDhzMeta?.alias || [],
    redirect: generate_45csrozaAjAzDhzMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/generate-csr.vue").then(m => m.default || m)
  },
  {
    name: generate_45csrozaAjAzDhzMeta?.name ?? "generate-csr___es",
    path: generate_45csrozaAjAzDhzMeta?.path ?? "/es/generate-csr",
    meta: generate_45csrozaAjAzDhzMeta || {},
    alias: generate_45csrozaAjAzDhzMeta?.alias || [],
    redirect: generate_45csrozaAjAzDhzMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/generate-csr.vue").then(m => m.default || m)
  },
  {
    name: generate_45csrozaAjAzDhzMeta?.name ?? "generate-csr___fr",
    path: generate_45csrozaAjAzDhzMeta?.path ?? "/fr/generate-csr",
    meta: generate_45csrozaAjAzDhzMeta || {},
    alias: generate_45csrozaAjAzDhzMeta?.alias || [],
    redirect: generate_45csrozaAjAzDhzMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/generate-csr.vue").then(m => m.default || m)
  },
  {
    name: generate_45csrozaAjAzDhzMeta?.name ?? "generate-csr___de",
    path: generate_45csrozaAjAzDhzMeta?.path ?? "/de/generate-csr",
    meta: generate_45csrozaAjAzDhzMeta || {},
    alias: generate_45csrozaAjAzDhzMeta?.alias || [],
    redirect: generate_45csrozaAjAzDhzMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/generate-csr.vue").then(m => m.default || m)
  },
  {
    name: generate_45csrozaAjAzDhzMeta?.name ?? "generate-csr___kr",
    path: generate_45csrozaAjAzDhzMeta?.path ?? "/kr/generate-csr",
    meta: generate_45csrozaAjAzDhzMeta || {},
    alias: generate_45csrozaAjAzDhzMeta?.alias || [],
    redirect: generate_45csrozaAjAzDhzMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/generate-csr.vue").then(m => m.default || m)
  },
  {
    name: generate_45csrozaAjAzDhzMeta?.name ?? "generate-csr___vn",
    path: generate_45csrozaAjAzDhzMeta?.path ?? "/vn/generate-csr",
    meta: generate_45csrozaAjAzDhzMeta || {},
    alias: generate_45csrozaAjAzDhzMeta?.alias || [],
    redirect: generate_45csrozaAjAzDhzMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/generate-csr.vue").then(m => m.default || m)
  },
  {
    name: generate_45csrozaAjAzDhzMeta?.name ?? "generate-csr___th",
    path: generate_45csrozaAjAzDhzMeta?.path ?? "/th/generate-csr",
    meta: generate_45csrozaAjAzDhzMeta || {},
    alias: generate_45csrozaAjAzDhzMeta?.alias || [],
    redirect: generate_45csrozaAjAzDhzMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/generate-csr.vue").then(m => m.default || m)
  },
  {
    name: generate_45csrozaAjAzDhzMeta?.name ?? "generate-csr___ru",
    path: generate_45csrozaAjAzDhzMeta?.path ?? "/ru/generate-csr",
    meta: generate_45csrozaAjAzDhzMeta || {},
    alias: generate_45csrozaAjAzDhzMeta?.alias || [],
    redirect: generate_45csrozaAjAzDhzMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/generate-csr.vue").then(m => m.default || m)
  },
  {
    name: generate_45csrozaAjAzDhzMeta?.name ?? "generate-csr___tr",
    path: generate_45csrozaAjAzDhzMeta?.path ?? "/tr/generate-csr",
    meta: generate_45csrozaAjAzDhzMeta || {},
    alias: generate_45csrozaAjAzDhzMeta?.alias || [],
    redirect: generate_45csrozaAjAzDhzMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/generate-csr.vue").then(m => m.default || m)
  },
  {
    name: help_45centerDJyrZOPD8mMeta?.name ?? "help-center___en",
    path: help_45centerDJyrZOPD8mMeta?.path ?? "/help-center",
    meta: help_45centerDJyrZOPD8mMeta || {},
    alias: help_45centerDJyrZOPD8mMeta?.alias || [],
    redirect: help_45centerDJyrZOPD8mMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/help-center.vue").then(m => m.default || m)
  },
  {
    name: help_45centerDJyrZOPD8mMeta?.name ?? "help-center___zh-cn",
    path: help_45centerDJyrZOPD8mMeta?.path ?? "/zh-cn/help-center",
    meta: help_45centerDJyrZOPD8mMeta || {},
    alias: help_45centerDJyrZOPD8mMeta?.alias || [],
    redirect: help_45centerDJyrZOPD8mMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/help-center.vue").then(m => m.default || m)
  },
  {
    name: help_45centerDJyrZOPD8mMeta?.name ?? "help-center___zh-tw",
    path: help_45centerDJyrZOPD8mMeta?.path ?? "/zh-tw/help-center",
    meta: help_45centerDJyrZOPD8mMeta || {},
    alias: help_45centerDJyrZOPD8mMeta?.alias || [],
    redirect: help_45centerDJyrZOPD8mMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/help-center.vue").then(m => m.default || m)
  },
  {
    name: help_45centerDJyrZOPD8mMeta?.name ?? "help-center___jp",
    path: help_45centerDJyrZOPD8mMeta?.path ?? "/jp/help-center",
    meta: help_45centerDJyrZOPD8mMeta || {},
    alias: help_45centerDJyrZOPD8mMeta?.alias || [],
    redirect: help_45centerDJyrZOPD8mMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/help-center.vue").then(m => m.default || m)
  },
  {
    name: help_45centerDJyrZOPD8mMeta?.name ?? "help-center___es",
    path: help_45centerDJyrZOPD8mMeta?.path ?? "/es/help-center",
    meta: help_45centerDJyrZOPD8mMeta || {},
    alias: help_45centerDJyrZOPD8mMeta?.alias || [],
    redirect: help_45centerDJyrZOPD8mMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/help-center.vue").then(m => m.default || m)
  },
  {
    name: help_45centerDJyrZOPD8mMeta?.name ?? "help-center___fr",
    path: help_45centerDJyrZOPD8mMeta?.path ?? "/fr/help-center",
    meta: help_45centerDJyrZOPD8mMeta || {},
    alias: help_45centerDJyrZOPD8mMeta?.alias || [],
    redirect: help_45centerDJyrZOPD8mMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/help-center.vue").then(m => m.default || m)
  },
  {
    name: help_45centerDJyrZOPD8mMeta?.name ?? "help-center___de",
    path: help_45centerDJyrZOPD8mMeta?.path ?? "/de/help-center",
    meta: help_45centerDJyrZOPD8mMeta || {},
    alias: help_45centerDJyrZOPD8mMeta?.alias || [],
    redirect: help_45centerDJyrZOPD8mMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/help-center.vue").then(m => m.default || m)
  },
  {
    name: help_45centerDJyrZOPD8mMeta?.name ?? "help-center___kr",
    path: help_45centerDJyrZOPD8mMeta?.path ?? "/kr/help-center",
    meta: help_45centerDJyrZOPD8mMeta || {},
    alias: help_45centerDJyrZOPD8mMeta?.alias || [],
    redirect: help_45centerDJyrZOPD8mMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/help-center.vue").then(m => m.default || m)
  },
  {
    name: help_45centerDJyrZOPD8mMeta?.name ?? "help-center___vn",
    path: help_45centerDJyrZOPD8mMeta?.path ?? "/vn/help-center",
    meta: help_45centerDJyrZOPD8mMeta || {},
    alias: help_45centerDJyrZOPD8mMeta?.alias || [],
    redirect: help_45centerDJyrZOPD8mMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/help-center.vue").then(m => m.default || m)
  },
  {
    name: help_45centerDJyrZOPD8mMeta?.name ?? "help-center___th",
    path: help_45centerDJyrZOPD8mMeta?.path ?? "/th/help-center",
    meta: help_45centerDJyrZOPD8mMeta || {},
    alias: help_45centerDJyrZOPD8mMeta?.alias || [],
    redirect: help_45centerDJyrZOPD8mMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/help-center.vue").then(m => m.default || m)
  },
  {
    name: help_45centerDJyrZOPD8mMeta?.name ?? "help-center___ru",
    path: help_45centerDJyrZOPD8mMeta?.path ?? "/ru/help-center",
    meta: help_45centerDJyrZOPD8mMeta || {},
    alias: help_45centerDJyrZOPD8mMeta?.alias || [],
    redirect: help_45centerDJyrZOPD8mMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/help-center.vue").then(m => m.default || m)
  },
  {
    name: help_45centerDJyrZOPD8mMeta?.name ?? "help-center___tr",
    path: help_45centerDJyrZOPD8mMeta?.path ?? "/tr/help-center",
    meta: help_45centerDJyrZOPD8mMeta || {},
    alias: help_45centerDJyrZOPD8mMeta?.alias || [],
    redirect: help_45centerDJyrZOPD8mMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/help-center.vue").then(m => m.default || m)
  },
  {
    name: _91id_93wt7dSLxfvBMeta?.name ?? "help-detail-id___en",
    path: _91id_93wt7dSLxfvBMeta?.path ?? "/help-detail/:id()",
    meta: _91id_93wt7dSLxfvBMeta || {},
    alias: _91id_93wt7dSLxfvBMeta?.alias || [],
    redirect: _91id_93wt7dSLxfvBMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/help-detail/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93wt7dSLxfvBMeta?.name ?? "help-detail-id___zh-cn",
    path: _91id_93wt7dSLxfvBMeta?.path ?? "/zh-cn/help-detail/:id()",
    meta: _91id_93wt7dSLxfvBMeta || {},
    alias: _91id_93wt7dSLxfvBMeta?.alias || [],
    redirect: _91id_93wt7dSLxfvBMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/help-detail/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93wt7dSLxfvBMeta?.name ?? "help-detail-id___zh-tw",
    path: _91id_93wt7dSLxfvBMeta?.path ?? "/zh-tw/help-detail/:id()",
    meta: _91id_93wt7dSLxfvBMeta || {},
    alias: _91id_93wt7dSLxfvBMeta?.alias || [],
    redirect: _91id_93wt7dSLxfvBMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/help-detail/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93wt7dSLxfvBMeta?.name ?? "help-detail-id___jp",
    path: _91id_93wt7dSLxfvBMeta?.path ?? "/jp/help-detail/:id()",
    meta: _91id_93wt7dSLxfvBMeta || {},
    alias: _91id_93wt7dSLxfvBMeta?.alias || [],
    redirect: _91id_93wt7dSLxfvBMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/help-detail/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93wt7dSLxfvBMeta?.name ?? "help-detail-id___es",
    path: _91id_93wt7dSLxfvBMeta?.path ?? "/es/help-detail/:id()",
    meta: _91id_93wt7dSLxfvBMeta || {},
    alias: _91id_93wt7dSLxfvBMeta?.alias || [],
    redirect: _91id_93wt7dSLxfvBMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/help-detail/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93wt7dSLxfvBMeta?.name ?? "help-detail-id___fr",
    path: _91id_93wt7dSLxfvBMeta?.path ?? "/fr/help-detail/:id()",
    meta: _91id_93wt7dSLxfvBMeta || {},
    alias: _91id_93wt7dSLxfvBMeta?.alias || [],
    redirect: _91id_93wt7dSLxfvBMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/help-detail/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93wt7dSLxfvBMeta?.name ?? "help-detail-id___de",
    path: _91id_93wt7dSLxfvBMeta?.path ?? "/de/help-detail/:id()",
    meta: _91id_93wt7dSLxfvBMeta || {},
    alias: _91id_93wt7dSLxfvBMeta?.alias || [],
    redirect: _91id_93wt7dSLxfvBMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/help-detail/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93wt7dSLxfvBMeta?.name ?? "help-detail-id___kr",
    path: _91id_93wt7dSLxfvBMeta?.path ?? "/kr/help-detail/:id()",
    meta: _91id_93wt7dSLxfvBMeta || {},
    alias: _91id_93wt7dSLxfvBMeta?.alias || [],
    redirect: _91id_93wt7dSLxfvBMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/help-detail/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93wt7dSLxfvBMeta?.name ?? "help-detail-id___vn",
    path: _91id_93wt7dSLxfvBMeta?.path ?? "/vn/help-detail/:id()",
    meta: _91id_93wt7dSLxfvBMeta || {},
    alias: _91id_93wt7dSLxfvBMeta?.alias || [],
    redirect: _91id_93wt7dSLxfvBMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/help-detail/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93wt7dSLxfvBMeta?.name ?? "help-detail-id___th",
    path: _91id_93wt7dSLxfvBMeta?.path ?? "/th/help-detail/:id()",
    meta: _91id_93wt7dSLxfvBMeta || {},
    alias: _91id_93wt7dSLxfvBMeta?.alias || [],
    redirect: _91id_93wt7dSLxfvBMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/help-detail/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93wt7dSLxfvBMeta?.name ?? "help-detail-id___ru",
    path: _91id_93wt7dSLxfvBMeta?.path ?? "/ru/help-detail/:id()",
    meta: _91id_93wt7dSLxfvBMeta || {},
    alias: _91id_93wt7dSLxfvBMeta?.alias || [],
    redirect: _91id_93wt7dSLxfvBMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/help-detail/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93wt7dSLxfvBMeta?.name ?? "help-detail-id___tr",
    path: _91id_93wt7dSLxfvBMeta?.path ?? "/tr/help-detail/:id()",
    meta: _91id_93wt7dSLxfvBMeta || {},
    alias: _91id_93wt7dSLxfvBMeta?.alias || [],
    redirect: _91id_93wt7dSLxfvBMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/help-detail/[id].vue").then(m => m.default || m)
  },
  {
    name: _91pname_938Kjdn9n9J0Meta?.name ?? "help-list-pname___en",
    path: _91pname_938Kjdn9n9J0Meta?.path ?? "/help-list/:pname()",
    meta: _91pname_938Kjdn9n9J0Meta || {},
    alias: _91pname_938Kjdn9n9J0Meta?.alias || [],
    redirect: _91pname_938Kjdn9n9J0Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/help-list/[pname].vue").then(m => m.default || m)
  },
  {
    name: _91pname_938Kjdn9n9J0Meta?.name ?? "help-list-pname___zh-cn",
    path: _91pname_938Kjdn9n9J0Meta?.path ?? "/zh-cn/help-list/:pname()",
    meta: _91pname_938Kjdn9n9J0Meta || {},
    alias: _91pname_938Kjdn9n9J0Meta?.alias || [],
    redirect: _91pname_938Kjdn9n9J0Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/help-list/[pname].vue").then(m => m.default || m)
  },
  {
    name: _91pname_938Kjdn9n9J0Meta?.name ?? "help-list-pname___zh-tw",
    path: _91pname_938Kjdn9n9J0Meta?.path ?? "/zh-tw/help-list/:pname()",
    meta: _91pname_938Kjdn9n9J0Meta || {},
    alias: _91pname_938Kjdn9n9J0Meta?.alias || [],
    redirect: _91pname_938Kjdn9n9J0Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/help-list/[pname].vue").then(m => m.default || m)
  },
  {
    name: _91pname_938Kjdn9n9J0Meta?.name ?? "help-list-pname___jp",
    path: _91pname_938Kjdn9n9J0Meta?.path ?? "/jp/help-list/:pname()",
    meta: _91pname_938Kjdn9n9J0Meta || {},
    alias: _91pname_938Kjdn9n9J0Meta?.alias || [],
    redirect: _91pname_938Kjdn9n9J0Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/help-list/[pname].vue").then(m => m.default || m)
  },
  {
    name: _91pname_938Kjdn9n9J0Meta?.name ?? "help-list-pname___es",
    path: _91pname_938Kjdn9n9J0Meta?.path ?? "/es/help-list/:pname()",
    meta: _91pname_938Kjdn9n9J0Meta || {},
    alias: _91pname_938Kjdn9n9J0Meta?.alias || [],
    redirect: _91pname_938Kjdn9n9J0Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/help-list/[pname].vue").then(m => m.default || m)
  },
  {
    name: _91pname_938Kjdn9n9J0Meta?.name ?? "help-list-pname___fr",
    path: _91pname_938Kjdn9n9J0Meta?.path ?? "/fr/help-list/:pname()",
    meta: _91pname_938Kjdn9n9J0Meta || {},
    alias: _91pname_938Kjdn9n9J0Meta?.alias || [],
    redirect: _91pname_938Kjdn9n9J0Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/help-list/[pname].vue").then(m => m.default || m)
  },
  {
    name: _91pname_938Kjdn9n9J0Meta?.name ?? "help-list-pname___de",
    path: _91pname_938Kjdn9n9J0Meta?.path ?? "/de/help-list/:pname()",
    meta: _91pname_938Kjdn9n9J0Meta || {},
    alias: _91pname_938Kjdn9n9J0Meta?.alias || [],
    redirect: _91pname_938Kjdn9n9J0Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/help-list/[pname].vue").then(m => m.default || m)
  },
  {
    name: _91pname_938Kjdn9n9J0Meta?.name ?? "help-list-pname___kr",
    path: _91pname_938Kjdn9n9J0Meta?.path ?? "/kr/help-list/:pname()",
    meta: _91pname_938Kjdn9n9J0Meta || {},
    alias: _91pname_938Kjdn9n9J0Meta?.alias || [],
    redirect: _91pname_938Kjdn9n9J0Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/help-list/[pname].vue").then(m => m.default || m)
  },
  {
    name: _91pname_938Kjdn9n9J0Meta?.name ?? "help-list-pname___vn",
    path: _91pname_938Kjdn9n9J0Meta?.path ?? "/vn/help-list/:pname()",
    meta: _91pname_938Kjdn9n9J0Meta || {},
    alias: _91pname_938Kjdn9n9J0Meta?.alias || [],
    redirect: _91pname_938Kjdn9n9J0Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/help-list/[pname].vue").then(m => m.default || m)
  },
  {
    name: _91pname_938Kjdn9n9J0Meta?.name ?? "help-list-pname___th",
    path: _91pname_938Kjdn9n9J0Meta?.path ?? "/th/help-list/:pname()",
    meta: _91pname_938Kjdn9n9J0Meta || {},
    alias: _91pname_938Kjdn9n9J0Meta?.alias || [],
    redirect: _91pname_938Kjdn9n9J0Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/help-list/[pname].vue").then(m => m.default || m)
  },
  {
    name: _91pname_938Kjdn9n9J0Meta?.name ?? "help-list-pname___ru",
    path: _91pname_938Kjdn9n9J0Meta?.path ?? "/ru/help-list/:pname()",
    meta: _91pname_938Kjdn9n9J0Meta || {},
    alias: _91pname_938Kjdn9n9J0Meta?.alias || [],
    redirect: _91pname_938Kjdn9n9J0Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/help-list/[pname].vue").then(m => m.default || m)
  },
  {
    name: _91pname_938Kjdn9n9J0Meta?.name ?? "help-list-pname___tr",
    path: _91pname_938Kjdn9n9J0Meta?.path ?? "/tr/help-list/:pname()",
    meta: _91pname_938Kjdn9n9J0Meta || {},
    alias: _91pname_938Kjdn9n9J0Meta?.alias || [],
    redirect: _91pname_938Kjdn9n9J0Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/help-list/[pname].vue").then(m => m.default || m)
  },
  {
    name: _91key_938HAeI1aJXtMeta?.name ?? "help-search-key___en",
    path: _91key_938HAeI1aJXtMeta?.path ?? "/help-search/:key()",
    meta: _91key_938HAeI1aJXtMeta || {},
    alias: _91key_938HAeI1aJXtMeta?.alias || [],
    redirect: _91key_938HAeI1aJXtMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/help-search/[key].vue").then(m => m.default || m)
  },
  {
    name: _91key_938HAeI1aJXtMeta?.name ?? "help-search-key___zh-cn",
    path: _91key_938HAeI1aJXtMeta?.path ?? "/zh-cn/help-search/:key()",
    meta: _91key_938HAeI1aJXtMeta || {},
    alias: _91key_938HAeI1aJXtMeta?.alias || [],
    redirect: _91key_938HAeI1aJXtMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/help-search/[key].vue").then(m => m.default || m)
  },
  {
    name: _91key_938HAeI1aJXtMeta?.name ?? "help-search-key___zh-tw",
    path: _91key_938HAeI1aJXtMeta?.path ?? "/zh-tw/help-search/:key()",
    meta: _91key_938HAeI1aJXtMeta || {},
    alias: _91key_938HAeI1aJXtMeta?.alias || [],
    redirect: _91key_938HAeI1aJXtMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/help-search/[key].vue").then(m => m.default || m)
  },
  {
    name: _91key_938HAeI1aJXtMeta?.name ?? "help-search-key___jp",
    path: _91key_938HAeI1aJXtMeta?.path ?? "/jp/help-search/:key()",
    meta: _91key_938HAeI1aJXtMeta || {},
    alias: _91key_938HAeI1aJXtMeta?.alias || [],
    redirect: _91key_938HAeI1aJXtMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/help-search/[key].vue").then(m => m.default || m)
  },
  {
    name: _91key_938HAeI1aJXtMeta?.name ?? "help-search-key___es",
    path: _91key_938HAeI1aJXtMeta?.path ?? "/es/help-search/:key()",
    meta: _91key_938HAeI1aJXtMeta || {},
    alias: _91key_938HAeI1aJXtMeta?.alias || [],
    redirect: _91key_938HAeI1aJXtMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/help-search/[key].vue").then(m => m.default || m)
  },
  {
    name: _91key_938HAeI1aJXtMeta?.name ?? "help-search-key___fr",
    path: _91key_938HAeI1aJXtMeta?.path ?? "/fr/help-search/:key()",
    meta: _91key_938HAeI1aJXtMeta || {},
    alias: _91key_938HAeI1aJXtMeta?.alias || [],
    redirect: _91key_938HAeI1aJXtMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/help-search/[key].vue").then(m => m.default || m)
  },
  {
    name: _91key_938HAeI1aJXtMeta?.name ?? "help-search-key___de",
    path: _91key_938HAeI1aJXtMeta?.path ?? "/de/help-search/:key()",
    meta: _91key_938HAeI1aJXtMeta || {},
    alias: _91key_938HAeI1aJXtMeta?.alias || [],
    redirect: _91key_938HAeI1aJXtMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/help-search/[key].vue").then(m => m.default || m)
  },
  {
    name: _91key_938HAeI1aJXtMeta?.name ?? "help-search-key___kr",
    path: _91key_938HAeI1aJXtMeta?.path ?? "/kr/help-search/:key()",
    meta: _91key_938HAeI1aJXtMeta || {},
    alias: _91key_938HAeI1aJXtMeta?.alias || [],
    redirect: _91key_938HAeI1aJXtMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/help-search/[key].vue").then(m => m.default || m)
  },
  {
    name: _91key_938HAeI1aJXtMeta?.name ?? "help-search-key___vn",
    path: _91key_938HAeI1aJXtMeta?.path ?? "/vn/help-search/:key()",
    meta: _91key_938HAeI1aJXtMeta || {},
    alias: _91key_938HAeI1aJXtMeta?.alias || [],
    redirect: _91key_938HAeI1aJXtMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/help-search/[key].vue").then(m => m.default || m)
  },
  {
    name: _91key_938HAeI1aJXtMeta?.name ?? "help-search-key___th",
    path: _91key_938HAeI1aJXtMeta?.path ?? "/th/help-search/:key()",
    meta: _91key_938HAeI1aJXtMeta || {},
    alias: _91key_938HAeI1aJXtMeta?.alias || [],
    redirect: _91key_938HAeI1aJXtMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/help-search/[key].vue").then(m => m.default || m)
  },
  {
    name: _91key_938HAeI1aJXtMeta?.name ?? "help-search-key___ru",
    path: _91key_938HAeI1aJXtMeta?.path ?? "/ru/help-search/:key()",
    meta: _91key_938HAeI1aJXtMeta || {},
    alias: _91key_938HAeI1aJXtMeta?.alias || [],
    redirect: _91key_938HAeI1aJXtMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/help-search/[key].vue").then(m => m.default || m)
  },
  {
    name: _91key_938HAeI1aJXtMeta?.name ?? "help-search-key___tr",
    path: _91key_938HAeI1aJXtMeta?.path ?? "/tr/help-search/:key()",
    meta: _91key_938HAeI1aJXtMeta || {},
    alias: _91key_938HAeI1aJXtMeta?.alias || [],
    redirect: _91key_938HAeI1aJXtMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/help-search/[key].vue").then(m => m.default || m)
  },
  {
    name: _91name_93YrLVpQEu5mMeta?.name ?? "hosting-cms-name___en",
    path: _91name_93YrLVpQEu5mMeta?.path ?? "/hosting/cms/:name()",
    meta: _91name_93YrLVpQEu5mMeta || {},
    alias: _91name_93YrLVpQEu5mMeta?.alias || [],
    redirect: _91name_93YrLVpQEu5mMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/hosting/cms/[name].vue").then(m => m.default || m)
  },
  {
    name: _91name_93YrLVpQEu5mMeta?.name ?? "hosting-cms-name___zh-cn",
    path: _91name_93YrLVpQEu5mMeta?.path ?? "/zh-cn/hosting/cms/:name()",
    meta: _91name_93YrLVpQEu5mMeta || {},
    alias: _91name_93YrLVpQEu5mMeta?.alias || [],
    redirect: _91name_93YrLVpQEu5mMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/hosting/cms/[name].vue").then(m => m.default || m)
  },
  {
    name: _91name_93YrLVpQEu5mMeta?.name ?? "hosting-cms-name___zh-tw",
    path: _91name_93YrLVpQEu5mMeta?.path ?? "/zh-tw/hosting/cms/:name()",
    meta: _91name_93YrLVpQEu5mMeta || {},
    alias: _91name_93YrLVpQEu5mMeta?.alias || [],
    redirect: _91name_93YrLVpQEu5mMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/hosting/cms/[name].vue").then(m => m.default || m)
  },
  {
    name: _91name_93YrLVpQEu5mMeta?.name ?? "hosting-cms-name___jp",
    path: _91name_93YrLVpQEu5mMeta?.path ?? "/jp/hosting/cms/:name()",
    meta: _91name_93YrLVpQEu5mMeta || {},
    alias: _91name_93YrLVpQEu5mMeta?.alias || [],
    redirect: _91name_93YrLVpQEu5mMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/hosting/cms/[name].vue").then(m => m.default || m)
  },
  {
    name: _91name_93YrLVpQEu5mMeta?.name ?? "hosting-cms-name___es",
    path: _91name_93YrLVpQEu5mMeta?.path ?? "/es/hosting/cms/:name()",
    meta: _91name_93YrLVpQEu5mMeta || {},
    alias: _91name_93YrLVpQEu5mMeta?.alias || [],
    redirect: _91name_93YrLVpQEu5mMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/hosting/cms/[name].vue").then(m => m.default || m)
  },
  {
    name: _91name_93YrLVpQEu5mMeta?.name ?? "hosting-cms-name___fr",
    path: _91name_93YrLVpQEu5mMeta?.path ?? "/fr/hosting/cms/:name()",
    meta: _91name_93YrLVpQEu5mMeta || {},
    alias: _91name_93YrLVpQEu5mMeta?.alias || [],
    redirect: _91name_93YrLVpQEu5mMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/hosting/cms/[name].vue").then(m => m.default || m)
  },
  {
    name: _91name_93YrLVpQEu5mMeta?.name ?? "hosting-cms-name___de",
    path: _91name_93YrLVpQEu5mMeta?.path ?? "/de/hosting/cms/:name()",
    meta: _91name_93YrLVpQEu5mMeta || {},
    alias: _91name_93YrLVpQEu5mMeta?.alias || [],
    redirect: _91name_93YrLVpQEu5mMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/hosting/cms/[name].vue").then(m => m.default || m)
  },
  {
    name: _91name_93YrLVpQEu5mMeta?.name ?? "hosting-cms-name___kr",
    path: _91name_93YrLVpQEu5mMeta?.path ?? "/kr/hosting/cms/:name()",
    meta: _91name_93YrLVpQEu5mMeta || {},
    alias: _91name_93YrLVpQEu5mMeta?.alias || [],
    redirect: _91name_93YrLVpQEu5mMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/hosting/cms/[name].vue").then(m => m.default || m)
  },
  {
    name: _91name_93YrLVpQEu5mMeta?.name ?? "hosting-cms-name___vn",
    path: _91name_93YrLVpQEu5mMeta?.path ?? "/vn/hosting/cms/:name()",
    meta: _91name_93YrLVpQEu5mMeta || {},
    alias: _91name_93YrLVpQEu5mMeta?.alias || [],
    redirect: _91name_93YrLVpQEu5mMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/hosting/cms/[name].vue").then(m => m.default || m)
  },
  {
    name: _91name_93YrLVpQEu5mMeta?.name ?? "hosting-cms-name___th",
    path: _91name_93YrLVpQEu5mMeta?.path ?? "/th/hosting/cms/:name()",
    meta: _91name_93YrLVpQEu5mMeta || {},
    alias: _91name_93YrLVpQEu5mMeta?.alias || [],
    redirect: _91name_93YrLVpQEu5mMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/hosting/cms/[name].vue").then(m => m.default || m)
  },
  {
    name: _91name_93YrLVpQEu5mMeta?.name ?? "hosting-cms-name___ru",
    path: _91name_93YrLVpQEu5mMeta?.path ?? "/ru/hosting/cms/:name()",
    meta: _91name_93YrLVpQEu5mMeta || {},
    alias: _91name_93YrLVpQEu5mMeta?.alias || [],
    redirect: _91name_93YrLVpQEu5mMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/hosting/cms/[name].vue").then(m => m.default || m)
  },
  {
    name: _91name_93YrLVpQEu5mMeta?.name ?? "hosting-cms-name___tr",
    path: _91name_93YrLVpQEu5mMeta?.path ?? "/tr/hosting/cms/:name()",
    meta: _91name_93YrLVpQEu5mMeta || {},
    alias: _91name_93YrLVpQEu5mMeta?.alias || [],
    redirect: _91name_93YrLVpQEu5mMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/hosting/cms/[name].vue").then(m => m.default || m)
  },
  {
    name: _91name_93MqhNGWM3TcMeta?.name ?? "hosting-location-name___en",
    path: _91name_93MqhNGWM3TcMeta?.path ?? "/hosting/location/:name()",
    meta: _91name_93MqhNGWM3TcMeta || {},
    alias: _91name_93MqhNGWM3TcMeta?.alias || [],
    redirect: _91name_93MqhNGWM3TcMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/hosting/location/[name].vue").then(m => m.default || m)
  },
  {
    name: _91name_93MqhNGWM3TcMeta?.name ?? "hosting-location-name___zh-cn",
    path: _91name_93MqhNGWM3TcMeta?.path ?? "/zh-cn/hosting/location/:name()",
    meta: _91name_93MqhNGWM3TcMeta || {},
    alias: _91name_93MqhNGWM3TcMeta?.alias || [],
    redirect: _91name_93MqhNGWM3TcMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/hosting/location/[name].vue").then(m => m.default || m)
  },
  {
    name: _91name_93MqhNGWM3TcMeta?.name ?? "hosting-location-name___zh-tw",
    path: _91name_93MqhNGWM3TcMeta?.path ?? "/zh-tw/hosting/location/:name()",
    meta: _91name_93MqhNGWM3TcMeta || {},
    alias: _91name_93MqhNGWM3TcMeta?.alias || [],
    redirect: _91name_93MqhNGWM3TcMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/hosting/location/[name].vue").then(m => m.default || m)
  },
  {
    name: _91name_93MqhNGWM3TcMeta?.name ?? "hosting-location-name___jp",
    path: _91name_93MqhNGWM3TcMeta?.path ?? "/jp/hosting/location/:name()",
    meta: _91name_93MqhNGWM3TcMeta || {},
    alias: _91name_93MqhNGWM3TcMeta?.alias || [],
    redirect: _91name_93MqhNGWM3TcMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/hosting/location/[name].vue").then(m => m.default || m)
  },
  {
    name: _91name_93MqhNGWM3TcMeta?.name ?? "hosting-location-name___es",
    path: _91name_93MqhNGWM3TcMeta?.path ?? "/es/hosting/location/:name()",
    meta: _91name_93MqhNGWM3TcMeta || {},
    alias: _91name_93MqhNGWM3TcMeta?.alias || [],
    redirect: _91name_93MqhNGWM3TcMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/hosting/location/[name].vue").then(m => m.default || m)
  },
  {
    name: _91name_93MqhNGWM3TcMeta?.name ?? "hosting-location-name___fr",
    path: _91name_93MqhNGWM3TcMeta?.path ?? "/fr/hosting/location/:name()",
    meta: _91name_93MqhNGWM3TcMeta || {},
    alias: _91name_93MqhNGWM3TcMeta?.alias || [],
    redirect: _91name_93MqhNGWM3TcMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/hosting/location/[name].vue").then(m => m.default || m)
  },
  {
    name: _91name_93MqhNGWM3TcMeta?.name ?? "hosting-location-name___de",
    path: _91name_93MqhNGWM3TcMeta?.path ?? "/de/hosting/location/:name()",
    meta: _91name_93MqhNGWM3TcMeta || {},
    alias: _91name_93MqhNGWM3TcMeta?.alias || [],
    redirect: _91name_93MqhNGWM3TcMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/hosting/location/[name].vue").then(m => m.default || m)
  },
  {
    name: _91name_93MqhNGWM3TcMeta?.name ?? "hosting-location-name___kr",
    path: _91name_93MqhNGWM3TcMeta?.path ?? "/kr/hosting/location/:name()",
    meta: _91name_93MqhNGWM3TcMeta || {},
    alias: _91name_93MqhNGWM3TcMeta?.alias || [],
    redirect: _91name_93MqhNGWM3TcMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/hosting/location/[name].vue").then(m => m.default || m)
  },
  {
    name: _91name_93MqhNGWM3TcMeta?.name ?? "hosting-location-name___vn",
    path: _91name_93MqhNGWM3TcMeta?.path ?? "/vn/hosting/location/:name()",
    meta: _91name_93MqhNGWM3TcMeta || {},
    alias: _91name_93MqhNGWM3TcMeta?.alias || [],
    redirect: _91name_93MqhNGWM3TcMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/hosting/location/[name].vue").then(m => m.default || m)
  },
  {
    name: _91name_93MqhNGWM3TcMeta?.name ?? "hosting-location-name___th",
    path: _91name_93MqhNGWM3TcMeta?.path ?? "/th/hosting/location/:name()",
    meta: _91name_93MqhNGWM3TcMeta || {},
    alias: _91name_93MqhNGWM3TcMeta?.alias || [],
    redirect: _91name_93MqhNGWM3TcMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/hosting/location/[name].vue").then(m => m.default || m)
  },
  {
    name: _91name_93MqhNGWM3TcMeta?.name ?? "hosting-location-name___ru",
    path: _91name_93MqhNGWM3TcMeta?.path ?? "/ru/hosting/location/:name()",
    meta: _91name_93MqhNGWM3TcMeta || {},
    alias: _91name_93MqhNGWM3TcMeta?.alias || [],
    redirect: _91name_93MqhNGWM3TcMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/hosting/location/[name].vue").then(m => m.default || m)
  },
  {
    name: _91name_93MqhNGWM3TcMeta?.name ?? "hosting-location-name___tr",
    path: _91name_93MqhNGWM3TcMeta?.path ?? "/tr/hosting/location/:name()",
    meta: _91name_93MqhNGWM3TcMeta || {},
    alias: _91name_93MqhNGWM3TcMeta?.alias || [],
    redirect: _91name_93MqhNGWM3TcMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/hosting/location/[name].vue").then(m => m.default || m)
  },
  {
    name: _91name_93PWzjNwXTHlMeta?.name ?? "hosting-type-name___en",
    path: _91name_93PWzjNwXTHlMeta?.path ?? "/hosting/type/:name()",
    meta: _91name_93PWzjNwXTHlMeta || {},
    alias: _91name_93PWzjNwXTHlMeta?.alias || [],
    redirect: _91name_93PWzjNwXTHlMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/hosting/type/[name].vue").then(m => m.default || m)
  },
  {
    name: _91name_93PWzjNwXTHlMeta?.name ?? "hosting-type-name___zh-cn",
    path: _91name_93PWzjNwXTHlMeta?.path ?? "/zh-cn/hosting/type/:name()",
    meta: _91name_93PWzjNwXTHlMeta || {},
    alias: _91name_93PWzjNwXTHlMeta?.alias || [],
    redirect: _91name_93PWzjNwXTHlMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/hosting/type/[name].vue").then(m => m.default || m)
  },
  {
    name: _91name_93PWzjNwXTHlMeta?.name ?? "hosting-type-name___zh-tw",
    path: _91name_93PWzjNwXTHlMeta?.path ?? "/zh-tw/hosting/type/:name()",
    meta: _91name_93PWzjNwXTHlMeta || {},
    alias: _91name_93PWzjNwXTHlMeta?.alias || [],
    redirect: _91name_93PWzjNwXTHlMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/hosting/type/[name].vue").then(m => m.default || m)
  },
  {
    name: _91name_93PWzjNwXTHlMeta?.name ?? "hosting-type-name___jp",
    path: _91name_93PWzjNwXTHlMeta?.path ?? "/jp/hosting/type/:name()",
    meta: _91name_93PWzjNwXTHlMeta || {},
    alias: _91name_93PWzjNwXTHlMeta?.alias || [],
    redirect: _91name_93PWzjNwXTHlMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/hosting/type/[name].vue").then(m => m.default || m)
  },
  {
    name: _91name_93PWzjNwXTHlMeta?.name ?? "hosting-type-name___es",
    path: _91name_93PWzjNwXTHlMeta?.path ?? "/es/hosting/type/:name()",
    meta: _91name_93PWzjNwXTHlMeta || {},
    alias: _91name_93PWzjNwXTHlMeta?.alias || [],
    redirect: _91name_93PWzjNwXTHlMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/hosting/type/[name].vue").then(m => m.default || m)
  },
  {
    name: _91name_93PWzjNwXTHlMeta?.name ?? "hosting-type-name___fr",
    path: _91name_93PWzjNwXTHlMeta?.path ?? "/fr/hosting/type/:name()",
    meta: _91name_93PWzjNwXTHlMeta || {},
    alias: _91name_93PWzjNwXTHlMeta?.alias || [],
    redirect: _91name_93PWzjNwXTHlMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/hosting/type/[name].vue").then(m => m.default || m)
  },
  {
    name: _91name_93PWzjNwXTHlMeta?.name ?? "hosting-type-name___de",
    path: _91name_93PWzjNwXTHlMeta?.path ?? "/de/hosting/type/:name()",
    meta: _91name_93PWzjNwXTHlMeta || {},
    alias: _91name_93PWzjNwXTHlMeta?.alias || [],
    redirect: _91name_93PWzjNwXTHlMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/hosting/type/[name].vue").then(m => m.default || m)
  },
  {
    name: _91name_93PWzjNwXTHlMeta?.name ?? "hosting-type-name___kr",
    path: _91name_93PWzjNwXTHlMeta?.path ?? "/kr/hosting/type/:name()",
    meta: _91name_93PWzjNwXTHlMeta || {},
    alias: _91name_93PWzjNwXTHlMeta?.alias || [],
    redirect: _91name_93PWzjNwXTHlMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/hosting/type/[name].vue").then(m => m.default || m)
  },
  {
    name: _91name_93PWzjNwXTHlMeta?.name ?? "hosting-type-name___vn",
    path: _91name_93PWzjNwXTHlMeta?.path ?? "/vn/hosting/type/:name()",
    meta: _91name_93PWzjNwXTHlMeta || {},
    alias: _91name_93PWzjNwXTHlMeta?.alias || [],
    redirect: _91name_93PWzjNwXTHlMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/hosting/type/[name].vue").then(m => m.default || m)
  },
  {
    name: _91name_93PWzjNwXTHlMeta?.name ?? "hosting-type-name___th",
    path: _91name_93PWzjNwXTHlMeta?.path ?? "/th/hosting/type/:name()",
    meta: _91name_93PWzjNwXTHlMeta || {},
    alias: _91name_93PWzjNwXTHlMeta?.alias || [],
    redirect: _91name_93PWzjNwXTHlMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/hosting/type/[name].vue").then(m => m.default || m)
  },
  {
    name: _91name_93PWzjNwXTHlMeta?.name ?? "hosting-type-name___ru",
    path: _91name_93PWzjNwXTHlMeta?.path ?? "/ru/hosting/type/:name()",
    meta: _91name_93PWzjNwXTHlMeta || {},
    alias: _91name_93PWzjNwXTHlMeta?.alias || [],
    redirect: _91name_93PWzjNwXTHlMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/hosting/type/[name].vue").then(m => m.default || m)
  },
  {
    name: _91name_93PWzjNwXTHlMeta?.name ?? "hosting-type-name___tr",
    path: _91name_93PWzjNwXTHlMeta?.path ?? "/tr/hosting/type/:name()",
    meta: _91name_93PWzjNwXTHlMeta || {},
    alias: _91name_93PWzjNwXTHlMeta?.alias || [],
    redirect: _91name_93PWzjNwXTHlMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/hosting/type/[name].vue").then(m => m.default || m)
  },
  {
    name: resellerIvf8frJ4aKMeta?.name ?? "hosting-type-reseller___en",
    path: resellerIvf8frJ4aKMeta?.path ?? "/hosting/type/reseller",
    meta: resellerIvf8frJ4aKMeta || {},
    alias: resellerIvf8frJ4aKMeta?.alias || [],
    redirect: resellerIvf8frJ4aKMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/hosting/type/reseller.vue").then(m => m.default || m)
  },
  {
    name: resellerIvf8frJ4aKMeta?.name ?? "hosting-type-reseller___zh-cn",
    path: resellerIvf8frJ4aKMeta?.path ?? "/zh-cn/hosting/type/reseller",
    meta: resellerIvf8frJ4aKMeta || {},
    alias: resellerIvf8frJ4aKMeta?.alias || [],
    redirect: resellerIvf8frJ4aKMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/hosting/type/reseller.vue").then(m => m.default || m)
  },
  {
    name: resellerIvf8frJ4aKMeta?.name ?? "hosting-type-reseller___zh-tw",
    path: resellerIvf8frJ4aKMeta?.path ?? "/zh-tw/hosting/type/reseller",
    meta: resellerIvf8frJ4aKMeta || {},
    alias: resellerIvf8frJ4aKMeta?.alias || [],
    redirect: resellerIvf8frJ4aKMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/hosting/type/reseller.vue").then(m => m.default || m)
  },
  {
    name: resellerIvf8frJ4aKMeta?.name ?? "hosting-type-reseller___jp",
    path: resellerIvf8frJ4aKMeta?.path ?? "/jp/hosting/type/reseller",
    meta: resellerIvf8frJ4aKMeta || {},
    alias: resellerIvf8frJ4aKMeta?.alias || [],
    redirect: resellerIvf8frJ4aKMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/hosting/type/reseller.vue").then(m => m.default || m)
  },
  {
    name: resellerIvf8frJ4aKMeta?.name ?? "hosting-type-reseller___es",
    path: resellerIvf8frJ4aKMeta?.path ?? "/es/hosting/type/reseller",
    meta: resellerIvf8frJ4aKMeta || {},
    alias: resellerIvf8frJ4aKMeta?.alias || [],
    redirect: resellerIvf8frJ4aKMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/hosting/type/reseller.vue").then(m => m.default || m)
  },
  {
    name: resellerIvf8frJ4aKMeta?.name ?? "hosting-type-reseller___fr",
    path: resellerIvf8frJ4aKMeta?.path ?? "/fr/hosting/type/reseller",
    meta: resellerIvf8frJ4aKMeta || {},
    alias: resellerIvf8frJ4aKMeta?.alias || [],
    redirect: resellerIvf8frJ4aKMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/hosting/type/reseller.vue").then(m => m.default || m)
  },
  {
    name: resellerIvf8frJ4aKMeta?.name ?? "hosting-type-reseller___de",
    path: resellerIvf8frJ4aKMeta?.path ?? "/de/hosting/type/reseller",
    meta: resellerIvf8frJ4aKMeta || {},
    alias: resellerIvf8frJ4aKMeta?.alias || [],
    redirect: resellerIvf8frJ4aKMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/hosting/type/reseller.vue").then(m => m.default || m)
  },
  {
    name: resellerIvf8frJ4aKMeta?.name ?? "hosting-type-reseller___kr",
    path: resellerIvf8frJ4aKMeta?.path ?? "/kr/hosting/type/reseller",
    meta: resellerIvf8frJ4aKMeta || {},
    alias: resellerIvf8frJ4aKMeta?.alias || [],
    redirect: resellerIvf8frJ4aKMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/hosting/type/reseller.vue").then(m => m.default || m)
  },
  {
    name: resellerIvf8frJ4aKMeta?.name ?? "hosting-type-reseller___vn",
    path: resellerIvf8frJ4aKMeta?.path ?? "/vn/hosting/type/reseller",
    meta: resellerIvf8frJ4aKMeta || {},
    alias: resellerIvf8frJ4aKMeta?.alias || [],
    redirect: resellerIvf8frJ4aKMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/hosting/type/reseller.vue").then(m => m.default || m)
  },
  {
    name: resellerIvf8frJ4aKMeta?.name ?? "hosting-type-reseller___th",
    path: resellerIvf8frJ4aKMeta?.path ?? "/th/hosting/type/reseller",
    meta: resellerIvf8frJ4aKMeta || {},
    alias: resellerIvf8frJ4aKMeta?.alias || [],
    redirect: resellerIvf8frJ4aKMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/hosting/type/reseller.vue").then(m => m.default || m)
  },
  {
    name: resellerIvf8frJ4aKMeta?.name ?? "hosting-type-reseller___ru",
    path: resellerIvf8frJ4aKMeta?.path ?? "/ru/hosting/type/reseller",
    meta: resellerIvf8frJ4aKMeta || {},
    alias: resellerIvf8frJ4aKMeta?.alias || [],
    redirect: resellerIvf8frJ4aKMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/hosting/type/reseller.vue").then(m => m.default || m)
  },
  {
    name: resellerIvf8frJ4aKMeta?.name ?? "hosting-type-reseller___tr",
    path: resellerIvf8frJ4aKMeta?.path ?? "/tr/hosting/type/reseller",
    meta: resellerIvf8frJ4aKMeta || {},
    alias: resellerIvf8frJ4aKMeta?.alias || [],
    redirect: resellerIvf8frJ4aKMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/hosting/type/reseller.vue").then(m => m.default || m)
  },
  {
    name: indexZJfwXI1CuzMeta?.name ?? "index___en",
    path: indexZJfwXI1CuzMeta?.path ?? "/",
    meta: indexZJfwXI1CuzMeta || {},
    alias: indexZJfwXI1CuzMeta?.alias || [],
    redirect: indexZJfwXI1CuzMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexZJfwXI1CuzMeta?.name ?? "index___zh-cn",
    path: indexZJfwXI1CuzMeta?.path ?? "/zh-cn",
    meta: indexZJfwXI1CuzMeta || {},
    alias: indexZJfwXI1CuzMeta?.alias || [],
    redirect: indexZJfwXI1CuzMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexZJfwXI1CuzMeta?.name ?? "index___zh-tw",
    path: indexZJfwXI1CuzMeta?.path ?? "/zh-tw",
    meta: indexZJfwXI1CuzMeta || {},
    alias: indexZJfwXI1CuzMeta?.alias || [],
    redirect: indexZJfwXI1CuzMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexZJfwXI1CuzMeta?.name ?? "index___jp",
    path: indexZJfwXI1CuzMeta?.path ?? "/jp",
    meta: indexZJfwXI1CuzMeta || {},
    alias: indexZJfwXI1CuzMeta?.alias || [],
    redirect: indexZJfwXI1CuzMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexZJfwXI1CuzMeta?.name ?? "index___es",
    path: indexZJfwXI1CuzMeta?.path ?? "/es",
    meta: indexZJfwXI1CuzMeta || {},
    alias: indexZJfwXI1CuzMeta?.alias || [],
    redirect: indexZJfwXI1CuzMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexZJfwXI1CuzMeta?.name ?? "index___fr",
    path: indexZJfwXI1CuzMeta?.path ?? "/fr",
    meta: indexZJfwXI1CuzMeta || {},
    alias: indexZJfwXI1CuzMeta?.alias || [],
    redirect: indexZJfwXI1CuzMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexZJfwXI1CuzMeta?.name ?? "index___de",
    path: indexZJfwXI1CuzMeta?.path ?? "/de",
    meta: indexZJfwXI1CuzMeta || {},
    alias: indexZJfwXI1CuzMeta?.alias || [],
    redirect: indexZJfwXI1CuzMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexZJfwXI1CuzMeta?.name ?? "index___kr",
    path: indexZJfwXI1CuzMeta?.path ?? "/kr",
    meta: indexZJfwXI1CuzMeta || {},
    alias: indexZJfwXI1CuzMeta?.alias || [],
    redirect: indexZJfwXI1CuzMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexZJfwXI1CuzMeta?.name ?? "index___vn",
    path: indexZJfwXI1CuzMeta?.path ?? "/vn",
    meta: indexZJfwXI1CuzMeta || {},
    alias: indexZJfwXI1CuzMeta?.alias || [],
    redirect: indexZJfwXI1CuzMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexZJfwXI1CuzMeta?.name ?? "index___th",
    path: indexZJfwXI1CuzMeta?.path ?? "/th",
    meta: indexZJfwXI1CuzMeta || {},
    alias: indexZJfwXI1CuzMeta?.alias || [],
    redirect: indexZJfwXI1CuzMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexZJfwXI1CuzMeta?.name ?? "index___ru",
    path: indexZJfwXI1CuzMeta?.path ?? "/ru",
    meta: indexZJfwXI1CuzMeta || {},
    alias: indexZJfwXI1CuzMeta?.alias || [],
    redirect: indexZJfwXI1CuzMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexZJfwXI1CuzMeta?.name ?? "index___tr",
    path: indexZJfwXI1CuzMeta?.path ?? "/tr",
    meta: indexZJfwXI1CuzMeta || {},
    alias: indexZJfwXI1CuzMeta?.alias || [],
    redirect: indexZJfwXI1CuzMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/index.vue").then(m => m.default || m)
  },
  {
    name: ispmanagerp3OKnXNQzfMeta?.name ?? "ispmanager___en",
    path: ispmanagerp3OKnXNQzfMeta?.path ?? "/ispmanager",
    meta: ispmanagerp3OKnXNQzfMeta || {},
    alias: ispmanagerp3OKnXNQzfMeta?.alias || [],
    redirect: ispmanagerp3OKnXNQzfMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ispmanager.vue").then(m => m.default || m)
  },
  {
    name: ispmanagerp3OKnXNQzfMeta?.name ?? "ispmanager___zh-cn",
    path: ispmanagerp3OKnXNQzfMeta?.path ?? "/zh-cn/ispmanager",
    meta: ispmanagerp3OKnXNQzfMeta || {},
    alias: ispmanagerp3OKnXNQzfMeta?.alias || [],
    redirect: ispmanagerp3OKnXNQzfMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ispmanager.vue").then(m => m.default || m)
  },
  {
    name: ispmanagerp3OKnXNQzfMeta?.name ?? "ispmanager___zh-tw",
    path: ispmanagerp3OKnXNQzfMeta?.path ?? "/zh-tw/ispmanager",
    meta: ispmanagerp3OKnXNQzfMeta || {},
    alias: ispmanagerp3OKnXNQzfMeta?.alias || [],
    redirect: ispmanagerp3OKnXNQzfMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ispmanager.vue").then(m => m.default || m)
  },
  {
    name: ispmanagerp3OKnXNQzfMeta?.name ?? "ispmanager___jp",
    path: ispmanagerp3OKnXNQzfMeta?.path ?? "/jp/ispmanager",
    meta: ispmanagerp3OKnXNQzfMeta || {},
    alias: ispmanagerp3OKnXNQzfMeta?.alias || [],
    redirect: ispmanagerp3OKnXNQzfMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ispmanager.vue").then(m => m.default || m)
  },
  {
    name: ispmanagerp3OKnXNQzfMeta?.name ?? "ispmanager___es",
    path: ispmanagerp3OKnXNQzfMeta?.path ?? "/es/ispmanager",
    meta: ispmanagerp3OKnXNQzfMeta || {},
    alias: ispmanagerp3OKnXNQzfMeta?.alias || [],
    redirect: ispmanagerp3OKnXNQzfMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ispmanager.vue").then(m => m.default || m)
  },
  {
    name: ispmanagerp3OKnXNQzfMeta?.name ?? "ispmanager___fr",
    path: ispmanagerp3OKnXNQzfMeta?.path ?? "/fr/ispmanager",
    meta: ispmanagerp3OKnXNQzfMeta || {},
    alias: ispmanagerp3OKnXNQzfMeta?.alias || [],
    redirect: ispmanagerp3OKnXNQzfMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ispmanager.vue").then(m => m.default || m)
  },
  {
    name: ispmanagerp3OKnXNQzfMeta?.name ?? "ispmanager___de",
    path: ispmanagerp3OKnXNQzfMeta?.path ?? "/de/ispmanager",
    meta: ispmanagerp3OKnXNQzfMeta || {},
    alias: ispmanagerp3OKnXNQzfMeta?.alias || [],
    redirect: ispmanagerp3OKnXNQzfMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ispmanager.vue").then(m => m.default || m)
  },
  {
    name: ispmanagerp3OKnXNQzfMeta?.name ?? "ispmanager___kr",
    path: ispmanagerp3OKnXNQzfMeta?.path ?? "/kr/ispmanager",
    meta: ispmanagerp3OKnXNQzfMeta || {},
    alias: ispmanagerp3OKnXNQzfMeta?.alias || [],
    redirect: ispmanagerp3OKnXNQzfMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ispmanager.vue").then(m => m.default || m)
  },
  {
    name: ispmanagerp3OKnXNQzfMeta?.name ?? "ispmanager___vn",
    path: ispmanagerp3OKnXNQzfMeta?.path ?? "/vn/ispmanager",
    meta: ispmanagerp3OKnXNQzfMeta || {},
    alias: ispmanagerp3OKnXNQzfMeta?.alias || [],
    redirect: ispmanagerp3OKnXNQzfMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ispmanager.vue").then(m => m.default || m)
  },
  {
    name: ispmanagerp3OKnXNQzfMeta?.name ?? "ispmanager___th",
    path: ispmanagerp3OKnXNQzfMeta?.path ?? "/th/ispmanager",
    meta: ispmanagerp3OKnXNQzfMeta || {},
    alias: ispmanagerp3OKnXNQzfMeta?.alias || [],
    redirect: ispmanagerp3OKnXNQzfMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ispmanager.vue").then(m => m.default || m)
  },
  {
    name: ispmanagerp3OKnXNQzfMeta?.name ?? "ispmanager___ru",
    path: ispmanagerp3OKnXNQzfMeta?.path ?? "/ru/ispmanager",
    meta: ispmanagerp3OKnXNQzfMeta || {},
    alias: ispmanagerp3OKnXNQzfMeta?.alias || [],
    redirect: ispmanagerp3OKnXNQzfMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ispmanager.vue").then(m => m.default || m)
  },
  {
    name: ispmanagerp3OKnXNQzfMeta?.name ?? "ispmanager___tr",
    path: ispmanagerp3OKnXNQzfMeta?.path ?? "/tr/ispmanager",
    meta: ispmanagerp3OKnXNQzfMeta || {},
    alias: ispmanagerp3OKnXNQzfMeta?.alias || [],
    redirect: ispmanagerp3OKnXNQzfMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ispmanager.vue").then(m => m.default || m)
  },
  {
    name: log_45detailsY6qzWGxIv5Meta?.name ?? "log-details___en",
    path: log_45detailsY6qzWGxIv5Meta?.path ?? "/log-details",
    meta: log_45detailsY6qzWGxIv5Meta || {},
    alias: log_45detailsY6qzWGxIv5Meta?.alias || [],
    redirect: log_45detailsY6qzWGxIv5Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/log-details.vue").then(m => m.default || m)
  },
  {
    name: log_45detailsY6qzWGxIv5Meta?.name ?? "log-details___zh-cn",
    path: log_45detailsY6qzWGxIv5Meta?.path ?? "/zh-cn/log-details",
    meta: log_45detailsY6qzWGxIv5Meta || {},
    alias: log_45detailsY6qzWGxIv5Meta?.alias || [],
    redirect: log_45detailsY6qzWGxIv5Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/log-details.vue").then(m => m.default || m)
  },
  {
    name: log_45detailsY6qzWGxIv5Meta?.name ?? "log-details___zh-tw",
    path: log_45detailsY6qzWGxIv5Meta?.path ?? "/zh-tw/log-details",
    meta: log_45detailsY6qzWGxIv5Meta || {},
    alias: log_45detailsY6qzWGxIv5Meta?.alias || [],
    redirect: log_45detailsY6qzWGxIv5Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/log-details.vue").then(m => m.default || m)
  },
  {
    name: log_45detailsY6qzWGxIv5Meta?.name ?? "log-details___jp",
    path: log_45detailsY6qzWGxIv5Meta?.path ?? "/jp/log-details",
    meta: log_45detailsY6qzWGxIv5Meta || {},
    alias: log_45detailsY6qzWGxIv5Meta?.alias || [],
    redirect: log_45detailsY6qzWGxIv5Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/log-details.vue").then(m => m.default || m)
  },
  {
    name: log_45detailsY6qzWGxIv5Meta?.name ?? "log-details___es",
    path: log_45detailsY6qzWGxIv5Meta?.path ?? "/es/log-details",
    meta: log_45detailsY6qzWGxIv5Meta || {},
    alias: log_45detailsY6qzWGxIv5Meta?.alias || [],
    redirect: log_45detailsY6qzWGxIv5Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/log-details.vue").then(m => m.default || m)
  },
  {
    name: log_45detailsY6qzWGxIv5Meta?.name ?? "log-details___fr",
    path: log_45detailsY6qzWGxIv5Meta?.path ?? "/fr/log-details",
    meta: log_45detailsY6qzWGxIv5Meta || {},
    alias: log_45detailsY6qzWGxIv5Meta?.alias || [],
    redirect: log_45detailsY6qzWGxIv5Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/log-details.vue").then(m => m.default || m)
  },
  {
    name: log_45detailsY6qzWGxIv5Meta?.name ?? "log-details___de",
    path: log_45detailsY6qzWGxIv5Meta?.path ?? "/de/log-details",
    meta: log_45detailsY6qzWGxIv5Meta || {},
    alias: log_45detailsY6qzWGxIv5Meta?.alias || [],
    redirect: log_45detailsY6qzWGxIv5Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/log-details.vue").then(m => m.default || m)
  },
  {
    name: log_45detailsY6qzWGxIv5Meta?.name ?? "log-details___kr",
    path: log_45detailsY6qzWGxIv5Meta?.path ?? "/kr/log-details",
    meta: log_45detailsY6qzWGxIv5Meta || {},
    alias: log_45detailsY6qzWGxIv5Meta?.alias || [],
    redirect: log_45detailsY6qzWGxIv5Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/log-details.vue").then(m => m.default || m)
  },
  {
    name: log_45detailsY6qzWGxIv5Meta?.name ?? "log-details___vn",
    path: log_45detailsY6qzWGxIv5Meta?.path ?? "/vn/log-details",
    meta: log_45detailsY6qzWGxIv5Meta || {},
    alias: log_45detailsY6qzWGxIv5Meta?.alias || [],
    redirect: log_45detailsY6qzWGxIv5Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/log-details.vue").then(m => m.default || m)
  },
  {
    name: log_45detailsY6qzWGxIv5Meta?.name ?? "log-details___th",
    path: log_45detailsY6qzWGxIv5Meta?.path ?? "/th/log-details",
    meta: log_45detailsY6qzWGxIv5Meta || {},
    alias: log_45detailsY6qzWGxIv5Meta?.alias || [],
    redirect: log_45detailsY6qzWGxIv5Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/log-details.vue").then(m => m.default || m)
  },
  {
    name: log_45detailsY6qzWGxIv5Meta?.name ?? "log-details___ru",
    path: log_45detailsY6qzWGxIv5Meta?.path ?? "/ru/log-details",
    meta: log_45detailsY6qzWGxIv5Meta || {},
    alias: log_45detailsY6qzWGxIv5Meta?.alias || [],
    redirect: log_45detailsY6qzWGxIv5Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/log-details.vue").then(m => m.default || m)
  },
  {
    name: log_45detailsY6qzWGxIv5Meta?.name ?? "log-details___tr",
    path: log_45detailsY6qzWGxIv5Meta?.path ?? "/tr/log-details",
    meta: log_45detailsY6qzWGxIv5Meta || {},
    alias: log_45detailsY6qzWGxIv5Meta?.alias || [],
    redirect: log_45detailsY6qzWGxIv5Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/log-details.vue").then(m => m.default || m)
  },
  {
    name: pleskfQTWJseJlVMeta?.name ?? "plesk___en",
    path: pleskfQTWJseJlVMeta?.path ?? "/plesk",
    meta: pleskfQTWJseJlVMeta || {},
    alias: pleskfQTWJseJlVMeta?.alias || [],
    redirect: pleskfQTWJseJlVMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/plesk.vue").then(m => m.default || m)
  },
  {
    name: pleskfQTWJseJlVMeta?.name ?? "plesk___zh-cn",
    path: pleskfQTWJseJlVMeta?.path ?? "/zh-cn/plesk",
    meta: pleskfQTWJseJlVMeta || {},
    alias: pleskfQTWJseJlVMeta?.alias || [],
    redirect: pleskfQTWJseJlVMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/plesk.vue").then(m => m.default || m)
  },
  {
    name: pleskfQTWJseJlVMeta?.name ?? "plesk___zh-tw",
    path: pleskfQTWJseJlVMeta?.path ?? "/zh-tw/plesk",
    meta: pleskfQTWJseJlVMeta || {},
    alias: pleskfQTWJseJlVMeta?.alias || [],
    redirect: pleskfQTWJseJlVMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/plesk.vue").then(m => m.default || m)
  },
  {
    name: pleskfQTWJseJlVMeta?.name ?? "plesk___jp",
    path: pleskfQTWJseJlVMeta?.path ?? "/jp/plesk",
    meta: pleskfQTWJseJlVMeta || {},
    alias: pleskfQTWJseJlVMeta?.alias || [],
    redirect: pleskfQTWJseJlVMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/plesk.vue").then(m => m.default || m)
  },
  {
    name: pleskfQTWJseJlVMeta?.name ?? "plesk___es",
    path: pleskfQTWJseJlVMeta?.path ?? "/es/plesk",
    meta: pleskfQTWJseJlVMeta || {},
    alias: pleskfQTWJseJlVMeta?.alias || [],
    redirect: pleskfQTWJseJlVMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/plesk.vue").then(m => m.default || m)
  },
  {
    name: pleskfQTWJseJlVMeta?.name ?? "plesk___fr",
    path: pleskfQTWJseJlVMeta?.path ?? "/fr/plesk",
    meta: pleskfQTWJseJlVMeta || {},
    alias: pleskfQTWJseJlVMeta?.alias || [],
    redirect: pleskfQTWJseJlVMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/plesk.vue").then(m => m.default || m)
  },
  {
    name: pleskfQTWJseJlVMeta?.name ?? "plesk___de",
    path: pleskfQTWJseJlVMeta?.path ?? "/de/plesk",
    meta: pleskfQTWJseJlVMeta || {},
    alias: pleskfQTWJseJlVMeta?.alias || [],
    redirect: pleskfQTWJseJlVMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/plesk.vue").then(m => m.default || m)
  },
  {
    name: pleskfQTWJseJlVMeta?.name ?? "plesk___kr",
    path: pleskfQTWJseJlVMeta?.path ?? "/kr/plesk",
    meta: pleskfQTWJseJlVMeta || {},
    alias: pleskfQTWJseJlVMeta?.alias || [],
    redirect: pleskfQTWJseJlVMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/plesk.vue").then(m => m.default || m)
  },
  {
    name: pleskfQTWJseJlVMeta?.name ?? "plesk___vn",
    path: pleskfQTWJseJlVMeta?.path ?? "/vn/plesk",
    meta: pleskfQTWJseJlVMeta || {},
    alias: pleskfQTWJseJlVMeta?.alias || [],
    redirect: pleskfQTWJseJlVMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/plesk.vue").then(m => m.default || m)
  },
  {
    name: pleskfQTWJseJlVMeta?.name ?? "plesk___th",
    path: pleskfQTWJseJlVMeta?.path ?? "/th/plesk",
    meta: pleskfQTWJseJlVMeta || {},
    alias: pleskfQTWJseJlVMeta?.alias || [],
    redirect: pleskfQTWJseJlVMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/plesk.vue").then(m => m.default || m)
  },
  {
    name: pleskfQTWJseJlVMeta?.name ?? "plesk___ru",
    path: pleskfQTWJseJlVMeta?.path ?? "/ru/plesk",
    meta: pleskfQTWJseJlVMeta || {},
    alias: pleskfQTWJseJlVMeta?.alias || [],
    redirect: pleskfQTWJseJlVMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/plesk.vue").then(m => m.default || m)
  },
  {
    name: pleskfQTWJseJlVMeta?.name ?? "plesk___tr",
    path: pleskfQTWJseJlVMeta?.path ?? "/tr/plesk",
    meta: pleskfQTWJseJlVMeta || {},
    alias: pleskfQTWJseJlVMeta?.alias || [],
    redirect: pleskfQTWJseJlVMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/plesk.vue").then(m => m.default || m)
  },
  {
    name: policy_45agreement8p79u5bhNnMeta?.name ?? "policy-agreement___en",
    path: policy_45agreement8p79u5bhNnMeta?.path ?? "/policy-agreement",
    meta: policy_45agreement8p79u5bhNnMeta || {},
    alias: policy_45agreement8p79u5bhNnMeta?.alias || [],
    redirect: policy_45agreement8p79u5bhNnMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/policy-agreement.vue").then(m => m.default || m)
  },
  {
    name: policy_45agreement8p79u5bhNnMeta?.name ?? "policy-agreement___zh-cn",
    path: policy_45agreement8p79u5bhNnMeta?.path ?? "/zh-cn/policy-agreement",
    meta: policy_45agreement8p79u5bhNnMeta || {},
    alias: policy_45agreement8p79u5bhNnMeta?.alias || [],
    redirect: policy_45agreement8p79u5bhNnMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/policy-agreement.vue").then(m => m.default || m)
  },
  {
    name: policy_45agreement8p79u5bhNnMeta?.name ?? "policy-agreement___zh-tw",
    path: policy_45agreement8p79u5bhNnMeta?.path ?? "/zh-tw/policy-agreement",
    meta: policy_45agreement8p79u5bhNnMeta || {},
    alias: policy_45agreement8p79u5bhNnMeta?.alias || [],
    redirect: policy_45agreement8p79u5bhNnMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/policy-agreement.vue").then(m => m.default || m)
  },
  {
    name: policy_45agreement8p79u5bhNnMeta?.name ?? "policy-agreement___jp",
    path: policy_45agreement8p79u5bhNnMeta?.path ?? "/jp/policy-agreement",
    meta: policy_45agreement8p79u5bhNnMeta || {},
    alias: policy_45agreement8p79u5bhNnMeta?.alias || [],
    redirect: policy_45agreement8p79u5bhNnMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/policy-agreement.vue").then(m => m.default || m)
  },
  {
    name: policy_45agreement8p79u5bhNnMeta?.name ?? "policy-agreement___es",
    path: policy_45agreement8p79u5bhNnMeta?.path ?? "/es/policy-agreement",
    meta: policy_45agreement8p79u5bhNnMeta || {},
    alias: policy_45agreement8p79u5bhNnMeta?.alias || [],
    redirect: policy_45agreement8p79u5bhNnMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/policy-agreement.vue").then(m => m.default || m)
  },
  {
    name: policy_45agreement8p79u5bhNnMeta?.name ?? "policy-agreement___fr",
    path: policy_45agreement8p79u5bhNnMeta?.path ?? "/fr/policy-agreement",
    meta: policy_45agreement8p79u5bhNnMeta || {},
    alias: policy_45agreement8p79u5bhNnMeta?.alias || [],
    redirect: policy_45agreement8p79u5bhNnMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/policy-agreement.vue").then(m => m.default || m)
  },
  {
    name: policy_45agreement8p79u5bhNnMeta?.name ?? "policy-agreement___de",
    path: policy_45agreement8p79u5bhNnMeta?.path ?? "/de/policy-agreement",
    meta: policy_45agreement8p79u5bhNnMeta || {},
    alias: policy_45agreement8p79u5bhNnMeta?.alias || [],
    redirect: policy_45agreement8p79u5bhNnMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/policy-agreement.vue").then(m => m.default || m)
  },
  {
    name: policy_45agreement8p79u5bhNnMeta?.name ?? "policy-agreement___kr",
    path: policy_45agreement8p79u5bhNnMeta?.path ?? "/kr/policy-agreement",
    meta: policy_45agreement8p79u5bhNnMeta || {},
    alias: policy_45agreement8p79u5bhNnMeta?.alias || [],
    redirect: policy_45agreement8p79u5bhNnMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/policy-agreement.vue").then(m => m.default || m)
  },
  {
    name: policy_45agreement8p79u5bhNnMeta?.name ?? "policy-agreement___vn",
    path: policy_45agreement8p79u5bhNnMeta?.path ?? "/vn/policy-agreement",
    meta: policy_45agreement8p79u5bhNnMeta || {},
    alias: policy_45agreement8p79u5bhNnMeta?.alias || [],
    redirect: policy_45agreement8p79u5bhNnMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/policy-agreement.vue").then(m => m.default || m)
  },
  {
    name: policy_45agreement8p79u5bhNnMeta?.name ?? "policy-agreement___th",
    path: policy_45agreement8p79u5bhNnMeta?.path ?? "/th/policy-agreement",
    meta: policy_45agreement8p79u5bhNnMeta || {},
    alias: policy_45agreement8p79u5bhNnMeta?.alias || [],
    redirect: policy_45agreement8p79u5bhNnMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/policy-agreement.vue").then(m => m.default || m)
  },
  {
    name: policy_45agreement8p79u5bhNnMeta?.name ?? "policy-agreement___ru",
    path: policy_45agreement8p79u5bhNnMeta?.path ?? "/ru/policy-agreement",
    meta: policy_45agreement8p79u5bhNnMeta || {},
    alias: policy_45agreement8p79u5bhNnMeta?.alias || [],
    redirect: policy_45agreement8p79u5bhNnMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/policy-agreement.vue").then(m => m.default || m)
  },
  {
    name: policy_45agreement8p79u5bhNnMeta?.name ?? "policy-agreement___tr",
    path: policy_45agreement8p79u5bhNnMeta?.path ?? "/tr/policy-agreement",
    meta: policy_45agreement8p79u5bhNnMeta || {},
    alias: policy_45agreement8p79u5bhNnMeta?.alias || [],
    redirect: policy_45agreement8p79u5bhNnMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/policy-agreement.vue").then(m => m.default || m)
  },
  {
    name: privacyj8BSIcQ3aBMeta?.name ?? "privacy___en",
    path: privacyj8BSIcQ3aBMeta?.path ?? "/privacy",
    meta: privacyj8BSIcQ3aBMeta || {},
    alias: privacyj8BSIcQ3aBMeta?.alias || [],
    redirect: privacyj8BSIcQ3aBMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/privacy.vue").then(m => m.default || m)
  },
  {
    name: privacyj8BSIcQ3aBMeta?.name ?? "privacy___zh-cn",
    path: privacyj8BSIcQ3aBMeta?.path ?? "/zh-cn/privacy",
    meta: privacyj8BSIcQ3aBMeta || {},
    alias: privacyj8BSIcQ3aBMeta?.alias || [],
    redirect: privacyj8BSIcQ3aBMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/privacy.vue").then(m => m.default || m)
  },
  {
    name: privacyj8BSIcQ3aBMeta?.name ?? "privacy___zh-tw",
    path: privacyj8BSIcQ3aBMeta?.path ?? "/zh-tw/privacy",
    meta: privacyj8BSIcQ3aBMeta || {},
    alias: privacyj8BSIcQ3aBMeta?.alias || [],
    redirect: privacyj8BSIcQ3aBMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/privacy.vue").then(m => m.default || m)
  },
  {
    name: privacyj8BSIcQ3aBMeta?.name ?? "privacy___jp",
    path: privacyj8BSIcQ3aBMeta?.path ?? "/jp/privacy",
    meta: privacyj8BSIcQ3aBMeta || {},
    alias: privacyj8BSIcQ3aBMeta?.alias || [],
    redirect: privacyj8BSIcQ3aBMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/privacy.vue").then(m => m.default || m)
  },
  {
    name: privacyj8BSIcQ3aBMeta?.name ?? "privacy___es",
    path: privacyj8BSIcQ3aBMeta?.path ?? "/es/privacy",
    meta: privacyj8BSIcQ3aBMeta || {},
    alias: privacyj8BSIcQ3aBMeta?.alias || [],
    redirect: privacyj8BSIcQ3aBMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/privacy.vue").then(m => m.default || m)
  },
  {
    name: privacyj8BSIcQ3aBMeta?.name ?? "privacy___fr",
    path: privacyj8BSIcQ3aBMeta?.path ?? "/fr/privacy",
    meta: privacyj8BSIcQ3aBMeta || {},
    alias: privacyj8BSIcQ3aBMeta?.alias || [],
    redirect: privacyj8BSIcQ3aBMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/privacy.vue").then(m => m.default || m)
  },
  {
    name: privacyj8BSIcQ3aBMeta?.name ?? "privacy___de",
    path: privacyj8BSIcQ3aBMeta?.path ?? "/de/privacy",
    meta: privacyj8BSIcQ3aBMeta || {},
    alias: privacyj8BSIcQ3aBMeta?.alias || [],
    redirect: privacyj8BSIcQ3aBMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/privacy.vue").then(m => m.default || m)
  },
  {
    name: privacyj8BSIcQ3aBMeta?.name ?? "privacy___kr",
    path: privacyj8BSIcQ3aBMeta?.path ?? "/kr/privacy",
    meta: privacyj8BSIcQ3aBMeta || {},
    alias: privacyj8BSIcQ3aBMeta?.alias || [],
    redirect: privacyj8BSIcQ3aBMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/privacy.vue").then(m => m.default || m)
  },
  {
    name: privacyj8BSIcQ3aBMeta?.name ?? "privacy___vn",
    path: privacyj8BSIcQ3aBMeta?.path ?? "/vn/privacy",
    meta: privacyj8BSIcQ3aBMeta || {},
    alias: privacyj8BSIcQ3aBMeta?.alias || [],
    redirect: privacyj8BSIcQ3aBMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/privacy.vue").then(m => m.default || m)
  },
  {
    name: privacyj8BSIcQ3aBMeta?.name ?? "privacy___th",
    path: privacyj8BSIcQ3aBMeta?.path ?? "/th/privacy",
    meta: privacyj8BSIcQ3aBMeta || {},
    alias: privacyj8BSIcQ3aBMeta?.alias || [],
    redirect: privacyj8BSIcQ3aBMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/privacy.vue").then(m => m.default || m)
  },
  {
    name: privacyj8BSIcQ3aBMeta?.name ?? "privacy___ru",
    path: privacyj8BSIcQ3aBMeta?.path ?? "/ru/privacy",
    meta: privacyj8BSIcQ3aBMeta || {},
    alias: privacyj8BSIcQ3aBMeta?.alias || [],
    redirect: privacyj8BSIcQ3aBMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/privacy.vue").then(m => m.default || m)
  },
  {
    name: privacyj8BSIcQ3aBMeta?.name ?? "privacy___tr",
    path: privacyj8BSIcQ3aBMeta?.path ?? "/tr/privacy",
    meta: privacyj8BSIcQ3aBMeta || {},
    alias: privacyj8BSIcQ3aBMeta?.alias || [],
    redirect: privacyj8BSIcQ3aBMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/privacy.vue").then(m => m.default || m)
  },
  {
    name: _91code_93POYWEFxG8rMeta?.name ?? "product-code___en",
    path: _91code_93POYWEFxG8rMeta?.path ?? "/product/:code()",
    meta: _91code_93POYWEFxG8rMeta || {},
    alias: _91code_93POYWEFxG8rMeta?.alias || [],
    redirect: _91code_93POYWEFxG8rMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/product/[code].vue").then(m => m.default || m)
  },
  {
    name: _91code_93POYWEFxG8rMeta?.name ?? "product-code___zh-cn",
    path: _91code_93POYWEFxG8rMeta?.path ?? "/zh-cn/product/:code()",
    meta: _91code_93POYWEFxG8rMeta || {},
    alias: _91code_93POYWEFxG8rMeta?.alias || [],
    redirect: _91code_93POYWEFxG8rMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/product/[code].vue").then(m => m.default || m)
  },
  {
    name: _91code_93POYWEFxG8rMeta?.name ?? "product-code___zh-tw",
    path: _91code_93POYWEFxG8rMeta?.path ?? "/zh-tw/product/:code()",
    meta: _91code_93POYWEFxG8rMeta || {},
    alias: _91code_93POYWEFxG8rMeta?.alias || [],
    redirect: _91code_93POYWEFxG8rMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/product/[code].vue").then(m => m.default || m)
  },
  {
    name: _91code_93POYWEFxG8rMeta?.name ?? "product-code___jp",
    path: _91code_93POYWEFxG8rMeta?.path ?? "/jp/product/:code()",
    meta: _91code_93POYWEFxG8rMeta || {},
    alias: _91code_93POYWEFxG8rMeta?.alias || [],
    redirect: _91code_93POYWEFxG8rMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/product/[code].vue").then(m => m.default || m)
  },
  {
    name: _91code_93POYWEFxG8rMeta?.name ?? "product-code___es",
    path: _91code_93POYWEFxG8rMeta?.path ?? "/es/product/:code()",
    meta: _91code_93POYWEFxG8rMeta || {},
    alias: _91code_93POYWEFxG8rMeta?.alias || [],
    redirect: _91code_93POYWEFxG8rMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/product/[code].vue").then(m => m.default || m)
  },
  {
    name: _91code_93POYWEFxG8rMeta?.name ?? "product-code___fr",
    path: _91code_93POYWEFxG8rMeta?.path ?? "/fr/product/:code()",
    meta: _91code_93POYWEFxG8rMeta || {},
    alias: _91code_93POYWEFxG8rMeta?.alias || [],
    redirect: _91code_93POYWEFxG8rMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/product/[code].vue").then(m => m.default || m)
  },
  {
    name: _91code_93POYWEFxG8rMeta?.name ?? "product-code___de",
    path: _91code_93POYWEFxG8rMeta?.path ?? "/de/product/:code()",
    meta: _91code_93POYWEFxG8rMeta || {},
    alias: _91code_93POYWEFxG8rMeta?.alias || [],
    redirect: _91code_93POYWEFxG8rMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/product/[code].vue").then(m => m.default || m)
  },
  {
    name: _91code_93POYWEFxG8rMeta?.name ?? "product-code___kr",
    path: _91code_93POYWEFxG8rMeta?.path ?? "/kr/product/:code()",
    meta: _91code_93POYWEFxG8rMeta || {},
    alias: _91code_93POYWEFxG8rMeta?.alias || [],
    redirect: _91code_93POYWEFxG8rMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/product/[code].vue").then(m => m.default || m)
  },
  {
    name: _91code_93POYWEFxG8rMeta?.name ?? "product-code___vn",
    path: _91code_93POYWEFxG8rMeta?.path ?? "/vn/product/:code()",
    meta: _91code_93POYWEFxG8rMeta || {},
    alias: _91code_93POYWEFxG8rMeta?.alias || [],
    redirect: _91code_93POYWEFxG8rMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/product/[code].vue").then(m => m.default || m)
  },
  {
    name: _91code_93POYWEFxG8rMeta?.name ?? "product-code___th",
    path: _91code_93POYWEFxG8rMeta?.path ?? "/th/product/:code()",
    meta: _91code_93POYWEFxG8rMeta || {},
    alias: _91code_93POYWEFxG8rMeta?.alias || [],
    redirect: _91code_93POYWEFxG8rMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/product/[code].vue").then(m => m.default || m)
  },
  {
    name: _91code_93POYWEFxG8rMeta?.name ?? "product-code___ru",
    path: _91code_93POYWEFxG8rMeta?.path ?? "/ru/product/:code()",
    meta: _91code_93POYWEFxG8rMeta || {},
    alias: _91code_93POYWEFxG8rMeta?.alias || [],
    redirect: _91code_93POYWEFxG8rMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/product/[code].vue").then(m => m.default || m)
  },
  {
    name: _91code_93POYWEFxG8rMeta?.name ?? "product-code___tr",
    path: _91code_93POYWEFxG8rMeta?.path ?? "/tr/product/:code()",
    meta: _91code_93POYWEFxG8rMeta || {},
    alias: _91code_93POYWEFxG8rMeta?.alias || [],
    redirect: _91code_93POYWEFxG8rMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/product/[code].vue").then(m => m.default || m)
  },
  {
    name: resellersRIYZhtSRqMeta?.name ?? "reseller___en",
    path: resellersRIYZhtSRqMeta?.path ?? "/reseller",
    meta: resellersRIYZhtSRqMeta || {},
    alias: resellersRIYZhtSRqMeta?.alias || [],
    redirect: resellersRIYZhtSRqMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/reseller.vue").then(m => m.default || m)
  },
  {
    name: resellersRIYZhtSRqMeta?.name ?? "reseller___zh-cn",
    path: resellersRIYZhtSRqMeta?.path ?? "/zh-cn/reseller",
    meta: resellersRIYZhtSRqMeta || {},
    alias: resellersRIYZhtSRqMeta?.alias || [],
    redirect: resellersRIYZhtSRqMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/reseller.vue").then(m => m.default || m)
  },
  {
    name: resellersRIYZhtSRqMeta?.name ?? "reseller___zh-tw",
    path: resellersRIYZhtSRqMeta?.path ?? "/zh-tw/reseller",
    meta: resellersRIYZhtSRqMeta || {},
    alias: resellersRIYZhtSRqMeta?.alias || [],
    redirect: resellersRIYZhtSRqMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/reseller.vue").then(m => m.default || m)
  },
  {
    name: resellersRIYZhtSRqMeta?.name ?? "reseller___jp",
    path: resellersRIYZhtSRqMeta?.path ?? "/jp/reseller",
    meta: resellersRIYZhtSRqMeta || {},
    alias: resellersRIYZhtSRqMeta?.alias || [],
    redirect: resellersRIYZhtSRqMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/reseller.vue").then(m => m.default || m)
  },
  {
    name: resellersRIYZhtSRqMeta?.name ?? "reseller___es",
    path: resellersRIYZhtSRqMeta?.path ?? "/es/reseller",
    meta: resellersRIYZhtSRqMeta || {},
    alias: resellersRIYZhtSRqMeta?.alias || [],
    redirect: resellersRIYZhtSRqMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/reseller.vue").then(m => m.default || m)
  },
  {
    name: resellersRIYZhtSRqMeta?.name ?? "reseller___fr",
    path: resellersRIYZhtSRqMeta?.path ?? "/fr/reseller",
    meta: resellersRIYZhtSRqMeta || {},
    alias: resellersRIYZhtSRqMeta?.alias || [],
    redirect: resellersRIYZhtSRqMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/reseller.vue").then(m => m.default || m)
  },
  {
    name: resellersRIYZhtSRqMeta?.name ?? "reseller___de",
    path: resellersRIYZhtSRqMeta?.path ?? "/de/reseller",
    meta: resellersRIYZhtSRqMeta || {},
    alias: resellersRIYZhtSRqMeta?.alias || [],
    redirect: resellersRIYZhtSRqMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/reseller.vue").then(m => m.default || m)
  },
  {
    name: resellersRIYZhtSRqMeta?.name ?? "reseller___kr",
    path: resellersRIYZhtSRqMeta?.path ?? "/kr/reseller",
    meta: resellersRIYZhtSRqMeta || {},
    alias: resellersRIYZhtSRqMeta?.alias || [],
    redirect: resellersRIYZhtSRqMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/reseller.vue").then(m => m.default || m)
  },
  {
    name: resellersRIYZhtSRqMeta?.name ?? "reseller___vn",
    path: resellersRIYZhtSRqMeta?.path ?? "/vn/reseller",
    meta: resellersRIYZhtSRqMeta || {},
    alias: resellersRIYZhtSRqMeta?.alias || [],
    redirect: resellersRIYZhtSRqMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/reseller.vue").then(m => m.default || m)
  },
  {
    name: resellersRIYZhtSRqMeta?.name ?? "reseller___th",
    path: resellersRIYZhtSRqMeta?.path ?? "/th/reseller",
    meta: resellersRIYZhtSRqMeta || {},
    alias: resellersRIYZhtSRqMeta?.alias || [],
    redirect: resellersRIYZhtSRqMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/reseller.vue").then(m => m.default || m)
  },
  {
    name: resellersRIYZhtSRqMeta?.name ?? "reseller___ru",
    path: resellersRIYZhtSRqMeta?.path ?? "/ru/reseller",
    meta: resellersRIYZhtSRqMeta || {},
    alias: resellersRIYZhtSRqMeta?.alias || [],
    redirect: resellersRIYZhtSRqMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/reseller.vue").then(m => m.default || m)
  },
  {
    name: resellersRIYZhtSRqMeta?.name ?? "reseller___tr",
    path: resellersRIYZhtSRqMeta?.path ?? "/tr/reseller",
    meta: resellersRIYZhtSRqMeta || {},
    alias: resellersRIYZhtSRqMeta?.alias || [],
    redirect: resellersRIYZhtSRqMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/reseller.vue").then(m => m.default || m)
  },
  {
    name: sitelockUseNRdjOj7Meta?.name ?? "sitelock___en",
    path: sitelockUseNRdjOj7Meta?.path ?? "/sitelock",
    meta: sitelockUseNRdjOj7Meta || {},
    alias: sitelockUseNRdjOj7Meta?.alias || [],
    redirect: sitelockUseNRdjOj7Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/sitelock.vue").then(m => m.default || m)
  },
  {
    name: sitelockUseNRdjOj7Meta?.name ?? "sitelock___zh-cn",
    path: sitelockUseNRdjOj7Meta?.path ?? "/zh-cn/sitelock",
    meta: sitelockUseNRdjOj7Meta || {},
    alias: sitelockUseNRdjOj7Meta?.alias || [],
    redirect: sitelockUseNRdjOj7Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/sitelock.vue").then(m => m.default || m)
  },
  {
    name: sitelockUseNRdjOj7Meta?.name ?? "sitelock___zh-tw",
    path: sitelockUseNRdjOj7Meta?.path ?? "/zh-tw/sitelock",
    meta: sitelockUseNRdjOj7Meta || {},
    alias: sitelockUseNRdjOj7Meta?.alias || [],
    redirect: sitelockUseNRdjOj7Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/sitelock.vue").then(m => m.default || m)
  },
  {
    name: sitelockUseNRdjOj7Meta?.name ?? "sitelock___jp",
    path: sitelockUseNRdjOj7Meta?.path ?? "/jp/sitelock",
    meta: sitelockUseNRdjOj7Meta || {},
    alias: sitelockUseNRdjOj7Meta?.alias || [],
    redirect: sitelockUseNRdjOj7Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/sitelock.vue").then(m => m.default || m)
  },
  {
    name: sitelockUseNRdjOj7Meta?.name ?? "sitelock___es",
    path: sitelockUseNRdjOj7Meta?.path ?? "/es/sitelock",
    meta: sitelockUseNRdjOj7Meta || {},
    alias: sitelockUseNRdjOj7Meta?.alias || [],
    redirect: sitelockUseNRdjOj7Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/sitelock.vue").then(m => m.default || m)
  },
  {
    name: sitelockUseNRdjOj7Meta?.name ?? "sitelock___fr",
    path: sitelockUseNRdjOj7Meta?.path ?? "/fr/sitelock",
    meta: sitelockUseNRdjOj7Meta || {},
    alias: sitelockUseNRdjOj7Meta?.alias || [],
    redirect: sitelockUseNRdjOj7Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/sitelock.vue").then(m => m.default || m)
  },
  {
    name: sitelockUseNRdjOj7Meta?.name ?? "sitelock___de",
    path: sitelockUseNRdjOj7Meta?.path ?? "/de/sitelock",
    meta: sitelockUseNRdjOj7Meta || {},
    alias: sitelockUseNRdjOj7Meta?.alias || [],
    redirect: sitelockUseNRdjOj7Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/sitelock.vue").then(m => m.default || m)
  },
  {
    name: sitelockUseNRdjOj7Meta?.name ?? "sitelock___kr",
    path: sitelockUseNRdjOj7Meta?.path ?? "/kr/sitelock",
    meta: sitelockUseNRdjOj7Meta || {},
    alias: sitelockUseNRdjOj7Meta?.alias || [],
    redirect: sitelockUseNRdjOj7Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/sitelock.vue").then(m => m.default || m)
  },
  {
    name: sitelockUseNRdjOj7Meta?.name ?? "sitelock___vn",
    path: sitelockUseNRdjOj7Meta?.path ?? "/vn/sitelock",
    meta: sitelockUseNRdjOj7Meta || {},
    alias: sitelockUseNRdjOj7Meta?.alias || [],
    redirect: sitelockUseNRdjOj7Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/sitelock.vue").then(m => m.default || m)
  },
  {
    name: sitelockUseNRdjOj7Meta?.name ?? "sitelock___th",
    path: sitelockUseNRdjOj7Meta?.path ?? "/th/sitelock",
    meta: sitelockUseNRdjOj7Meta || {},
    alias: sitelockUseNRdjOj7Meta?.alias || [],
    redirect: sitelockUseNRdjOj7Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/sitelock.vue").then(m => m.default || m)
  },
  {
    name: sitelockUseNRdjOj7Meta?.name ?? "sitelock___ru",
    path: sitelockUseNRdjOj7Meta?.path ?? "/ru/sitelock",
    meta: sitelockUseNRdjOj7Meta || {},
    alias: sitelockUseNRdjOj7Meta?.alias || [],
    redirect: sitelockUseNRdjOj7Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/sitelock.vue").then(m => m.default || m)
  },
  {
    name: sitelockUseNRdjOj7Meta?.name ?? "sitelock___tr",
    path: sitelockUseNRdjOj7Meta?.path ?? "/tr/sitelock",
    meta: sitelockUseNRdjOj7Meta || {},
    alias: sitelockUseNRdjOj7Meta?.alias || [],
    redirect: sitelockUseNRdjOj7Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/sitelock.vue").then(m => m.default || m)
  },
  {
    name: compliance0iSTfh82KuMeta?.name ?? "solution-compliance___en",
    path: compliance0iSTfh82KuMeta?.path ?? "/solution/compliance",
    meta: compliance0iSTfh82KuMeta || {},
    alias: compliance0iSTfh82KuMeta?.alias || [],
    redirect: compliance0iSTfh82KuMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/compliance.vue").then(m => m.default || m)
  },
  {
    name: compliance0iSTfh82KuMeta?.name ?? "solution-compliance___zh-cn",
    path: compliance0iSTfh82KuMeta?.path ?? "/zh-cn/solution/compliance",
    meta: compliance0iSTfh82KuMeta || {},
    alias: compliance0iSTfh82KuMeta?.alias || [],
    redirect: compliance0iSTfh82KuMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/compliance.vue").then(m => m.default || m)
  },
  {
    name: compliance0iSTfh82KuMeta?.name ?? "solution-compliance___zh-tw",
    path: compliance0iSTfh82KuMeta?.path ?? "/zh-tw/solution/compliance",
    meta: compliance0iSTfh82KuMeta || {},
    alias: compliance0iSTfh82KuMeta?.alias || [],
    redirect: compliance0iSTfh82KuMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/compliance.vue").then(m => m.default || m)
  },
  {
    name: compliance0iSTfh82KuMeta?.name ?? "solution-compliance___jp",
    path: compliance0iSTfh82KuMeta?.path ?? "/jp/solution/compliance",
    meta: compliance0iSTfh82KuMeta || {},
    alias: compliance0iSTfh82KuMeta?.alias || [],
    redirect: compliance0iSTfh82KuMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/compliance.vue").then(m => m.default || m)
  },
  {
    name: compliance0iSTfh82KuMeta?.name ?? "solution-compliance___es",
    path: compliance0iSTfh82KuMeta?.path ?? "/es/solution/compliance",
    meta: compliance0iSTfh82KuMeta || {},
    alias: compliance0iSTfh82KuMeta?.alias || [],
    redirect: compliance0iSTfh82KuMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/compliance.vue").then(m => m.default || m)
  },
  {
    name: compliance0iSTfh82KuMeta?.name ?? "solution-compliance___fr",
    path: compliance0iSTfh82KuMeta?.path ?? "/fr/solution/compliance",
    meta: compliance0iSTfh82KuMeta || {},
    alias: compliance0iSTfh82KuMeta?.alias || [],
    redirect: compliance0iSTfh82KuMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/compliance.vue").then(m => m.default || m)
  },
  {
    name: compliance0iSTfh82KuMeta?.name ?? "solution-compliance___de",
    path: compliance0iSTfh82KuMeta?.path ?? "/de/solution/compliance",
    meta: compliance0iSTfh82KuMeta || {},
    alias: compliance0iSTfh82KuMeta?.alias || [],
    redirect: compliance0iSTfh82KuMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/compliance.vue").then(m => m.default || m)
  },
  {
    name: compliance0iSTfh82KuMeta?.name ?? "solution-compliance___kr",
    path: compliance0iSTfh82KuMeta?.path ?? "/kr/solution/compliance",
    meta: compliance0iSTfh82KuMeta || {},
    alias: compliance0iSTfh82KuMeta?.alias || [],
    redirect: compliance0iSTfh82KuMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/compliance.vue").then(m => m.default || m)
  },
  {
    name: compliance0iSTfh82KuMeta?.name ?? "solution-compliance___vn",
    path: compliance0iSTfh82KuMeta?.path ?? "/vn/solution/compliance",
    meta: compliance0iSTfh82KuMeta || {},
    alias: compliance0iSTfh82KuMeta?.alias || [],
    redirect: compliance0iSTfh82KuMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/compliance.vue").then(m => m.default || m)
  },
  {
    name: compliance0iSTfh82KuMeta?.name ?? "solution-compliance___th",
    path: compliance0iSTfh82KuMeta?.path ?? "/th/solution/compliance",
    meta: compliance0iSTfh82KuMeta || {},
    alias: compliance0iSTfh82KuMeta?.alias || [],
    redirect: compliance0iSTfh82KuMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/compliance.vue").then(m => m.default || m)
  },
  {
    name: compliance0iSTfh82KuMeta?.name ?? "solution-compliance___ru",
    path: compliance0iSTfh82KuMeta?.path ?? "/ru/solution/compliance",
    meta: compliance0iSTfh82KuMeta || {},
    alias: compliance0iSTfh82KuMeta?.alias || [],
    redirect: compliance0iSTfh82KuMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/compliance.vue").then(m => m.default || m)
  },
  {
    name: compliance0iSTfh82KuMeta?.name ?? "solution-compliance___tr",
    path: compliance0iSTfh82KuMeta?.path ?? "/tr/solution/compliance",
    meta: compliance0iSTfh82KuMeta || {},
    alias: compliance0iSTfh82KuMeta?.alias || [],
    redirect: compliance0iSTfh82KuMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/compliance.vue").then(m => m.default || m)
  },
  {
    name: foreign_45trade_45ecommercejHzX2244VLMeta?.name ?? "solution-foreign-trade-ecommerce___en",
    path: foreign_45trade_45ecommercejHzX2244VLMeta?.path ?? "/solution/foreign-trade-ecommerce",
    meta: foreign_45trade_45ecommercejHzX2244VLMeta || {},
    alias: foreign_45trade_45ecommercejHzX2244VLMeta?.alias || [],
    redirect: foreign_45trade_45ecommercejHzX2244VLMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/foreign-trade-ecommerce.vue").then(m => m.default || m)
  },
  {
    name: foreign_45trade_45ecommercejHzX2244VLMeta?.name ?? "solution-foreign-trade-ecommerce___zh-cn",
    path: foreign_45trade_45ecommercejHzX2244VLMeta?.path ?? "/zh-cn/solution/foreign-trade-ecommerce",
    meta: foreign_45trade_45ecommercejHzX2244VLMeta || {},
    alias: foreign_45trade_45ecommercejHzX2244VLMeta?.alias || [],
    redirect: foreign_45trade_45ecommercejHzX2244VLMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/foreign-trade-ecommerce.vue").then(m => m.default || m)
  },
  {
    name: foreign_45trade_45ecommercejHzX2244VLMeta?.name ?? "solution-foreign-trade-ecommerce___zh-tw",
    path: foreign_45trade_45ecommercejHzX2244VLMeta?.path ?? "/zh-tw/solution/foreign-trade-ecommerce",
    meta: foreign_45trade_45ecommercejHzX2244VLMeta || {},
    alias: foreign_45trade_45ecommercejHzX2244VLMeta?.alias || [],
    redirect: foreign_45trade_45ecommercejHzX2244VLMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/foreign-trade-ecommerce.vue").then(m => m.default || m)
  },
  {
    name: foreign_45trade_45ecommercejHzX2244VLMeta?.name ?? "solution-foreign-trade-ecommerce___jp",
    path: foreign_45trade_45ecommercejHzX2244VLMeta?.path ?? "/jp/solution/foreign-trade-ecommerce",
    meta: foreign_45trade_45ecommercejHzX2244VLMeta || {},
    alias: foreign_45trade_45ecommercejHzX2244VLMeta?.alias || [],
    redirect: foreign_45trade_45ecommercejHzX2244VLMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/foreign-trade-ecommerce.vue").then(m => m.default || m)
  },
  {
    name: foreign_45trade_45ecommercejHzX2244VLMeta?.name ?? "solution-foreign-trade-ecommerce___es",
    path: foreign_45trade_45ecommercejHzX2244VLMeta?.path ?? "/es/solution/foreign-trade-ecommerce",
    meta: foreign_45trade_45ecommercejHzX2244VLMeta || {},
    alias: foreign_45trade_45ecommercejHzX2244VLMeta?.alias || [],
    redirect: foreign_45trade_45ecommercejHzX2244VLMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/foreign-trade-ecommerce.vue").then(m => m.default || m)
  },
  {
    name: foreign_45trade_45ecommercejHzX2244VLMeta?.name ?? "solution-foreign-trade-ecommerce___fr",
    path: foreign_45trade_45ecommercejHzX2244VLMeta?.path ?? "/fr/solution/foreign-trade-ecommerce",
    meta: foreign_45trade_45ecommercejHzX2244VLMeta || {},
    alias: foreign_45trade_45ecommercejHzX2244VLMeta?.alias || [],
    redirect: foreign_45trade_45ecommercejHzX2244VLMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/foreign-trade-ecommerce.vue").then(m => m.default || m)
  },
  {
    name: foreign_45trade_45ecommercejHzX2244VLMeta?.name ?? "solution-foreign-trade-ecommerce___de",
    path: foreign_45trade_45ecommercejHzX2244VLMeta?.path ?? "/de/solution/foreign-trade-ecommerce",
    meta: foreign_45trade_45ecommercejHzX2244VLMeta || {},
    alias: foreign_45trade_45ecommercejHzX2244VLMeta?.alias || [],
    redirect: foreign_45trade_45ecommercejHzX2244VLMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/foreign-trade-ecommerce.vue").then(m => m.default || m)
  },
  {
    name: foreign_45trade_45ecommercejHzX2244VLMeta?.name ?? "solution-foreign-trade-ecommerce___kr",
    path: foreign_45trade_45ecommercejHzX2244VLMeta?.path ?? "/kr/solution/foreign-trade-ecommerce",
    meta: foreign_45trade_45ecommercejHzX2244VLMeta || {},
    alias: foreign_45trade_45ecommercejHzX2244VLMeta?.alias || [],
    redirect: foreign_45trade_45ecommercejHzX2244VLMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/foreign-trade-ecommerce.vue").then(m => m.default || m)
  },
  {
    name: foreign_45trade_45ecommercejHzX2244VLMeta?.name ?? "solution-foreign-trade-ecommerce___vn",
    path: foreign_45trade_45ecommercejHzX2244VLMeta?.path ?? "/vn/solution/foreign-trade-ecommerce",
    meta: foreign_45trade_45ecommercejHzX2244VLMeta || {},
    alias: foreign_45trade_45ecommercejHzX2244VLMeta?.alias || [],
    redirect: foreign_45trade_45ecommercejHzX2244VLMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/foreign-trade-ecommerce.vue").then(m => m.default || m)
  },
  {
    name: foreign_45trade_45ecommercejHzX2244VLMeta?.name ?? "solution-foreign-trade-ecommerce___th",
    path: foreign_45trade_45ecommercejHzX2244VLMeta?.path ?? "/th/solution/foreign-trade-ecommerce",
    meta: foreign_45trade_45ecommercejHzX2244VLMeta || {},
    alias: foreign_45trade_45ecommercejHzX2244VLMeta?.alias || [],
    redirect: foreign_45trade_45ecommercejHzX2244VLMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/foreign-trade-ecommerce.vue").then(m => m.default || m)
  },
  {
    name: foreign_45trade_45ecommercejHzX2244VLMeta?.name ?? "solution-foreign-trade-ecommerce___ru",
    path: foreign_45trade_45ecommercejHzX2244VLMeta?.path ?? "/ru/solution/foreign-trade-ecommerce",
    meta: foreign_45trade_45ecommercejHzX2244VLMeta || {},
    alias: foreign_45trade_45ecommercejHzX2244VLMeta?.alias || [],
    redirect: foreign_45trade_45ecommercejHzX2244VLMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/foreign-trade-ecommerce.vue").then(m => m.default || m)
  },
  {
    name: foreign_45trade_45ecommercejHzX2244VLMeta?.name ?? "solution-foreign-trade-ecommerce___tr",
    path: foreign_45trade_45ecommercejHzX2244VLMeta?.path ?? "/tr/solution/foreign-trade-ecommerce",
    meta: foreign_45trade_45ecommercejHzX2244VLMeta || {},
    alias: foreign_45trade_45ecommercejHzX2244VLMeta?.alias || [],
    redirect: foreign_45trade_45ecommercejHzX2244VLMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/foreign-trade-ecommerce.vue").then(m => m.default || m)
  },
  {
    name: hostingy0JfMpgGHrMeta?.name ?? "solution-hosting___en",
    path: hostingy0JfMpgGHrMeta?.path ?? "/solution/hosting",
    meta: hostingy0JfMpgGHrMeta || {},
    alias: hostingy0JfMpgGHrMeta?.alias || [],
    redirect: hostingy0JfMpgGHrMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/hosting.vue").then(m => m.default || m)
  },
  {
    name: hostingy0JfMpgGHrMeta?.name ?? "solution-hosting___zh-cn",
    path: hostingy0JfMpgGHrMeta?.path ?? "/zh-cn/solution/hosting",
    meta: hostingy0JfMpgGHrMeta || {},
    alias: hostingy0JfMpgGHrMeta?.alias || [],
    redirect: hostingy0JfMpgGHrMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/hosting.vue").then(m => m.default || m)
  },
  {
    name: hostingy0JfMpgGHrMeta?.name ?? "solution-hosting___zh-tw",
    path: hostingy0JfMpgGHrMeta?.path ?? "/zh-tw/solution/hosting",
    meta: hostingy0JfMpgGHrMeta || {},
    alias: hostingy0JfMpgGHrMeta?.alias || [],
    redirect: hostingy0JfMpgGHrMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/hosting.vue").then(m => m.default || m)
  },
  {
    name: hostingy0JfMpgGHrMeta?.name ?? "solution-hosting___jp",
    path: hostingy0JfMpgGHrMeta?.path ?? "/jp/solution/hosting",
    meta: hostingy0JfMpgGHrMeta || {},
    alias: hostingy0JfMpgGHrMeta?.alias || [],
    redirect: hostingy0JfMpgGHrMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/hosting.vue").then(m => m.default || m)
  },
  {
    name: hostingy0JfMpgGHrMeta?.name ?? "solution-hosting___es",
    path: hostingy0JfMpgGHrMeta?.path ?? "/es/solution/hosting",
    meta: hostingy0JfMpgGHrMeta || {},
    alias: hostingy0JfMpgGHrMeta?.alias || [],
    redirect: hostingy0JfMpgGHrMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/hosting.vue").then(m => m.default || m)
  },
  {
    name: hostingy0JfMpgGHrMeta?.name ?? "solution-hosting___fr",
    path: hostingy0JfMpgGHrMeta?.path ?? "/fr/solution/hosting",
    meta: hostingy0JfMpgGHrMeta || {},
    alias: hostingy0JfMpgGHrMeta?.alias || [],
    redirect: hostingy0JfMpgGHrMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/hosting.vue").then(m => m.default || m)
  },
  {
    name: hostingy0JfMpgGHrMeta?.name ?? "solution-hosting___de",
    path: hostingy0JfMpgGHrMeta?.path ?? "/de/solution/hosting",
    meta: hostingy0JfMpgGHrMeta || {},
    alias: hostingy0JfMpgGHrMeta?.alias || [],
    redirect: hostingy0JfMpgGHrMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/hosting.vue").then(m => m.default || m)
  },
  {
    name: hostingy0JfMpgGHrMeta?.name ?? "solution-hosting___kr",
    path: hostingy0JfMpgGHrMeta?.path ?? "/kr/solution/hosting",
    meta: hostingy0JfMpgGHrMeta || {},
    alias: hostingy0JfMpgGHrMeta?.alias || [],
    redirect: hostingy0JfMpgGHrMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/hosting.vue").then(m => m.default || m)
  },
  {
    name: hostingy0JfMpgGHrMeta?.name ?? "solution-hosting___vn",
    path: hostingy0JfMpgGHrMeta?.path ?? "/vn/solution/hosting",
    meta: hostingy0JfMpgGHrMeta || {},
    alias: hostingy0JfMpgGHrMeta?.alias || [],
    redirect: hostingy0JfMpgGHrMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/hosting.vue").then(m => m.default || m)
  },
  {
    name: hostingy0JfMpgGHrMeta?.name ?? "solution-hosting___th",
    path: hostingy0JfMpgGHrMeta?.path ?? "/th/solution/hosting",
    meta: hostingy0JfMpgGHrMeta || {},
    alias: hostingy0JfMpgGHrMeta?.alias || [],
    redirect: hostingy0JfMpgGHrMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/hosting.vue").then(m => m.default || m)
  },
  {
    name: hostingy0JfMpgGHrMeta?.name ?? "solution-hosting___ru",
    path: hostingy0JfMpgGHrMeta?.path ?? "/ru/solution/hosting",
    meta: hostingy0JfMpgGHrMeta || {},
    alias: hostingy0JfMpgGHrMeta?.alias || [],
    redirect: hostingy0JfMpgGHrMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/hosting.vue").then(m => m.default || m)
  },
  {
    name: hostingy0JfMpgGHrMeta?.name ?? "solution-hosting___tr",
    path: hostingy0JfMpgGHrMeta?.path ?? "/tr/solution/hosting",
    meta: hostingy0JfMpgGHrMeta || {},
    alias: hostingy0JfMpgGHrMeta?.alias || [],
    redirect: hostingy0JfMpgGHrMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/hosting.vue").then(m => m.default || m)
  },
  {
    name: pkiWRnAT3uirUMeta?.name ?? "solution-pki___en",
    path: pkiWRnAT3uirUMeta?.path ?? "/solution/pki",
    meta: pkiWRnAT3uirUMeta || {},
    alias: pkiWRnAT3uirUMeta?.alias || [],
    redirect: pkiWRnAT3uirUMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/pki.vue").then(m => m.default || m)
  },
  {
    name: pkiWRnAT3uirUMeta?.name ?? "solution-pki___zh-cn",
    path: pkiWRnAT3uirUMeta?.path ?? "/zh-cn/solution/pki",
    meta: pkiWRnAT3uirUMeta || {},
    alias: pkiWRnAT3uirUMeta?.alias || [],
    redirect: pkiWRnAT3uirUMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/pki.vue").then(m => m.default || m)
  },
  {
    name: pkiWRnAT3uirUMeta?.name ?? "solution-pki___zh-tw",
    path: pkiWRnAT3uirUMeta?.path ?? "/zh-tw/solution/pki",
    meta: pkiWRnAT3uirUMeta || {},
    alias: pkiWRnAT3uirUMeta?.alias || [],
    redirect: pkiWRnAT3uirUMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/pki.vue").then(m => m.default || m)
  },
  {
    name: pkiWRnAT3uirUMeta?.name ?? "solution-pki___jp",
    path: pkiWRnAT3uirUMeta?.path ?? "/jp/solution/pki",
    meta: pkiWRnAT3uirUMeta || {},
    alias: pkiWRnAT3uirUMeta?.alias || [],
    redirect: pkiWRnAT3uirUMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/pki.vue").then(m => m.default || m)
  },
  {
    name: pkiWRnAT3uirUMeta?.name ?? "solution-pki___es",
    path: pkiWRnAT3uirUMeta?.path ?? "/es/solution/pki",
    meta: pkiWRnAT3uirUMeta || {},
    alias: pkiWRnAT3uirUMeta?.alias || [],
    redirect: pkiWRnAT3uirUMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/pki.vue").then(m => m.default || m)
  },
  {
    name: pkiWRnAT3uirUMeta?.name ?? "solution-pki___fr",
    path: pkiWRnAT3uirUMeta?.path ?? "/fr/solution/pki",
    meta: pkiWRnAT3uirUMeta || {},
    alias: pkiWRnAT3uirUMeta?.alias || [],
    redirect: pkiWRnAT3uirUMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/pki.vue").then(m => m.default || m)
  },
  {
    name: pkiWRnAT3uirUMeta?.name ?? "solution-pki___de",
    path: pkiWRnAT3uirUMeta?.path ?? "/de/solution/pki",
    meta: pkiWRnAT3uirUMeta || {},
    alias: pkiWRnAT3uirUMeta?.alias || [],
    redirect: pkiWRnAT3uirUMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/pki.vue").then(m => m.default || m)
  },
  {
    name: pkiWRnAT3uirUMeta?.name ?? "solution-pki___kr",
    path: pkiWRnAT3uirUMeta?.path ?? "/kr/solution/pki",
    meta: pkiWRnAT3uirUMeta || {},
    alias: pkiWRnAT3uirUMeta?.alias || [],
    redirect: pkiWRnAT3uirUMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/pki.vue").then(m => m.default || m)
  },
  {
    name: pkiWRnAT3uirUMeta?.name ?? "solution-pki___vn",
    path: pkiWRnAT3uirUMeta?.path ?? "/vn/solution/pki",
    meta: pkiWRnAT3uirUMeta || {},
    alias: pkiWRnAT3uirUMeta?.alias || [],
    redirect: pkiWRnAT3uirUMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/pki.vue").then(m => m.default || m)
  },
  {
    name: pkiWRnAT3uirUMeta?.name ?? "solution-pki___th",
    path: pkiWRnAT3uirUMeta?.path ?? "/th/solution/pki",
    meta: pkiWRnAT3uirUMeta || {},
    alias: pkiWRnAT3uirUMeta?.alias || [],
    redirect: pkiWRnAT3uirUMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/pki.vue").then(m => m.default || m)
  },
  {
    name: pkiWRnAT3uirUMeta?.name ?? "solution-pki___ru",
    path: pkiWRnAT3uirUMeta?.path ?? "/ru/solution/pki",
    meta: pkiWRnAT3uirUMeta || {},
    alias: pkiWRnAT3uirUMeta?.alias || [],
    redirect: pkiWRnAT3uirUMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/pki.vue").then(m => m.default || m)
  },
  {
    name: pkiWRnAT3uirUMeta?.name ?? "solution-pki___tr",
    path: pkiWRnAT3uirUMeta?.path ?? "/tr/solution/pki",
    meta: pkiWRnAT3uirUMeta || {},
    alias: pkiWRnAT3uirUMeta?.alias || [],
    redirect: pkiWRnAT3uirUMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/pki.vue").then(m => m.default || m)
  },
  {
    name: secured_45emailHrfqhwG6PFMeta?.name ?? "solution-secured-email___en",
    path: secured_45emailHrfqhwG6PFMeta?.path ?? "/solution/secured-email",
    meta: secured_45emailHrfqhwG6PFMeta || {},
    alias: secured_45emailHrfqhwG6PFMeta?.alias || [],
    redirect: secured_45emailHrfqhwG6PFMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/secured-email.vue").then(m => m.default || m)
  },
  {
    name: secured_45emailHrfqhwG6PFMeta?.name ?? "solution-secured-email___zh-cn",
    path: secured_45emailHrfqhwG6PFMeta?.path ?? "/zh-cn/solution/secured-email",
    meta: secured_45emailHrfqhwG6PFMeta || {},
    alias: secured_45emailHrfqhwG6PFMeta?.alias || [],
    redirect: secured_45emailHrfqhwG6PFMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/secured-email.vue").then(m => m.default || m)
  },
  {
    name: secured_45emailHrfqhwG6PFMeta?.name ?? "solution-secured-email___zh-tw",
    path: secured_45emailHrfqhwG6PFMeta?.path ?? "/zh-tw/solution/secured-email",
    meta: secured_45emailHrfqhwG6PFMeta || {},
    alias: secured_45emailHrfqhwG6PFMeta?.alias || [],
    redirect: secured_45emailHrfqhwG6PFMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/secured-email.vue").then(m => m.default || m)
  },
  {
    name: secured_45emailHrfqhwG6PFMeta?.name ?? "solution-secured-email___jp",
    path: secured_45emailHrfqhwG6PFMeta?.path ?? "/jp/solution/secured-email",
    meta: secured_45emailHrfqhwG6PFMeta || {},
    alias: secured_45emailHrfqhwG6PFMeta?.alias || [],
    redirect: secured_45emailHrfqhwG6PFMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/secured-email.vue").then(m => m.default || m)
  },
  {
    name: secured_45emailHrfqhwG6PFMeta?.name ?? "solution-secured-email___es",
    path: secured_45emailHrfqhwG6PFMeta?.path ?? "/es/solution/secured-email",
    meta: secured_45emailHrfqhwG6PFMeta || {},
    alias: secured_45emailHrfqhwG6PFMeta?.alias || [],
    redirect: secured_45emailHrfqhwG6PFMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/secured-email.vue").then(m => m.default || m)
  },
  {
    name: secured_45emailHrfqhwG6PFMeta?.name ?? "solution-secured-email___fr",
    path: secured_45emailHrfqhwG6PFMeta?.path ?? "/fr/solution/secured-email",
    meta: secured_45emailHrfqhwG6PFMeta || {},
    alias: secured_45emailHrfqhwG6PFMeta?.alias || [],
    redirect: secured_45emailHrfqhwG6PFMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/secured-email.vue").then(m => m.default || m)
  },
  {
    name: secured_45emailHrfqhwG6PFMeta?.name ?? "solution-secured-email___de",
    path: secured_45emailHrfqhwG6PFMeta?.path ?? "/de/solution/secured-email",
    meta: secured_45emailHrfqhwG6PFMeta || {},
    alias: secured_45emailHrfqhwG6PFMeta?.alias || [],
    redirect: secured_45emailHrfqhwG6PFMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/secured-email.vue").then(m => m.default || m)
  },
  {
    name: secured_45emailHrfqhwG6PFMeta?.name ?? "solution-secured-email___kr",
    path: secured_45emailHrfqhwG6PFMeta?.path ?? "/kr/solution/secured-email",
    meta: secured_45emailHrfqhwG6PFMeta || {},
    alias: secured_45emailHrfqhwG6PFMeta?.alias || [],
    redirect: secured_45emailHrfqhwG6PFMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/secured-email.vue").then(m => m.default || m)
  },
  {
    name: secured_45emailHrfqhwG6PFMeta?.name ?? "solution-secured-email___vn",
    path: secured_45emailHrfqhwG6PFMeta?.path ?? "/vn/solution/secured-email",
    meta: secured_45emailHrfqhwG6PFMeta || {},
    alias: secured_45emailHrfqhwG6PFMeta?.alias || [],
    redirect: secured_45emailHrfqhwG6PFMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/secured-email.vue").then(m => m.default || m)
  },
  {
    name: secured_45emailHrfqhwG6PFMeta?.name ?? "solution-secured-email___th",
    path: secured_45emailHrfqhwG6PFMeta?.path ?? "/th/solution/secured-email",
    meta: secured_45emailHrfqhwG6PFMeta || {},
    alias: secured_45emailHrfqhwG6PFMeta?.alias || [],
    redirect: secured_45emailHrfqhwG6PFMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/secured-email.vue").then(m => m.default || m)
  },
  {
    name: secured_45emailHrfqhwG6PFMeta?.name ?? "solution-secured-email___ru",
    path: secured_45emailHrfqhwG6PFMeta?.path ?? "/ru/solution/secured-email",
    meta: secured_45emailHrfqhwG6PFMeta || {},
    alias: secured_45emailHrfqhwG6PFMeta?.alias || [],
    redirect: secured_45emailHrfqhwG6PFMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/secured-email.vue").then(m => m.default || m)
  },
  {
    name: secured_45emailHrfqhwG6PFMeta?.name ?? "solution-secured-email___tr",
    path: secured_45emailHrfqhwG6PFMeta?.path ?? "/tr/solution/secured-email",
    meta: secured_45emailHrfqhwG6PFMeta || {},
    alias: secured_45emailHrfqhwG6PFMeta?.alias || [],
    redirect: secured_45emailHrfqhwG6PFMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/secured-email.vue").then(m => m.default || m)
  },
  {
    name: ucmjqNOF4PpkGMeta?.name ?? "solution-ucm___en",
    path: ucmjqNOF4PpkGMeta?.path ?? "/solution/ucm",
    meta: ucmjqNOF4PpkGMeta || {},
    alias: ucmjqNOF4PpkGMeta?.alias || [],
    redirect: ucmjqNOF4PpkGMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/ucm.vue").then(m => m.default || m)
  },
  {
    name: ucmjqNOF4PpkGMeta?.name ?? "solution-ucm___zh-cn",
    path: ucmjqNOF4PpkGMeta?.path ?? "/zh-cn/solution/ucm",
    meta: ucmjqNOF4PpkGMeta || {},
    alias: ucmjqNOF4PpkGMeta?.alias || [],
    redirect: ucmjqNOF4PpkGMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/ucm.vue").then(m => m.default || m)
  },
  {
    name: ucmjqNOF4PpkGMeta?.name ?? "solution-ucm___zh-tw",
    path: ucmjqNOF4PpkGMeta?.path ?? "/zh-tw/solution/ucm",
    meta: ucmjqNOF4PpkGMeta || {},
    alias: ucmjqNOF4PpkGMeta?.alias || [],
    redirect: ucmjqNOF4PpkGMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/ucm.vue").then(m => m.default || m)
  },
  {
    name: ucmjqNOF4PpkGMeta?.name ?? "solution-ucm___jp",
    path: ucmjqNOF4PpkGMeta?.path ?? "/jp/solution/ucm",
    meta: ucmjqNOF4PpkGMeta || {},
    alias: ucmjqNOF4PpkGMeta?.alias || [],
    redirect: ucmjqNOF4PpkGMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/ucm.vue").then(m => m.default || m)
  },
  {
    name: ucmjqNOF4PpkGMeta?.name ?? "solution-ucm___es",
    path: ucmjqNOF4PpkGMeta?.path ?? "/es/solution/ucm",
    meta: ucmjqNOF4PpkGMeta || {},
    alias: ucmjqNOF4PpkGMeta?.alias || [],
    redirect: ucmjqNOF4PpkGMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/ucm.vue").then(m => m.default || m)
  },
  {
    name: ucmjqNOF4PpkGMeta?.name ?? "solution-ucm___fr",
    path: ucmjqNOF4PpkGMeta?.path ?? "/fr/solution/ucm",
    meta: ucmjqNOF4PpkGMeta || {},
    alias: ucmjqNOF4PpkGMeta?.alias || [],
    redirect: ucmjqNOF4PpkGMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/ucm.vue").then(m => m.default || m)
  },
  {
    name: ucmjqNOF4PpkGMeta?.name ?? "solution-ucm___de",
    path: ucmjqNOF4PpkGMeta?.path ?? "/de/solution/ucm",
    meta: ucmjqNOF4PpkGMeta || {},
    alias: ucmjqNOF4PpkGMeta?.alias || [],
    redirect: ucmjqNOF4PpkGMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/ucm.vue").then(m => m.default || m)
  },
  {
    name: ucmjqNOF4PpkGMeta?.name ?? "solution-ucm___kr",
    path: ucmjqNOF4PpkGMeta?.path ?? "/kr/solution/ucm",
    meta: ucmjqNOF4PpkGMeta || {},
    alias: ucmjqNOF4PpkGMeta?.alias || [],
    redirect: ucmjqNOF4PpkGMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/ucm.vue").then(m => m.default || m)
  },
  {
    name: ucmjqNOF4PpkGMeta?.name ?? "solution-ucm___vn",
    path: ucmjqNOF4PpkGMeta?.path ?? "/vn/solution/ucm",
    meta: ucmjqNOF4PpkGMeta || {},
    alias: ucmjqNOF4PpkGMeta?.alias || [],
    redirect: ucmjqNOF4PpkGMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/ucm.vue").then(m => m.default || m)
  },
  {
    name: ucmjqNOF4PpkGMeta?.name ?? "solution-ucm___th",
    path: ucmjqNOF4PpkGMeta?.path ?? "/th/solution/ucm",
    meta: ucmjqNOF4PpkGMeta || {},
    alias: ucmjqNOF4PpkGMeta?.alias || [],
    redirect: ucmjqNOF4PpkGMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/ucm.vue").then(m => m.default || m)
  },
  {
    name: ucmjqNOF4PpkGMeta?.name ?? "solution-ucm___ru",
    path: ucmjqNOF4PpkGMeta?.path ?? "/ru/solution/ucm",
    meta: ucmjqNOF4PpkGMeta || {},
    alias: ucmjqNOF4PpkGMeta?.alias || [],
    redirect: ucmjqNOF4PpkGMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/ucm.vue").then(m => m.default || m)
  },
  {
    name: ucmjqNOF4PpkGMeta?.name ?? "solution-ucm___tr",
    path: ucmjqNOF4PpkGMeta?.path ?? "/tr/solution/ucm",
    meta: ucmjqNOF4PpkGMeta || {},
    alias: ucmjqNOF4PpkGMeta?.alias || [],
    redirect: ucmjqNOF4PpkGMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/solution/ucm.vue").then(m => m.default || m)
  },
  {
    name: ssl_45checkerxkOEuBYTL5Meta?.name ?? "ssl-checker___en",
    path: ssl_45checkerxkOEuBYTL5Meta?.path ?? "/ssl-checker",
    meta: ssl_45checkerxkOEuBYTL5Meta || {},
    alias: ssl_45checkerxkOEuBYTL5Meta?.alias || [],
    redirect: ssl_45checkerxkOEuBYTL5Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl-checker.vue").then(m => m.default || m)
  },
  {
    name: ssl_45checkerxkOEuBYTL5Meta?.name ?? "ssl-checker___zh-cn",
    path: ssl_45checkerxkOEuBYTL5Meta?.path ?? "/zh-cn/ssl-checker",
    meta: ssl_45checkerxkOEuBYTL5Meta || {},
    alias: ssl_45checkerxkOEuBYTL5Meta?.alias || [],
    redirect: ssl_45checkerxkOEuBYTL5Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl-checker.vue").then(m => m.default || m)
  },
  {
    name: ssl_45checkerxkOEuBYTL5Meta?.name ?? "ssl-checker___zh-tw",
    path: ssl_45checkerxkOEuBYTL5Meta?.path ?? "/zh-tw/ssl-checker",
    meta: ssl_45checkerxkOEuBYTL5Meta || {},
    alias: ssl_45checkerxkOEuBYTL5Meta?.alias || [],
    redirect: ssl_45checkerxkOEuBYTL5Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl-checker.vue").then(m => m.default || m)
  },
  {
    name: ssl_45checkerxkOEuBYTL5Meta?.name ?? "ssl-checker___jp",
    path: ssl_45checkerxkOEuBYTL5Meta?.path ?? "/jp/ssl-checker",
    meta: ssl_45checkerxkOEuBYTL5Meta || {},
    alias: ssl_45checkerxkOEuBYTL5Meta?.alias || [],
    redirect: ssl_45checkerxkOEuBYTL5Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl-checker.vue").then(m => m.default || m)
  },
  {
    name: ssl_45checkerxkOEuBYTL5Meta?.name ?? "ssl-checker___es",
    path: ssl_45checkerxkOEuBYTL5Meta?.path ?? "/es/ssl-checker",
    meta: ssl_45checkerxkOEuBYTL5Meta || {},
    alias: ssl_45checkerxkOEuBYTL5Meta?.alias || [],
    redirect: ssl_45checkerxkOEuBYTL5Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl-checker.vue").then(m => m.default || m)
  },
  {
    name: ssl_45checkerxkOEuBYTL5Meta?.name ?? "ssl-checker___fr",
    path: ssl_45checkerxkOEuBYTL5Meta?.path ?? "/fr/ssl-checker",
    meta: ssl_45checkerxkOEuBYTL5Meta || {},
    alias: ssl_45checkerxkOEuBYTL5Meta?.alias || [],
    redirect: ssl_45checkerxkOEuBYTL5Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl-checker.vue").then(m => m.default || m)
  },
  {
    name: ssl_45checkerxkOEuBYTL5Meta?.name ?? "ssl-checker___de",
    path: ssl_45checkerxkOEuBYTL5Meta?.path ?? "/de/ssl-checker",
    meta: ssl_45checkerxkOEuBYTL5Meta || {},
    alias: ssl_45checkerxkOEuBYTL5Meta?.alias || [],
    redirect: ssl_45checkerxkOEuBYTL5Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl-checker.vue").then(m => m.default || m)
  },
  {
    name: ssl_45checkerxkOEuBYTL5Meta?.name ?? "ssl-checker___kr",
    path: ssl_45checkerxkOEuBYTL5Meta?.path ?? "/kr/ssl-checker",
    meta: ssl_45checkerxkOEuBYTL5Meta || {},
    alias: ssl_45checkerxkOEuBYTL5Meta?.alias || [],
    redirect: ssl_45checkerxkOEuBYTL5Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl-checker.vue").then(m => m.default || m)
  },
  {
    name: ssl_45checkerxkOEuBYTL5Meta?.name ?? "ssl-checker___vn",
    path: ssl_45checkerxkOEuBYTL5Meta?.path ?? "/vn/ssl-checker",
    meta: ssl_45checkerxkOEuBYTL5Meta || {},
    alias: ssl_45checkerxkOEuBYTL5Meta?.alias || [],
    redirect: ssl_45checkerxkOEuBYTL5Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl-checker.vue").then(m => m.default || m)
  },
  {
    name: ssl_45checkerxkOEuBYTL5Meta?.name ?? "ssl-checker___th",
    path: ssl_45checkerxkOEuBYTL5Meta?.path ?? "/th/ssl-checker",
    meta: ssl_45checkerxkOEuBYTL5Meta || {},
    alias: ssl_45checkerxkOEuBYTL5Meta?.alias || [],
    redirect: ssl_45checkerxkOEuBYTL5Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl-checker.vue").then(m => m.default || m)
  },
  {
    name: ssl_45checkerxkOEuBYTL5Meta?.name ?? "ssl-checker___ru",
    path: ssl_45checkerxkOEuBYTL5Meta?.path ?? "/ru/ssl-checker",
    meta: ssl_45checkerxkOEuBYTL5Meta || {},
    alias: ssl_45checkerxkOEuBYTL5Meta?.alias || [],
    redirect: ssl_45checkerxkOEuBYTL5Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl-checker.vue").then(m => m.default || m)
  },
  {
    name: ssl_45checkerxkOEuBYTL5Meta?.name ?? "ssl-checker___tr",
    path: ssl_45checkerxkOEuBYTL5Meta?.path ?? "/tr/ssl-checker",
    meta: ssl_45checkerxkOEuBYTL5Meta || {},
    alias: ssl_45checkerxkOEuBYTL5Meta?.alias || [],
    redirect: ssl_45checkerxkOEuBYTL5Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl-checker.vue").then(m => m.default || m)
  },
  {
    name: ssl_45converterupq6O3q4dRMeta?.name ?? "ssl-converter___en",
    path: ssl_45converterupq6O3q4dRMeta?.path ?? "/ssl-converter",
    meta: ssl_45converterupq6O3q4dRMeta || {},
    alias: ssl_45converterupq6O3q4dRMeta?.alias || [],
    redirect: ssl_45converterupq6O3q4dRMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl-converter.vue").then(m => m.default || m)
  },
  {
    name: ssl_45converterupq6O3q4dRMeta?.name ?? "ssl-converter___zh-cn",
    path: ssl_45converterupq6O3q4dRMeta?.path ?? "/zh-cn/ssl-converter",
    meta: ssl_45converterupq6O3q4dRMeta || {},
    alias: ssl_45converterupq6O3q4dRMeta?.alias || [],
    redirect: ssl_45converterupq6O3q4dRMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl-converter.vue").then(m => m.default || m)
  },
  {
    name: ssl_45converterupq6O3q4dRMeta?.name ?? "ssl-converter___zh-tw",
    path: ssl_45converterupq6O3q4dRMeta?.path ?? "/zh-tw/ssl-converter",
    meta: ssl_45converterupq6O3q4dRMeta || {},
    alias: ssl_45converterupq6O3q4dRMeta?.alias || [],
    redirect: ssl_45converterupq6O3q4dRMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl-converter.vue").then(m => m.default || m)
  },
  {
    name: ssl_45converterupq6O3q4dRMeta?.name ?? "ssl-converter___jp",
    path: ssl_45converterupq6O3q4dRMeta?.path ?? "/jp/ssl-converter",
    meta: ssl_45converterupq6O3q4dRMeta || {},
    alias: ssl_45converterupq6O3q4dRMeta?.alias || [],
    redirect: ssl_45converterupq6O3q4dRMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl-converter.vue").then(m => m.default || m)
  },
  {
    name: ssl_45converterupq6O3q4dRMeta?.name ?? "ssl-converter___es",
    path: ssl_45converterupq6O3q4dRMeta?.path ?? "/es/ssl-converter",
    meta: ssl_45converterupq6O3q4dRMeta || {},
    alias: ssl_45converterupq6O3q4dRMeta?.alias || [],
    redirect: ssl_45converterupq6O3q4dRMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl-converter.vue").then(m => m.default || m)
  },
  {
    name: ssl_45converterupq6O3q4dRMeta?.name ?? "ssl-converter___fr",
    path: ssl_45converterupq6O3q4dRMeta?.path ?? "/fr/ssl-converter",
    meta: ssl_45converterupq6O3q4dRMeta || {},
    alias: ssl_45converterupq6O3q4dRMeta?.alias || [],
    redirect: ssl_45converterupq6O3q4dRMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl-converter.vue").then(m => m.default || m)
  },
  {
    name: ssl_45converterupq6O3q4dRMeta?.name ?? "ssl-converter___de",
    path: ssl_45converterupq6O3q4dRMeta?.path ?? "/de/ssl-converter",
    meta: ssl_45converterupq6O3q4dRMeta || {},
    alias: ssl_45converterupq6O3q4dRMeta?.alias || [],
    redirect: ssl_45converterupq6O3q4dRMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl-converter.vue").then(m => m.default || m)
  },
  {
    name: ssl_45converterupq6O3q4dRMeta?.name ?? "ssl-converter___kr",
    path: ssl_45converterupq6O3q4dRMeta?.path ?? "/kr/ssl-converter",
    meta: ssl_45converterupq6O3q4dRMeta || {},
    alias: ssl_45converterupq6O3q4dRMeta?.alias || [],
    redirect: ssl_45converterupq6O3q4dRMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl-converter.vue").then(m => m.default || m)
  },
  {
    name: ssl_45converterupq6O3q4dRMeta?.name ?? "ssl-converter___vn",
    path: ssl_45converterupq6O3q4dRMeta?.path ?? "/vn/ssl-converter",
    meta: ssl_45converterupq6O3q4dRMeta || {},
    alias: ssl_45converterupq6O3q4dRMeta?.alias || [],
    redirect: ssl_45converterupq6O3q4dRMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl-converter.vue").then(m => m.default || m)
  },
  {
    name: ssl_45converterupq6O3q4dRMeta?.name ?? "ssl-converter___th",
    path: ssl_45converterupq6O3q4dRMeta?.path ?? "/th/ssl-converter",
    meta: ssl_45converterupq6O3q4dRMeta || {},
    alias: ssl_45converterupq6O3q4dRMeta?.alias || [],
    redirect: ssl_45converterupq6O3q4dRMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl-converter.vue").then(m => m.default || m)
  },
  {
    name: ssl_45converterupq6O3q4dRMeta?.name ?? "ssl-converter___ru",
    path: ssl_45converterupq6O3q4dRMeta?.path ?? "/ru/ssl-converter",
    meta: ssl_45converterupq6O3q4dRMeta || {},
    alias: ssl_45converterupq6O3q4dRMeta?.alias || [],
    redirect: ssl_45converterupq6O3q4dRMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl-converter.vue").then(m => m.default || m)
  },
  {
    name: ssl_45converterupq6O3q4dRMeta?.name ?? "ssl-converter___tr",
    path: ssl_45converterupq6O3q4dRMeta?.path ?? "/tr/ssl-converter",
    meta: ssl_45converterupq6O3q4dRMeta || {},
    alias: ssl_45converterupq6O3q4dRMeta?.alias || [],
    redirect: ssl_45converterupq6O3q4dRMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl-converter.vue").then(m => m.default || m)
  },
  {
    name: ssl_45monitoringeyYR4VHxENMeta?.name ?? "ssl-monitoring___en",
    path: ssl_45monitoringeyYR4VHxENMeta?.path ?? "/ssl-monitoring",
    meta: ssl_45monitoringeyYR4VHxENMeta || {},
    alias: ssl_45monitoringeyYR4VHxENMeta?.alias || [],
    redirect: ssl_45monitoringeyYR4VHxENMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl-monitoring.vue").then(m => m.default || m)
  },
  {
    name: ssl_45monitoringeyYR4VHxENMeta?.name ?? "ssl-monitoring___zh-cn",
    path: ssl_45monitoringeyYR4VHxENMeta?.path ?? "/zh-cn/ssl-monitoring",
    meta: ssl_45monitoringeyYR4VHxENMeta || {},
    alias: ssl_45monitoringeyYR4VHxENMeta?.alias || [],
    redirect: ssl_45monitoringeyYR4VHxENMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl-monitoring.vue").then(m => m.default || m)
  },
  {
    name: ssl_45monitoringeyYR4VHxENMeta?.name ?? "ssl-monitoring___zh-tw",
    path: ssl_45monitoringeyYR4VHxENMeta?.path ?? "/zh-tw/ssl-monitoring",
    meta: ssl_45monitoringeyYR4VHxENMeta || {},
    alias: ssl_45monitoringeyYR4VHxENMeta?.alias || [],
    redirect: ssl_45monitoringeyYR4VHxENMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl-monitoring.vue").then(m => m.default || m)
  },
  {
    name: ssl_45monitoringeyYR4VHxENMeta?.name ?? "ssl-monitoring___jp",
    path: ssl_45monitoringeyYR4VHxENMeta?.path ?? "/jp/ssl-monitoring",
    meta: ssl_45monitoringeyYR4VHxENMeta || {},
    alias: ssl_45monitoringeyYR4VHxENMeta?.alias || [],
    redirect: ssl_45monitoringeyYR4VHxENMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl-monitoring.vue").then(m => m.default || m)
  },
  {
    name: ssl_45monitoringeyYR4VHxENMeta?.name ?? "ssl-monitoring___es",
    path: ssl_45monitoringeyYR4VHxENMeta?.path ?? "/es/ssl-monitoring",
    meta: ssl_45monitoringeyYR4VHxENMeta || {},
    alias: ssl_45monitoringeyYR4VHxENMeta?.alias || [],
    redirect: ssl_45monitoringeyYR4VHxENMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl-monitoring.vue").then(m => m.default || m)
  },
  {
    name: ssl_45monitoringeyYR4VHxENMeta?.name ?? "ssl-monitoring___fr",
    path: ssl_45monitoringeyYR4VHxENMeta?.path ?? "/fr/ssl-monitoring",
    meta: ssl_45monitoringeyYR4VHxENMeta || {},
    alias: ssl_45monitoringeyYR4VHxENMeta?.alias || [],
    redirect: ssl_45monitoringeyYR4VHxENMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl-monitoring.vue").then(m => m.default || m)
  },
  {
    name: ssl_45monitoringeyYR4VHxENMeta?.name ?? "ssl-monitoring___de",
    path: ssl_45monitoringeyYR4VHxENMeta?.path ?? "/de/ssl-monitoring",
    meta: ssl_45monitoringeyYR4VHxENMeta || {},
    alias: ssl_45monitoringeyYR4VHxENMeta?.alias || [],
    redirect: ssl_45monitoringeyYR4VHxENMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl-monitoring.vue").then(m => m.default || m)
  },
  {
    name: ssl_45monitoringeyYR4VHxENMeta?.name ?? "ssl-monitoring___kr",
    path: ssl_45monitoringeyYR4VHxENMeta?.path ?? "/kr/ssl-monitoring",
    meta: ssl_45monitoringeyYR4VHxENMeta || {},
    alias: ssl_45monitoringeyYR4VHxENMeta?.alias || [],
    redirect: ssl_45monitoringeyYR4VHxENMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl-monitoring.vue").then(m => m.default || m)
  },
  {
    name: ssl_45monitoringeyYR4VHxENMeta?.name ?? "ssl-monitoring___vn",
    path: ssl_45monitoringeyYR4VHxENMeta?.path ?? "/vn/ssl-monitoring",
    meta: ssl_45monitoringeyYR4VHxENMeta || {},
    alias: ssl_45monitoringeyYR4VHxENMeta?.alias || [],
    redirect: ssl_45monitoringeyYR4VHxENMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl-monitoring.vue").then(m => m.default || m)
  },
  {
    name: ssl_45monitoringeyYR4VHxENMeta?.name ?? "ssl-monitoring___th",
    path: ssl_45monitoringeyYR4VHxENMeta?.path ?? "/th/ssl-monitoring",
    meta: ssl_45monitoringeyYR4VHxENMeta || {},
    alias: ssl_45monitoringeyYR4VHxENMeta?.alias || [],
    redirect: ssl_45monitoringeyYR4VHxENMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl-monitoring.vue").then(m => m.default || m)
  },
  {
    name: ssl_45monitoringeyYR4VHxENMeta?.name ?? "ssl-monitoring___ru",
    path: ssl_45monitoringeyYR4VHxENMeta?.path ?? "/ru/ssl-monitoring",
    meta: ssl_45monitoringeyYR4VHxENMeta || {},
    alias: ssl_45monitoringeyYR4VHxENMeta?.alias || [],
    redirect: ssl_45monitoringeyYR4VHxENMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl-monitoring.vue").then(m => m.default || m)
  },
  {
    name: ssl_45monitoringeyYR4VHxENMeta?.name ?? "ssl-monitoring___tr",
    path: ssl_45monitoringeyYR4VHxENMeta?.path ?? "/tr/ssl-monitoring",
    meta: ssl_45monitoringeyYR4VHxENMeta || {},
    alias: ssl_45monitoringeyYR4VHxENMeta?.alias || [],
    redirect: ssl_45monitoringeyYR4VHxENMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl-monitoring.vue").then(m => m.default || m)
  },
  {
    name: _91viewType_93kQjKfmSOWfMeta?.name ?? "ssl-viewType___en",
    path: _91viewType_93kQjKfmSOWfMeta?.path ?? "/ssl/:viewType()",
    meta: _91viewType_93kQjKfmSOWfMeta || {},
    alias: _91viewType_93kQjKfmSOWfMeta?.alias || [],
    redirect: _91viewType_93kQjKfmSOWfMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl/[viewType].vue").then(m => m.default || m)
  },
  {
    name: _91viewType_93kQjKfmSOWfMeta?.name ?? "ssl-viewType___zh-cn",
    path: _91viewType_93kQjKfmSOWfMeta?.path ?? "/zh-cn/ssl/:viewType()",
    meta: _91viewType_93kQjKfmSOWfMeta || {},
    alias: _91viewType_93kQjKfmSOWfMeta?.alias || [],
    redirect: _91viewType_93kQjKfmSOWfMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl/[viewType].vue").then(m => m.default || m)
  },
  {
    name: _91viewType_93kQjKfmSOWfMeta?.name ?? "ssl-viewType___zh-tw",
    path: _91viewType_93kQjKfmSOWfMeta?.path ?? "/zh-tw/ssl/:viewType()",
    meta: _91viewType_93kQjKfmSOWfMeta || {},
    alias: _91viewType_93kQjKfmSOWfMeta?.alias || [],
    redirect: _91viewType_93kQjKfmSOWfMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl/[viewType].vue").then(m => m.default || m)
  },
  {
    name: _91viewType_93kQjKfmSOWfMeta?.name ?? "ssl-viewType___jp",
    path: _91viewType_93kQjKfmSOWfMeta?.path ?? "/jp/ssl/:viewType()",
    meta: _91viewType_93kQjKfmSOWfMeta || {},
    alias: _91viewType_93kQjKfmSOWfMeta?.alias || [],
    redirect: _91viewType_93kQjKfmSOWfMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl/[viewType].vue").then(m => m.default || m)
  },
  {
    name: _91viewType_93kQjKfmSOWfMeta?.name ?? "ssl-viewType___es",
    path: _91viewType_93kQjKfmSOWfMeta?.path ?? "/es/ssl/:viewType()",
    meta: _91viewType_93kQjKfmSOWfMeta || {},
    alias: _91viewType_93kQjKfmSOWfMeta?.alias || [],
    redirect: _91viewType_93kQjKfmSOWfMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl/[viewType].vue").then(m => m.default || m)
  },
  {
    name: _91viewType_93kQjKfmSOWfMeta?.name ?? "ssl-viewType___fr",
    path: _91viewType_93kQjKfmSOWfMeta?.path ?? "/fr/ssl/:viewType()",
    meta: _91viewType_93kQjKfmSOWfMeta || {},
    alias: _91viewType_93kQjKfmSOWfMeta?.alias || [],
    redirect: _91viewType_93kQjKfmSOWfMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl/[viewType].vue").then(m => m.default || m)
  },
  {
    name: _91viewType_93kQjKfmSOWfMeta?.name ?? "ssl-viewType___de",
    path: _91viewType_93kQjKfmSOWfMeta?.path ?? "/de/ssl/:viewType()",
    meta: _91viewType_93kQjKfmSOWfMeta || {},
    alias: _91viewType_93kQjKfmSOWfMeta?.alias || [],
    redirect: _91viewType_93kQjKfmSOWfMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl/[viewType].vue").then(m => m.default || m)
  },
  {
    name: _91viewType_93kQjKfmSOWfMeta?.name ?? "ssl-viewType___kr",
    path: _91viewType_93kQjKfmSOWfMeta?.path ?? "/kr/ssl/:viewType()",
    meta: _91viewType_93kQjKfmSOWfMeta || {},
    alias: _91viewType_93kQjKfmSOWfMeta?.alias || [],
    redirect: _91viewType_93kQjKfmSOWfMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl/[viewType].vue").then(m => m.default || m)
  },
  {
    name: _91viewType_93kQjKfmSOWfMeta?.name ?? "ssl-viewType___vn",
    path: _91viewType_93kQjKfmSOWfMeta?.path ?? "/vn/ssl/:viewType()",
    meta: _91viewType_93kQjKfmSOWfMeta || {},
    alias: _91viewType_93kQjKfmSOWfMeta?.alias || [],
    redirect: _91viewType_93kQjKfmSOWfMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl/[viewType].vue").then(m => m.default || m)
  },
  {
    name: _91viewType_93kQjKfmSOWfMeta?.name ?? "ssl-viewType___th",
    path: _91viewType_93kQjKfmSOWfMeta?.path ?? "/th/ssl/:viewType()",
    meta: _91viewType_93kQjKfmSOWfMeta || {},
    alias: _91viewType_93kQjKfmSOWfMeta?.alias || [],
    redirect: _91viewType_93kQjKfmSOWfMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl/[viewType].vue").then(m => m.default || m)
  },
  {
    name: _91viewType_93kQjKfmSOWfMeta?.name ?? "ssl-viewType___ru",
    path: _91viewType_93kQjKfmSOWfMeta?.path ?? "/ru/ssl/:viewType()",
    meta: _91viewType_93kQjKfmSOWfMeta || {},
    alias: _91viewType_93kQjKfmSOWfMeta?.alias || [],
    redirect: _91viewType_93kQjKfmSOWfMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl/[viewType].vue").then(m => m.default || m)
  },
  {
    name: _91viewType_93kQjKfmSOWfMeta?.name ?? "ssl-viewType___tr",
    path: _91viewType_93kQjKfmSOWfMeta?.path ?? "/tr/ssl/:viewType()",
    meta: _91viewType_93kQjKfmSOWfMeta || {},
    alias: _91viewType_93kQjKfmSOWfMeta?.alias || [],
    redirect: _91viewType_93kQjKfmSOWfMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl/[viewType].vue").then(m => m.default || m)
  },
  {
    name: indexYBv5K0UvrUMeta?.name ?? "ssl___en",
    path: indexYBv5K0UvrUMeta?.path ?? "/ssl",
    meta: indexYBv5K0UvrUMeta || {},
    alias: indexYBv5K0UvrUMeta?.alias || [],
    redirect: indexYBv5K0UvrUMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl/index.vue").then(m => m.default || m)
  },
  {
    name: indexYBv5K0UvrUMeta?.name ?? "ssl___zh-cn",
    path: indexYBv5K0UvrUMeta?.path ?? "/zh-cn/ssl",
    meta: indexYBv5K0UvrUMeta || {},
    alias: indexYBv5K0UvrUMeta?.alias || [],
    redirect: indexYBv5K0UvrUMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl/index.vue").then(m => m.default || m)
  },
  {
    name: indexYBv5K0UvrUMeta?.name ?? "ssl___zh-tw",
    path: indexYBv5K0UvrUMeta?.path ?? "/zh-tw/ssl",
    meta: indexYBv5K0UvrUMeta || {},
    alias: indexYBv5K0UvrUMeta?.alias || [],
    redirect: indexYBv5K0UvrUMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl/index.vue").then(m => m.default || m)
  },
  {
    name: indexYBv5K0UvrUMeta?.name ?? "ssl___jp",
    path: indexYBv5K0UvrUMeta?.path ?? "/jp/ssl",
    meta: indexYBv5K0UvrUMeta || {},
    alias: indexYBv5K0UvrUMeta?.alias || [],
    redirect: indexYBv5K0UvrUMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl/index.vue").then(m => m.default || m)
  },
  {
    name: indexYBv5K0UvrUMeta?.name ?? "ssl___es",
    path: indexYBv5K0UvrUMeta?.path ?? "/es/ssl",
    meta: indexYBv5K0UvrUMeta || {},
    alias: indexYBv5K0UvrUMeta?.alias || [],
    redirect: indexYBv5K0UvrUMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl/index.vue").then(m => m.default || m)
  },
  {
    name: indexYBv5K0UvrUMeta?.name ?? "ssl___fr",
    path: indexYBv5K0UvrUMeta?.path ?? "/fr/ssl",
    meta: indexYBv5K0UvrUMeta || {},
    alias: indexYBv5K0UvrUMeta?.alias || [],
    redirect: indexYBv5K0UvrUMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl/index.vue").then(m => m.default || m)
  },
  {
    name: indexYBv5K0UvrUMeta?.name ?? "ssl___de",
    path: indexYBv5K0UvrUMeta?.path ?? "/de/ssl",
    meta: indexYBv5K0UvrUMeta || {},
    alias: indexYBv5K0UvrUMeta?.alias || [],
    redirect: indexYBv5K0UvrUMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl/index.vue").then(m => m.default || m)
  },
  {
    name: indexYBv5K0UvrUMeta?.name ?? "ssl___kr",
    path: indexYBv5K0UvrUMeta?.path ?? "/kr/ssl",
    meta: indexYBv5K0UvrUMeta || {},
    alias: indexYBv5K0UvrUMeta?.alias || [],
    redirect: indexYBv5K0UvrUMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl/index.vue").then(m => m.default || m)
  },
  {
    name: indexYBv5K0UvrUMeta?.name ?? "ssl___vn",
    path: indexYBv5K0UvrUMeta?.path ?? "/vn/ssl",
    meta: indexYBv5K0UvrUMeta || {},
    alias: indexYBv5K0UvrUMeta?.alias || [],
    redirect: indexYBv5K0UvrUMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl/index.vue").then(m => m.default || m)
  },
  {
    name: indexYBv5K0UvrUMeta?.name ?? "ssl___th",
    path: indexYBv5K0UvrUMeta?.path ?? "/th/ssl",
    meta: indexYBv5K0UvrUMeta || {},
    alias: indexYBv5K0UvrUMeta?.alias || [],
    redirect: indexYBv5K0UvrUMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl/index.vue").then(m => m.default || m)
  },
  {
    name: indexYBv5K0UvrUMeta?.name ?? "ssl___ru",
    path: indexYBv5K0UvrUMeta?.path ?? "/ru/ssl",
    meta: indexYBv5K0UvrUMeta || {},
    alias: indexYBv5K0UvrUMeta?.alias || [],
    redirect: indexYBv5K0UvrUMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl/index.vue").then(m => m.default || m)
  },
  {
    name: indexYBv5K0UvrUMeta?.name ?? "ssl___tr",
    path: indexYBv5K0UvrUMeta?.path ?? "/tr/ssl",
    meta: indexYBv5K0UvrUMeta || {},
    alias: indexYBv5K0UvrUMeta?.alias || [],
    redirect: indexYBv5K0UvrUMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/ssl/index.vue").then(m => m.default || m)
  },
  {
    name: indexD04gcbwWxZMeta?.name ?? "tools___en",
    path: indexD04gcbwWxZMeta?.path ?? "/tools",
    meta: indexD04gcbwWxZMeta || {},
    alias: indexD04gcbwWxZMeta?.alias || [],
    redirect: indexD04gcbwWxZMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/tools/index.vue").then(m => m.default || m)
  },
  {
    name: indexD04gcbwWxZMeta?.name ?? "tools___zh-cn",
    path: indexD04gcbwWxZMeta?.path ?? "/zh-cn/tools",
    meta: indexD04gcbwWxZMeta || {},
    alias: indexD04gcbwWxZMeta?.alias || [],
    redirect: indexD04gcbwWxZMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/tools/index.vue").then(m => m.default || m)
  },
  {
    name: indexD04gcbwWxZMeta?.name ?? "tools___zh-tw",
    path: indexD04gcbwWxZMeta?.path ?? "/zh-tw/tools",
    meta: indexD04gcbwWxZMeta || {},
    alias: indexD04gcbwWxZMeta?.alias || [],
    redirect: indexD04gcbwWxZMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/tools/index.vue").then(m => m.default || m)
  },
  {
    name: indexD04gcbwWxZMeta?.name ?? "tools___jp",
    path: indexD04gcbwWxZMeta?.path ?? "/jp/tools",
    meta: indexD04gcbwWxZMeta || {},
    alias: indexD04gcbwWxZMeta?.alias || [],
    redirect: indexD04gcbwWxZMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/tools/index.vue").then(m => m.default || m)
  },
  {
    name: indexD04gcbwWxZMeta?.name ?? "tools___es",
    path: indexD04gcbwWxZMeta?.path ?? "/es/tools",
    meta: indexD04gcbwWxZMeta || {},
    alias: indexD04gcbwWxZMeta?.alias || [],
    redirect: indexD04gcbwWxZMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/tools/index.vue").then(m => m.default || m)
  },
  {
    name: indexD04gcbwWxZMeta?.name ?? "tools___fr",
    path: indexD04gcbwWxZMeta?.path ?? "/fr/tools",
    meta: indexD04gcbwWxZMeta || {},
    alias: indexD04gcbwWxZMeta?.alias || [],
    redirect: indexD04gcbwWxZMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/tools/index.vue").then(m => m.default || m)
  },
  {
    name: indexD04gcbwWxZMeta?.name ?? "tools___de",
    path: indexD04gcbwWxZMeta?.path ?? "/de/tools",
    meta: indexD04gcbwWxZMeta || {},
    alias: indexD04gcbwWxZMeta?.alias || [],
    redirect: indexD04gcbwWxZMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/tools/index.vue").then(m => m.default || m)
  },
  {
    name: indexD04gcbwWxZMeta?.name ?? "tools___kr",
    path: indexD04gcbwWxZMeta?.path ?? "/kr/tools",
    meta: indexD04gcbwWxZMeta || {},
    alias: indexD04gcbwWxZMeta?.alias || [],
    redirect: indexD04gcbwWxZMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/tools/index.vue").then(m => m.default || m)
  },
  {
    name: indexD04gcbwWxZMeta?.name ?? "tools___vn",
    path: indexD04gcbwWxZMeta?.path ?? "/vn/tools",
    meta: indexD04gcbwWxZMeta || {},
    alias: indexD04gcbwWxZMeta?.alias || [],
    redirect: indexD04gcbwWxZMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/tools/index.vue").then(m => m.default || m)
  },
  {
    name: indexD04gcbwWxZMeta?.name ?? "tools___th",
    path: indexD04gcbwWxZMeta?.path ?? "/th/tools",
    meta: indexD04gcbwWxZMeta || {},
    alias: indexD04gcbwWxZMeta?.alias || [],
    redirect: indexD04gcbwWxZMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/tools/index.vue").then(m => m.default || m)
  },
  {
    name: indexD04gcbwWxZMeta?.name ?? "tools___ru",
    path: indexD04gcbwWxZMeta?.path ?? "/ru/tools",
    meta: indexD04gcbwWxZMeta || {},
    alias: indexD04gcbwWxZMeta?.alias || [],
    redirect: indexD04gcbwWxZMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/tools/index.vue").then(m => m.default || m)
  },
  {
    name: indexD04gcbwWxZMeta?.name ?? "tools___tr",
    path: indexD04gcbwWxZMeta?.path ?? "/tr/tools",
    meta: indexD04gcbwWxZMeta || {},
    alias: indexD04gcbwWxZMeta?.alias || [],
    redirect: indexD04gcbwWxZMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/tools/index.vue").then(m => m.default || m)
  },
  {
    name: verified_45mark_45certificate5vxDYAamR1Meta?.name ?? "verified-mark-certificate___en",
    path: verified_45mark_45certificate5vxDYAamR1Meta?.path ?? "/verified-mark-certificate",
    meta: verified_45mark_45certificate5vxDYAamR1Meta || {},
    alias: verified_45mark_45certificate5vxDYAamR1Meta?.alias || [],
    redirect: verified_45mark_45certificate5vxDYAamR1Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/verified-mark-certificate.vue").then(m => m.default || m)
  },
  {
    name: verified_45mark_45certificate5vxDYAamR1Meta?.name ?? "verified-mark-certificate___zh-cn",
    path: verified_45mark_45certificate5vxDYAamR1Meta?.path ?? "/zh-cn/verified-mark-certificate",
    meta: verified_45mark_45certificate5vxDYAamR1Meta || {},
    alias: verified_45mark_45certificate5vxDYAamR1Meta?.alias || [],
    redirect: verified_45mark_45certificate5vxDYAamR1Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/verified-mark-certificate.vue").then(m => m.default || m)
  },
  {
    name: verified_45mark_45certificate5vxDYAamR1Meta?.name ?? "verified-mark-certificate___zh-tw",
    path: verified_45mark_45certificate5vxDYAamR1Meta?.path ?? "/zh-tw/verified-mark-certificate",
    meta: verified_45mark_45certificate5vxDYAamR1Meta || {},
    alias: verified_45mark_45certificate5vxDYAamR1Meta?.alias || [],
    redirect: verified_45mark_45certificate5vxDYAamR1Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/verified-mark-certificate.vue").then(m => m.default || m)
  },
  {
    name: verified_45mark_45certificate5vxDYAamR1Meta?.name ?? "verified-mark-certificate___jp",
    path: verified_45mark_45certificate5vxDYAamR1Meta?.path ?? "/jp/verified-mark-certificate",
    meta: verified_45mark_45certificate5vxDYAamR1Meta || {},
    alias: verified_45mark_45certificate5vxDYAamR1Meta?.alias || [],
    redirect: verified_45mark_45certificate5vxDYAamR1Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/verified-mark-certificate.vue").then(m => m.default || m)
  },
  {
    name: verified_45mark_45certificate5vxDYAamR1Meta?.name ?? "verified-mark-certificate___es",
    path: verified_45mark_45certificate5vxDYAamR1Meta?.path ?? "/es/verified-mark-certificate",
    meta: verified_45mark_45certificate5vxDYAamR1Meta || {},
    alias: verified_45mark_45certificate5vxDYAamR1Meta?.alias || [],
    redirect: verified_45mark_45certificate5vxDYAamR1Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/verified-mark-certificate.vue").then(m => m.default || m)
  },
  {
    name: verified_45mark_45certificate5vxDYAamR1Meta?.name ?? "verified-mark-certificate___fr",
    path: verified_45mark_45certificate5vxDYAamR1Meta?.path ?? "/fr/verified-mark-certificate",
    meta: verified_45mark_45certificate5vxDYAamR1Meta || {},
    alias: verified_45mark_45certificate5vxDYAamR1Meta?.alias || [],
    redirect: verified_45mark_45certificate5vxDYAamR1Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/verified-mark-certificate.vue").then(m => m.default || m)
  },
  {
    name: verified_45mark_45certificate5vxDYAamR1Meta?.name ?? "verified-mark-certificate___de",
    path: verified_45mark_45certificate5vxDYAamR1Meta?.path ?? "/de/verified-mark-certificate",
    meta: verified_45mark_45certificate5vxDYAamR1Meta || {},
    alias: verified_45mark_45certificate5vxDYAamR1Meta?.alias || [],
    redirect: verified_45mark_45certificate5vxDYAamR1Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/verified-mark-certificate.vue").then(m => m.default || m)
  },
  {
    name: verified_45mark_45certificate5vxDYAamR1Meta?.name ?? "verified-mark-certificate___kr",
    path: verified_45mark_45certificate5vxDYAamR1Meta?.path ?? "/kr/verified-mark-certificate",
    meta: verified_45mark_45certificate5vxDYAamR1Meta || {},
    alias: verified_45mark_45certificate5vxDYAamR1Meta?.alias || [],
    redirect: verified_45mark_45certificate5vxDYAamR1Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/verified-mark-certificate.vue").then(m => m.default || m)
  },
  {
    name: verified_45mark_45certificate5vxDYAamR1Meta?.name ?? "verified-mark-certificate___vn",
    path: verified_45mark_45certificate5vxDYAamR1Meta?.path ?? "/vn/verified-mark-certificate",
    meta: verified_45mark_45certificate5vxDYAamR1Meta || {},
    alias: verified_45mark_45certificate5vxDYAamR1Meta?.alias || [],
    redirect: verified_45mark_45certificate5vxDYAamR1Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/verified-mark-certificate.vue").then(m => m.default || m)
  },
  {
    name: verified_45mark_45certificate5vxDYAamR1Meta?.name ?? "verified-mark-certificate___th",
    path: verified_45mark_45certificate5vxDYAamR1Meta?.path ?? "/th/verified-mark-certificate",
    meta: verified_45mark_45certificate5vxDYAamR1Meta || {},
    alias: verified_45mark_45certificate5vxDYAamR1Meta?.alias || [],
    redirect: verified_45mark_45certificate5vxDYAamR1Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/verified-mark-certificate.vue").then(m => m.default || m)
  },
  {
    name: verified_45mark_45certificate5vxDYAamR1Meta?.name ?? "verified-mark-certificate___ru",
    path: verified_45mark_45certificate5vxDYAamR1Meta?.path ?? "/ru/verified-mark-certificate",
    meta: verified_45mark_45certificate5vxDYAamR1Meta || {},
    alias: verified_45mark_45certificate5vxDYAamR1Meta?.alias || [],
    redirect: verified_45mark_45certificate5vxDYAamR1Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/verified-mark-certificate.vue").then(m => m.default || m)
  },
  {
    name: verified_45mark_45certificate5vxDYAamR1Meta?.name ?? "verified-mark-certificate___tr",
    path: verified_45mark_45certificate5vxDYAamR1Meta?.path ?? "/tr/verified-mark-certificate",
    meta: verified_45mark_45certificate5vxDYAamR1Meta || {},
    alias: verified_45mark_45certificate5vxDYAamR1Meta?.alias || [],
    redirect: verified_45mark_45certificate5vxDYAamR1Meta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/verified-mark-certificate.vue").then(m => m.default || m)
  },
  {
    name: whmcsf8FmDsZ0CKMeta?.name ?? "whmcs___en",
    path: whmcsf8FmDsZ0CKMeta?.path ?? "/whmcs",
    meta: whmcsf8FmDsZ0CKMeta || {},
    alias: whmcsf8FmDsZ0CKMeta?.alias || [],
    redirect: whmcsf8FmDsZ0CKMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/whmcs.vue").then(m => m.default || m)
  },
  {
    name: whmcsf8FmDsZ0CKMeta?.name ?? "whmcs___zh-cn",
    path: whmcsf8FmDsZ0CKMeta?.path ?? "/zh-cn/whmcs",
    meta: whmcsf8FmDsZ0CKMeta || {},
    alias: whmcsf8FmDsZ0CKMeta?.alias || [],
    redirect: whmcsf8FmDsZ0CKMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/whmcs.vue").then(m => m.default || m)
  },
  {
    name: whmcsf8FmDsZ0CKMeta?.name ?? "whmcs___zh-tw",
    path: whmcsf8FmDsZ0CKMeta?.path ?? "/zh-tw/whmcs",
    meta: whmcsf8FmDsZ0CKMeta || {},
    alias: whmcsf8FmDsZ0CKMeta?.alias || [],
    redirect: whmcsf8FmDsZ0CKMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/whmcs.vue").then(m => m.default || m)
  },
  {
    name: whmcsf8FmDsZ0CKMeta?.name ?? "whmcs___jp",
    path: whmcsf8FmDsZ0CKMeta?.path ?? "/jp/whmcs",
    meta: whmcsf8FmDsZ0CKMeta || {},
    alias: whmcsf8FmDsZ0CKMeta?.alias || [],
    redirect: whmcsf8FmDsZ0CKMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/whmcs.vue").then(m => m.default || m)
  },
  {
    name: whmcsf8FmDsZ0CKMeta?.name ?? "whmcs___es",
    path: whmcsf8FmDsZ0CKMeta?.path ?? "/es/whmcs",
    meta: whmcsf8FmDsZ0CKMeta || {},
    alias: whmcsf8FmDsZ0CKMeta?.alias || [],
    redirect: whmcsf8FmDsZ0CKMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/whmcs.vue").then(m => m.default || m)
  },
  {
    name: whmcsf8FmDsZ0CKMeta?.name ?? "whmcs___fr",
    path: whmcsf8FmDsZ0CKMeta?.path ?? "/fr/whmcs",
    meta: whmcsf8FmDsZ0CKMeta || {},
    alias: whmcsf8FmDsZ0CKMeta?.alias || [],
    redirect: whmcsf8FmDsZ0CKMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/whmcs.vue").then(m => m.default || m)
  },
  {
    name: whmcsf8FmDsZ0CKMeta?.name ?? "whmcs___de",
    path: whmcsf8FmDsZ0CKMeta?.path ?? "/de/whmcs",
    meta: whmcsf8FmDsZ0CKMeta || {},
    alias: whmcsf8FmDsZ0CKMeta?.alias || [],
    redirect: whmcsf8FmDsZ0CKMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/whmcs.vue").then(m => m.default || m)
  },
  {
    name: whmcsf8FmDsZ0CKMeta?.name ?? "whmcs___kr",
    path: whmcsf8FmDsZ0CKMeta?.path ?? "/kr/whmcs",
    meta: whmcsf8FmDsZ0CKMeta || {},
    alias: whmcsf8FmDsZ0CKMeta?.alias || [],
    redirect: whmcsf8FmDsZ0CKMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/whmcs.vue").then(m => m.default || m)
  },
  {
    name: whmcsf8FmDsZ0CKMeta?.name ?? "whmcs___vn",
    path: whmcsf8FmDsZ0CKMeta?.path ?? "/vn/whmcs",
    meta: whmcsf8FmDsZ0CKMeta || {},
    alias: whmcsf8FmDsZ0CKMeta?.alias || [],
    redirect: whmcsf8FmDsZ0CKMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/whmcs.vue").then(m => m.default || m)
  },
  {
    name: whmcsf8FmDsZ0CKMeta?.name ?? "whmcs___th",
    path: whmcsf8FmDsZ0CKMeta?.path ?? "/th/whmcs",
    meta: whmcsf8FmDsZ0CKMeta || {},
    alias: whmcsf8FmDsZ0CKMeta?.alias || [],
    redirect: whmcsf8FmDsZ0CKMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/whmcs.vue").then(m => m.default || m)
  },
  {
    name: whmcsf8FmDsZ0CKMeta?.name ?? "whmcs___ru",
    path: whmcsf8FmDsZ0CKMeta?.path ?? "/ru/whmcs",
    meta: whmcsf8FmDsZ0CKMeta || {},
    alias: whmcsf8FmDsZ0CKMeta?.alias || [],
    redirect: whmcsf8FmDsZ0CKMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/whmcs.vue").then(m => m.default || m)
  },
  {
    name: whmcsf8FmDsZ0CKMeta?.name ?? "whmcs___tr",
    path: whmcsf8FmDsZ0CKMeta?.path ?? "/tr/whmcs",
    meta: whmcsf8FmDsZ0CKMeta || {},
    alias: whmcsf8FmDsZ0CKMeta?.alias || [],
    redirect: whmcsf8FmDsZ0CKMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/whmcs.vue").then(m => m.default || m)
  },
  {
    name: whois_45lookupZ4YcDKnLqnMeta?.name ?? "whois-lookup___en",
    path: whois_45lookupZ4YcDKnLqnMeta?.path ?? "/whois-lookup",
    meta: whois_45lookupZ4YcDKnLqnMeta || {},
    alias: whois_45lookupZ4YcDKnLqnMeta?.alias || [],
    redirect: whois_45lookupZ4YcDKnLqnMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/whois-lookup.vue").then(m => m.default || m)
  },
  {
    name: whois_45lookupZ4YcDKnLqnMeta?.name ?? "whois-lookup___zh-cn",
    path: whois_45lookupZ4YcDKnLqnMeta?.path ?? "/zh-cn/whois-lookup",
    meta: whois_45lookupZ4YcDKnLqnMeta || {},
    alias: whois_45lookupZ4YcDKnLqnMeta?.alias || [],
    redirect: whois_45lookupZ4YcDKnLqnMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/whois-lookup.vue").then(m => m.default || m)
  },
  {
    name: whois_45lookupZ4YcDKnLqnMeta?.name ?? "whois-lookup___zh-tw",
    path: whois_45lookupZ4YcDKnLqnMeta?.path ?? "/zh-tw/whois-lookup",
    meta: whois_45lookupZ4YcDKnLqnMeta || {},
    alias: whois_45lookupZ4YcDKnLqnMeta?.alias || [],
    redirect: whois_45lookupZ4YcDKnLqnMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/whois-lookup.vue").then(m => m.default || m)
  },
  {
    name: whois_45lookupZ4YcDKnLqnMeta?.name ?? "whois-lookup___jp",
    path: whois_45lookupZ4YcDKnLqnMeta?.path ?? "/jp/whois-lookup",
    meta: whois_45lookupZ4YcDKnLqnMeta || {},
    alias: whois_45lookupZ4YcDKnLqnMeta?.alias || [],
    redirect: whois_45lookupZ4YcDKnLqnMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/whois-lookup.vue").then(m => m.default || m)
  },
  {
    name: whois_45lookupZ4YcDKnLqnMeta?.name ?? "whois-lookup___es",
    path: whois_45lookupZ4YcDKnLqnMeta?.path ?? "/es/whois-lookup",
    meta: whois_45lookupZ4YcDKnLqnMeta || {},
    alias: whois_45lookupZ4YcDKnLqnMeta?.alias || [],
    redirect: whois_45lookupZ4YcDKnLqnMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/whois-lookup.vue").then(m => m.default || m)
  },
  {
    name: whois_45lookupZ4YcDKnLqnMeta?.name ?? "whois-lookup___fr",
    path: whois_45lookupZ4YcDKnLqnMeta?.path ?? "/fr/whois-lookup",
    meta: whois_45lookupZ4YcDKnLqnMeta || {},
    alias: whois_45lookupZ4YcDKnLqnMeta?.alias || [],
    redirect: whois_45lookupZ4YcDKnLqnMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/whois-lookup.vue").then(m => m.default || m)
  },
  {
    name: whois_45lookupZ4YcDKnLqnMeta?.name ?? "whois-lookup___de",
    path: whois_45lookupZ4YcDKnLqnMeta?.path ?? "/de/whois-lookup",
    meta: whois_45lookupZ4YcDKnLqnMeta || {},
    alias: whois_45lookupZ4YcDKnLqnMeta?.alias || [],
    redirect: whois_45lookupZ4YcDKnLqnMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/whois-lookup.vue").then(m => m.default || m)
  },
  {
    name: whois_45lookupZ4YcDKnLqnMeta?.name ?? "whois-lookup___kr",
    path: whois_45lookupZ4YcDKnLqnMeta?.path ?? "/kr/whois-lookup",
    meta: whois_45lookupZ4YcDKnLqnMeta || {},
    alias: whois_45lookupZ4YcDKnLqnMeta?.alias || [],
    redirect: whois_45lookupZ4YcDKnLqnMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/whois-lookup.vue").then(m => m.default || m)
  },
  {
    name: whois_45lookupZ4YcDKnLqnMeta?.name ?? "whois-lookup___vn",
    path: whois_45lookupZ4YcDKnLqnMeta?.path ?? "/vn/whois-lookup",
    meta: whois_45lookupZ4YcDKnLqnMeta || {},
    alias: whois_45lookupZ4YcDKnLqnMeta?.alias || [],
    redirect: whois_45lookupZ4YcDKnLqnMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/whois-lookup.vue").then(m => m.default || m)
  },
  {
    name: whois_45lookupZ4YcDKnLqnMeta?.name ?? "whois-lookup___th",
    path: whois_45lookupZ4YcDKnLqnMeta?.path ?? "/th/whois-lookup",
    meta: whois_45lookupZ4YcDKnLqnMeta || {},
    alias: whois_45lookupZ4YcDKnLqnMeta?.alias || [],
    redirect: whois_45lookupZ4YcDKnLqnMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/whois-lookup.vue").then(m => m.default || m)
  },
  {
    name: whois_45lookupZ4YcDKnLqnMeta?.name ?? "whois-lookup___ru",
    path: whois_45lookupZ4YcDKnLqnMeta?.path ?? "/ru/whois-lookup",
    meta: whois_45lookupZ4YcDKnLqnMeta || {},
    alias: whois_45lookupZ4YcDKnLqnMeta?.alias || [],
    redirect: whois_45lookupZ4YcDKnLqnMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/whois-lookup.vue").then(m => m.default || m)
  },
  {
    name: whois_45lookupZ4YcDKnLqnMeta?.name ?? "whois-lookup___tr",
    path: whois_45lookupZ4YcDKnLqnMeta?.path ?? "/tr/whois-lookup",
    meta: whois_45lookupZ4YcDKnLqnMeta || {},
    alias: whois_45lookupZ4YcDKnLqnMeta?.alias || [],
    redirect: whois_45lookupZ4YcDKnLqnMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/whois-lookup.vue").then(m => m.default || m)
  },
  {
    name: whql9qhG2AF5FsMeta?.name ?? "whql___en",
    path: whql9qhG2AF5FsMeta?.path ?? "/whql",
    meta: whql9qhG2AF5FsMeta || {},
    alias: whql9qhG2AF5FsMeta?.alias || [],
    redirect: whql9qhG2AF5FsMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/whql.vue").then(m => m.default || m)
  },
  {
    name: whql9qhG2AF5FsMeta?.name ?? "whql___zh-cn",
    path: whql9qhG2AF5FsMeta?.path ?? "/zh-cn/whql",
    meta: whql9qhG2AF5FsMeta || {},
    alias: whql9qhG2AF5FsMeta?.alias || [],
    redirect: whql9qhG2AF5FsMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/whql.vue").then(m => m.default || m)
  },
  {
    name: whql9qhG2AF5FsMeta?.name ?? "whql___zh-tw",
    path: whql9qhG2AF5FsMeta?.path ?? "/zh-tw/whql",
    meta: whql9qhG2AF5FsMeta || {},
    alias: whql9qhG2AF5FsMeta?.alias || [],
    redirect: whql9qhG2AF5FsMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/whql.vue").then(m => m.default || m)
  },
  {
    name: whql9qhG2AF5FsMeta?.name ?? "whql___jp",
    path: whql9qhG2AF5FsMeta?.path ?? "/jp/whql",
    meta: whql9qhG2AF5FsMeta || {},
    alias: whql9qhG2AF5FsMeta?.alias || [],
    redirect: whql9qhG2AF5FsMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/whql.vue").then(m => m.default || m)
  },
  {
    name: whql9qhG2AF5FsMeta?.name ?? "whql___es",
    path: whql9qhG2AF5FsMeta?.path ?? "/es/whql",
    meta: whql9qhG2AF5FsMeta || {},
    alias: whql9qhG2AF5FsMeta?.alias || [],
    redirect: whql9qhG2AF5FsMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/whql.vue").then(m => m.default || m)
  },
  {
    name: whql9qhG2AF5FsMeta?.name ?? "whql___fr",
    path: whql9qhG2AF5FsMeta?.path ?? "/fr/whql",
    meta: whql9qhG2AF5FsMeta || {},
    alias: whql9qhG2AF5FsMeta?.alias || [],
    redirect: whql9qhG2AF5FsMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/whql.vue").then(m => m.default || m)
  },
  {
    name: whql9qhG2AF5FsMeta?.name ?? "whql___de",
    path: whql9qhG2AF5FsMeta?.path ?? "/de/whql",
    meta: whql9qhG2AF5FsMeta || {},
    alias: whql9qhG2AF5FsMeta?.alias || [],
    redirect: whql9qhG2AF5FsMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/whql.vue").then(m => m.default || m)
  },
  {
    name: whql9qhG2AF5FsMeta?.name ?? "whql___kr",
    path: whql9qhG2AF5FsMeta?.path ?? "/kr/whql",
    meta: whql9qhG2AF5FsMeta || {},
    alias: whql9qhG2AF5FsMeta?.alias || [],
    redirect: whql9qhG2AF5FsMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/whql.vue").then(m => m.default || m)
  },
  {
    name: whql9qhG2AF5FsMeta?.name ?? "whql___vn",
    path: whql9qhG2AF5FsMeta?.path ?? "/vn/whql",
    meta: whql9qhG2AF5FsMeta || {},
    alias: whql9qhG2AF5FsMeta?.alias || [],
    redirect: whql9qhG2AF5FsMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/whql.vue").then(m => m.default || m)
  },
  {
    name: whql9qhG2AF5FsMeta?.name ?? "whql___th",
    path: whql9qhG2AF5FsMeta?.path ?? "/th/whql",
    meta: whql9qhG2AF5FsMeta || {},
    alias: whql9qhG2AF5FsMeta?.alias || [],
    redirect: whql9qhG2AF5FsMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/whql.vue").then(m => m.default || m)
  },
  {
    name: whql9qhG2AF5FsMeta?.name ?? "whql___ru",
    path: whql9qhG2AF5FsMeta?.path ?? "/ru/whql",
    meta: whql9qhG2AF5FsMeta || {},
    alias: whql9qhG2AF5FsMeta?.alias || [],
    redirect: whql9qhG2AF5FsMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/whql.vue").then(m => m.default || m)
  },
  {
    name: whql9qhG2AF5FsMeta?.name ?? "whql___tr",
    path: whql9qhG2AF5FsMeta?.path ?? "/tr/whql",
    meta: whql9qhG2AF5FsMeta || {},
    alias: whql9qhG2AF5FsMeta?.alias || [],
    redirect: whql9qhG2AF5FsMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/whql.vue").then(m => m.default || m)
  },
  {
    name: why_45nicsrsu5r75lVeIbMeta?.name ?? "why-nicsrs___en",
    path: why_45nicsrsu5r75lVeIbMeta?.path ?? "/why-nicsrs",
    meta: why_45nicsrsu5r75lVeIbMeta || {},
    alias: why_45nicsrsu5r75lVeIbMeta?.alias || [],
    redirect: why_45nicsrsu5r75lVeIbMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/why-nicsrs.vue").then(m => m.default || m)
  },
  {
    name: why_45nicsrsu5r75lVeIbMeta?.name ?? "why-nicsrs___zh-cn",
    path: why_45nicsrsu5r75lVeIbMeta?.path ?? "/zh-cn/why-nicsrs",
    meta: why_45nicsrsu5r75lVeIbMeta || {},
    alias: why_45nicsrsu5r75lVeIbMeta?.alias || [],
    redirect: why_45nicsrsu5r75lVeIbMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/why-nicsrs.vue").then(m => m.default || m)
  },
  {
    name: why_45nicsrsu5r75lVeIbMeta?.name ?? "why-nicsrs___zh-tw",
    path: why_45nicsrsu5r75lVeIbMeta?.path ?? "/zh-tw/why-nicsrs",
    meta: why_45nicsrsu5r75lVeIbMeta || {},
    alias: why_45nicsrsu5r75lVeIbMeta?.alias || [],
    redirect: why_45nicsrsu5r75lVeIbMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/why-nicsrs.vue").then(m => m.default || m)
  },
  {
    name: why_45nicsrsu5r75lVeIbMeta?.name ?? "why-nicsrs___jp",
    path: why_45nicsrsu5r75lVeIbMeta?.path ?? "/jp/why-nicsrs",
    meta: why_45nicsrsu5r75lVeIbMeta || {},
    alias: why_45nicsrsu5r75lVeIbMeta?.alias || [],
    redirect: why_45nicsrsu5r75lVeIbMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/why-nicsrs.vue").then(m => m.default || m)
  },
  {
    name: why_45nicsrsu5r75lVeIbMeta?.name ?? "why-nicsrs___es",
    path: why_45nicsrsu5r75lVeIbMeta?.path ?? "/es/why-nicsrs",
    meta: why_45nicsrsu5r75lVeIbMeta || {},
    alias: why_45nicsrsu5r75lVeIbMeta?.alias || [],
    redirect: why_45nicsrsu5r75lVeIbMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/why-nicsrs.vue").then(m => m.default || m)
  },
  {
    name: why_45nicsrsu5r75lVeIbMeta?.name ?? "why-nicsrs___fr",
    path: why_45nicsrsu5r75lVeIbMeta?.path ?? "/fr/why-nicsrs",
    meta: why_45nicsrsu5r75lVeIbMeta || {},
    alias: why_45nicsrsu5r75lVeIbMeta?.alias || [],
    redirect: why_45nicsrsu5r75lVeIbMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/why-nicsrs.vue").then(m => m.default || m)
  },
  {
    name: why_45nicsrsu5r75lVeIbMeta?.name ?? "why-nicsrs___de",
    path: why_45nicsrsu5r75lVeIbMeta?.path ?? "/de/why-nicsrs",
    meta: why_45nicsrsu5r75lVeIbMeta || {},
    alias: why_45nicsrsu5r75lVeIbMeta?.alias || [],
    redirect: why_45nicsrsu5r75lVeIbMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/why-nicsrs.vue").then(m => m.default || m)
  },
  {
    name: why_45nicsrsu5r75lVeIbMeta?.name ?? "why-nicsrs___kr",
    path: why_45nicsrsu5r75lVeIbMeta?.path ?? "/kr/why-nicsrs",
    meta: why_45nicsrsu5r75lVeIbMeta || {},
    alias: why_45nicsrsu5r75lVeIbMeta?.alias || [],
    redirect: why_45nicsrsu5r75lVeIbMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/why-nicsrs.vue").then(m => m.default || m)
  },
  {
    name: why_45nicsrsu5r75lVeIbMeta?.name ?? "why-nicsrs___vn",
    path: why_45nicsrsu5r75lVeIbMeta?.path ?? "/vn/why-nicsrs",
    meta: why_45nicsrsu5r75lVeIbMeta || {},
    alias: why_45nicsrsu5r75lVeIbMeta?.alias || [],
    redirect: why_45nicsrsu5r75lVeIbMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/why-nicsrs.vue").then(m => m.default || m)
  },
  {
    name: why_45nicsrsu5r75lVeIbMeta?.name ?? "why-nicsrs___th",
    path: why_45nicsrsu5r75lVeIbMeta?.path ?? "/th/why-nicsrs",
    meta: why_45nicsrsu5r75lVeIbMeta || {},
    alias: why_45nicsrsu5r75lVeIbMeta?.alias || [],
    redirect: why_45nicsrsu5r75lVeIbMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/why-nicsrs.vue").then(m => m.default || m)
  },
  {
    name: why_45nicsrsu5r75lVeIbMeta?.name ?? "why-nicsrs___ru",
    path: why_45nicsrsu5r75lVeIbMeta?.path ?? "/ru/why-nicsrs",
    meta: why_45nicsrsu5r75lVeIbMeta || {},
    alias: why_45nicsrsu5r75lVeIbMeta?.alias || [],
    redirect: why_45nicsrsu5r75lVeIbMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/why-nicsrs.vue").then(m => m.default || m)
  },
  {
    name: why_45nicsrsu5r75lVeIbMeta?.name ?? "why-nicsrs___tr",
    path: why_45nicsrsu5r75lVeIbMeta?.path ?? "/tr/why-nicsrs",
    meta: why_45nicsrsu5r75lVeIbMeta || {},
    alias: why_45nicsrsu5r75lVeIbMeta?.alias || [],
    redirect: why_45nicsrsu5r75lVeIbMeta?.redirect || undefined,
    component: () => import("/builds/racent/frontend/website_nicsrs/pages/why-nicsrs.vue").then(m => m.default || m)
  }
]